// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    it: {
        translation: {
            // === NAVBAR (STRINGHE SEMPLICI) ===
            home: 'Home',
            aboutUs: 'Chi Siamo',
            sriLankanav: 'Sri Lanka',
            gallerynav: 'Galleria',
            bookATour: 'Prenota un Tour',
            thingsToDo: 'Cose da Fare', // <-- STRINGA, NON OGGETTO
            contactUs: 'Contattaci',

            // === CONTACT US PAGE ===
            contactUsTitle: 'Contattaci',
            contactUsSubtitle: 'Pick Lanka - La Tua Porta per Avventure Indimenticabili a Sri Lanka',
            feelFreeToContact: 'Contattaci Liberamente',
            planYourDream: 'Pianifica la Tua Avventura da Sogno a Sri Lanka',
            contactDescription: 'Contatta Pick Lanka per pacchetti turistici personalizzati, guida esperta e esperienze di viaggio indimenticabili in tutta Sri Lanka.',
            callCenter: 'Centro Chiamate',
            email: 'Email',
            ourLocation: 'La Nostra Sede',
            socialNetwork: 'Social Network',
            getInTouch: 'Contattaci',
            getInTouchDesc: 'Scopri Sri Lanka con Pick Lanka — siamo qui 24/7 per rendere il tuo viaggio indimenticabile.',
            name: 'Nome',
            emailLabel: 'Email',
            contactNumber: 'Numero di Contatto',
            message: 'Messaggio',
            sendMessage: 'Invia Messaggio',
            sending: 'Invio in corso...',
            successMessage: 'La tua richiesta è stata inviata tramite WhatsApp!',
            errorMessage: 'Impossibile aprire WhatsApp. Riprova.',
            findUsInColombo: 'Trovaci a Colombo',

            footer: {
                pickLankaTitle: "Pick Lanka Tours",
                getInTouch: "Contattaci",
                stayConnected: "Rimani Connesso",
                address: "164, Jambugasmulla Mawatha, Nugegoda, Sri Lanka.",
                email: "info@picklanka.com",
                phone: "+94 77 080 6767",
                newsletterPlaceholder: "Inserisci la tua email",
                newsletterAria: "Email per la newsletter",
                sendButton: "Invia",
                copyright: "Pick Lanka Tours. Tutti i diritti riservati.",
                developedBy: "Progettato e sviluppato da",
                developer: "Redev Solutions (+94 76 460 8225)",

                links: {
                    home: "Home",
                    aboutUs: "Chi Siamo",
                    sriLanka: "Sri Lanka",
                    tourPackages: "Pacchetti Turistici",
                    gallery: "Galleria",
                    events: "Eventi",
                    thingsToDo: "Cose da Fare",
                    contactUs: "Contattaci"
                },

                social: {
                    facebook: "Facebook",
                    instagram: "Instagram",
                    youtube: "YouTube",
                    tiktok: "TikTok"
                }
            },

            // === WILDLIFE SAFARI PAGE (IT) ===
            wildlifeSafariPage: {
                heroTitle: 'Safari Faunistico a Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka, nota per la sua ricca biodiversità, offre incredibili safari faunistici in parchi nazionali come Yala, Wilpattu, Minneriya e Udawalawe. Questi safari offrono l’opportunità di osservare elefanti, leopardi, orsi bradipo e una varietà di specie di uccelli nel loro habitat naturale.',
                    paragraph2: 'Esplora paesaggi diversificati, dalle foreste dense alle praterie aperte, e cattura momenti indimenticabili della fauna in azione. Con guide esperte e jeep safari ben attrezzate, un safari faunistico a Sri Lanka è un must per gli amanti della natura e gli avventurieri.'
                },
                highlights: {
                    title: 'Perché Scegliere un Safari Faunistico?',
                    intro: 'Un safari faunistico a Sri Lanka offre un’opportunità unica per connettersi con la natura ed esplorare la straordinaria biodiversità dell’isola. I punti salienti includono:',
                    list: [
                        'Osservare specie iconiche come elefanti, leopardi e coccodrilli.',
                        'Esplorare foreste lussureggianti, zone umide e pianure aperte brulicanti di fauna.',
                        'Catturare straordinarie fotografie naturalistiche in ambienti naturali.',
                        'Vivere l’emozione di avvistare animali elusivi come il leopardo dello Sri Lanka.',
                        'Imparare sugli sforzi di conservazione da guide esperte e naturalisti.'
                    ]
                },
                images: {
                    main: 'Safari Faunistico a Sri Lanka',
                    elephants: 'Osserva maestosi elefanti che vagano liberamente nei parchi nazionali dello Sri Lanka.',
                    leopard: 'Avvista l’elusivo leopardo dello Sri Lanka, un momento clou di ogni safari faunistico.'
                },
                tips: {
                    title: 'Consigli per un Safari Faunistico Emozionante',
                    list: [
                        'Indossa abbigliamento di colore neutro per mimetizzarti con l’ambiente.',
                        'Porta crema solare, cappello e repellente per insetti per protezione.',
                        'Porta binocolo e fotocamera per avvistare e catturare la fauna.',
                        'Segui le istruzioni della guida per un’esperienza sicura e piacevole.',
                        'Prenota in anticipo, soprattutto durante l’alta stagione, per assicurarti un posto nei parchi più popolari.'
                    ]
                }
            },

            // === WHITE WATER RAFTING PAGE (IT) ===
            whiteWaterRaftingPage: {
                heroTitle: 'Rafting in Acque Bianche a Sri Lanka',
                intro: {
                    paragraph1: 'Il rafting in acque bianche a Sri Lanka è un’esperienza emozionante, soprattutto a Kitulgala, la capitale dell’avventura dell’isola. Il fiume Kelani, con le sue rapide impetuose e i panorami mozzafiato, offre un ambiente perfetto sia per principianti che per rafters esperti.',
                    paragraph2: 'Le spedizioni di rafting coprono generalmente un tratto di 5 chilometri con rapide da Grado 2 a Grado 4. I partecipanti possono godere dell’adrenalina di navigare correnti impegnative mentre ammirano la lussureggiante vegetazione e le viste mozzafiato delle sponde del fiume.'
                },
                highlights: {
                    title: 'Perché Scegliere il Rafting in Acque Bianche a Sri Lanka?',
                    intro: 'Il rafting in acque bianche a Sri Lanka offre una combinazione unica di avventura e bellezza naturale. Ecco alcuni punti salienti dell’esperienza:',
                    list: [
                        'Naviga attraverso rapide emozionanti sotto la guida di istruttori esperti.',
                        'Goditi viste mozzafiato della foresta pluviale circostante e del terreno montuoso.',
                        'Combina il rafting con altre attività come trekking, birdwatching e canyoning a Kitulgala.',
                        'Perfetto per gruppi, famiglie o viaggiatori singoli in cerca di una scarica di adrenalina.'
                    ]
                },
                images: {
                    main: 'Rafting in Acque Bianche a Sri Lanka',
                    action: 'Senti l’adrenalina mentre conquisti le rapide impegnative del fiume Kelani.',
                    scenic: 'Goditi la serena bellezza dei lussureggianti dintorni durante la tua avventura di rafting.'
                },
                tips: {
                    title: 'Consigli per un Viaggio di Rafting Sicuro ed Emozionante',
                    list: [
                        'Indossa il giubbotto di salvataggio e il casco forniti dalla guida per la sicurezza.',
                        'Ascolta attentamente le istruzioni di sicurezza prima di iniziare il viaggio.',
                        'Indossa abbigliamento comodo e ad asciugatura rapida e scarpe sicure come scarpe d’acqua.',
                        'Porta un cambio di vestiti e un asciugamano per dopo il viaggio.',
                        'Prenota il tuo viaggio di rafting con un operatore affidabile per garantire un’esperienza sicura e piacevole.'
                    ]
                }
            },

            // === TEMPLE VISIT PAGE (IT) ===
            templeVisitPage: {
                heroTitle: 'Visita ai Templi a Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka, conosciuta come la Terra del Buddha, ospita antichi templi che riflettono il suo ricco patrimonio spirituale e culturale. Parti per un viaggio alla scoperta di templi iconici come il Tempio del Dente a Kandy, il Tempio delle Grotte di Dambulla e Ruwanwelisaya ad Anuradhapura.',
                    paragraph2: 'Questi luoghi sacri, adornati con intagli intricati, murales e statue, offrono uno sguardo alle tradizioni spirituali e all’eccellenza architettonica dell’isola. Una visita ai templi non è solo un’esperienza culturale, ma anche un’opportunità per trovare pace e tranquillità.'
                },
                highlights: {
                    title: 'Perché Visitare i Templi a Sri Lanka?',
                    intro: 'Visitare i templi a Sri Lanka offre un’opportunità unica per connettersi con la storia, la cultura e la spiritualità dell’isola. Ecco alcuni punti salienti:',
                    list: [
                        'Ammirare l’architettura intricata e le statue secolari.',
                        'Imparare le tradizioni e i rituali buddhisti da guide esperte.',
                        'Esplorare siti Patrimonio UNESCO come il Tempio d’Oro di Dambulla.',
                        'Vivere la serenità e l’atmosfera spirituale degli spazi sacri.',
                        'Assistere a festival vivaci come l’Esala Perahera al Tempio del Dente.'
                    ]
                },
                images: {
                    main: 'Visita ai Templi a Sri Lanka',
                    interior: 'Ammira gli splendidi interni adornati con intagli intricati e murales.',
                    sacred: 'Visita templi sacri come Ruwanwelisaya e immergiti nelle tradizioni spirituali.'
                },
                tips: {
                    title: 'Consigli per Visitare i Templi a Sri Lanka',
                    list: [
                        'Vestiti in modo modesto, coprendo spalle e ginocchia, per rispetto.',
                        'Togliti le scarpe prima di entrare nei locali del tempio.',
                        'Evita di toccare statue o oggetti sacri.',
                        'Porta una piccola donazione per il tempio se desideri contribuire.',
                        'Rispetta il silenzio e l’atmosfera spirituale durante la visita.'
                    ]
                }
            },

            // === TEA TASTING PAGE (IT) ===
            teaTastingPage: {
                heroTitle: 'Tour di Degustazione del Tè a Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka, spesso chiamata la "Perla dell’Oceano Indiano", è famosa per la sua produzione di tè di classe mondiale. Partecipa a un tour di degustazione del tè ed esplora le lussureggianti piantagioni di tè in regioni come Nuwara Eliya, Ella e Kandy. Scopri l’arte della coltivazione del tè, il meticoloso processo di produzione e assapora i ricchi sapori dell’autentico tè di Ceylon.',
                    paragraph2: 'Che tu sia un appassionato di tè o semplicemente curioso, un tour di degustazione del tè offre un’opportunità unica per immergersi nell’eredità del tè dello Sri Lanka e vivere la serena bellezza delle sue alture.'
                },
                highlights: {
                    title: 'Perché Scegliere un Tour di Degustazione del Tè?',
                    intro: 'Un tour di degustazione del tè a Sri Lanka non è solo assaggiare il tè: è un’esperienza culturale immersiva. Ecco alcuni punti salienti:',
                    list: [
                        'Visitare pittoresche piantagioni di tè immerse nelle fresche alture.',
                        'Scoprire la storia e l’importanza del tè di Ceylon.',
                        'Partecipare alla raccolta del tè e osservare il processo di produzione nelle fabbriche.',
                        'Assaporare diverse varietà di tè, dal nero al verde fino a miscele aromatizzate.',
                        'Godersi lo scenario mozzafiato di montagne nebbiose e cascate a strapiombo.'
                    ]
                },
                images: {
                    main: 'Tour di Degustazione del Tè a Sri Lanka',
                    plantation: 'Esplora lussureggianti piantagioni di tè e impara sulla coltivazione del tè.',
                    preparation: 'Scopri l’arte della preparazione del tè e assapora l’autentico tè di Ceylon.'
                },
                tips: {
                    title: 'Consigli per un Tour di Degustazione del Tè Piacevole',
                    list: [
                        'Indossa abbigliamento comodo e scarpe adatte per camminare nelle piantagioni.',
                        'Porta una giacca leggera, poiché le regioni di alta quota possono essere fresche e nebbiose.',
                        'Prova diverse varietà di tè e porta a casa i tuoi preferiti come souvenir.',
                        'Fai domande durante il tour per approfondire il processo di produzione del tè.',
                        'Combina il tuo tour del tè con visite ad attrazioni vicine come cascate e punti panoramici.'
                    ]
                }
            },

            // === SNORKELING PAGE (IT) ===
            snorkelingPage: {
                heroTitle: 'Snorkeling a Sri Lanka',
                intro: {
                    paragraph1: 'Lo snorkeling a Sri Lanka offre un’esperienza subacquea indimenticabile, dove puoi esplorare vibranti barriere coralline e una ricca vita marina. Con le sue acque cristalline e abbondanti ecosistemi acquatici, Sri Lanka è un paradiso per gli amanti dello snorkeling di ogni livello.',
                    paragraph2: 'Alcuni dei luoghi più popolari per lo snorkeling includono Hikkaduwa, famosa per i suoi giardini di corallo colorati e le tartarughe, Pigeon Island a Trincomalee, nota per le sue barriere incontaminate, e Mirissa, dove potresti persino avvistare una balena o due durante la stagione di snorkeling.'
                },
                highlights: {
                    title: 'Perché Scegliere lo Snorkeling a Sri Lanka?',
                    intro: 'Lo snorkeling a Sri Lanka è un’esperienza magica che unisce avventura e bellezza naturale. Ecco alcuni punti salienti:',
                    list: [
                        'Esplorare vibranti barriere coralline brulicanti di vita.',
                        'Nuotare accanto a pesci tropicali colorati, tartarughe e persino squali di scogliera.',
                        'Scoprire paesaggi subacquei incontaminati in acque chiare e calde.',
                        'Adatto sia ai principianti che agli snorkelisti esperti.',
                        'Accessibile da alcune delle migliori destinazioni balneari dello Sri Lanka.'
                    ]
                },
                images: {
                    main: 'Snorkeling a Sri Lanka',
                    coral: 'Scopri splendide barriere coralline e i loro vibranti ecosistemi.',
                    marine: 'Incontra una ricca vita marina, tra cui tartarughe, pesci tropicali e altro ancora.'
                },
                tips: {
                    title: 'Consigli per un’Esperienza di Snorkeling Memorabile',
                    list: [
                        'Indossa una maschera e un boccaglio comodi per una visione chiara sott’acqua.',
                        'Applica una crema solare sicura per la barriera corallina per proteggere la pelle e la vita marina.',
                        'Nuota delicatamente per evitare di disturbare le barriere coralline e le creature acquatiche.',
                        'Rimani idratato e fai pause tra le sessioni.',
                        'Partecipa a un tour guidato per i migliori punti di snorkeling e consigli di sicurezza.'
                    ]
                }
            },

            // === RIVER SAFARI PAGE (IT) ===
            riverSafariPage: {
                heroTitle: 'Safari Fluviale a Sri Lanka',
                intro: {
                    paragraph1: 'Un safari fluviale a Sri Lanka offre un modo unico per esplorare la ricca biodiversità e la bellezza paesaggistica dell’isola. Scivola lungo corsi d’acqua tranquilli circondati da mangrovie lussureggianti, avvista fauna esotica e goditi tramonti pittoreschi che ti lasceranno incantato.',
                    paragraph2: 'Le destinazioni più popolari per i safari fluviali includono il Madu Ganga (fiume Madu) e il fiume Bentota. Questi safari offrono l’opportunità di osservare varie specie di uccelli, varani, coccodrilli e persino scimmie nel loro habitat naturale. L’ambiente sereno è perfetto per gli amanti della natura e i fotografi.'
                },
                highlights: {
                    title: 'Perché Scegliere un Safari Fluviale?',
                    intro: 'Un safari fluviale è un’esperienza rilassante e immersiva che combina natura, fauna e esplorazione culturale. Ecco alcuni punti salienti:',
                    list: [
                        'Esplorare mangrovie lussureggianti brulicanti di vita.',
                        'Avvistare uccelli esotici, coccodrilli e altra fauna.',
                        'Visitare piccole isole e villaggi locali lungo il fiume.',
                        'Godersi la tranquillità e la bellezza pittoresca delle vie d’acqua dello Sri Lanka.',
                        'Perfetto per famiglie, coppie e viaggiatori singoli in cerca di una fuga pacifica.'
                    ]
                },
                images: {
                    main: 'Safari Fluviale a Sri Lanka',
                    mangroves: 'Scopri le lussureggianti mangrovie che costeggiano le vie d’acqua panoramiche dello Sri Lanka.',
                    wildlife: 'Avvista fauna esotica come coccodrilli, varani e uccelli colorati durante il tuo safari.'
                },
                tips: {
                    title: 'Consigli per un Safari Fluviale Piacevole',
                    list: [
                        'Indossa abbigliamento comodo e porta cappello e crema solare per protezione.',
                        'Porta un binocolo per avvistare fauna e uccelli lontani.',
                        'Porta una fotocamera o uno smartphone per catturare paesaggi mozzafiato e fauna.',
                        'Segui le istruzioni della guida per un’esperienza sicura e piacevole.',
                        'Rispetta l’ambiente naturale evitando di gettare rifiuti e disturbare la fauna.'
                    ]
                }
            },

            // === JEEP SAFARI PAGE (IT) ===
            jeepSafariPage: {
                heroTitle: 'Safari in Jeep a Sri Lanka',
                intro: {
                    paragraph1: 'I parchi nazionali dello Sri Lanka offrono un’emozionante esperienza di safari in jeep, permettendoti di esplorare la ricca biodiversità dell’isola e osservare la fauna selvatica nel suo habitat naturale. Il Parco Nazionale di Yala, Wilpattu e Udawalawe sono tra le destinazioni più popolari per i safari in jeep.',
                    paragraph2: 'Questi safari offrono l’opportunità di vedere elefanti, leopardi, orsi bradipo, bufali d’acqua, coccodrilli e una vasta varietà di specie di uccelli. Guidati da naturalisti esperti e tracciatori, i safari in jeep sono perfetti per gli appassionati di fauna e fotografi.'
                },
                highlights: {
                    title: 'Perché Scegliere un Safari in Jeep?',
                    intro: 'I safari in jeep sono uno dei modi migliori per esplorare la variegata fauna selvatica dello Sri Lanka. Ecco alcuni punti salienti:',
                    list: [
                        'Incontri ravvicinati con specie iconiche come elefanti e leopardi.',
                        'Accesso a zone remote e panoramiche all’interno dei parchi nazionali.',
                        'Opportunità per la fotografia naturalistica in un ambiente autentico.',
                        'Guida da parte di naturalisti esperti e ranger del parco.',
                        'Un’avventura adatta a tutte le età, che combina emozione ed educazione.'
                    ]
                },
                images: {
                    main: 'Safari in Jeep a Sri Lanka',
                    wildlife: 'Osserva fauna iconica come leopardi, elefanti e coccodrilli durante il tuo safari.',
                    landscape: 'Esplora gli splendidi paesaggi dei parchi nazionali dello Sri Lanka, dalle foreste dense alle pianure aperte.'
                },
                tips: {
                    title: 'Consigli per un Safari in Jeep Piacevole',
                    list: [
                        'Indossa abbigliamento comodo e di colore neutro per mimetizzarti con l’ambiente.',
                        'Porta crema solare, cappello e repellente per insetti per protezione.',
                        'Porta binocolo e fotocamera per migliorare l’esperienza e catturare la fauna.',
                        'Segui le istruzioni della guida per garantire sicurezza e rispetto per gli animali.',
                        'Prenota il tuo safari in anticipo, soprattutto durante l’alta stagione, per assicurarti un posto.'
                    ]
                }
            },

            // === FISHING PAGE (IT) ===
            fishingPage: {
                heroTitle: 'Pesca a Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka, con la sua vasta costa e l’abbondanza di laghi e fiumi d’acqua dolce, offre un’esperienza di pesca senza pari. Che tu sia un pescatore professionista o un hobbista, Sri Lanka ha qualcosa da offrire. Dalle spedizioni di pesca d’altura alla tradizionale pesca sui trampoli praticata dai pescatori locali, vivrai un’avventura indimenticabile.',
                    paragraph2: 'Le destinazioni di pesca più popolari includono la costa meridionale intorno a Galle e Mirissa, la laguna di Negombo e le calme acque di Trincomalee. A seconda delle tue preferenze, puoi provare diverse tecniche di pesca come il trolling, la pesca di fondo o la pesca a mosca.'
                },
                experiences: {
                    title: 'Esperienze di Pesca a Sri Lanka',
                    intro: 'La pesca a Sri Lanka non è solo catturare pesci; è un’opportunità per immergersi nella cultura e nelle tradizioni dell’isola. Alcune esperienze uniche di pesca includono:',
                    list: [
                        { title: 'Pesca sui Trampoli', description: 'Un metodo tradizionale in cui i pescatori si appollaiano sui trampoli per pescare vicino alla riva, una pratica unica dello Sri Lanka.' },
                        { title: 'Pesca d’Altura', description: 'Avventurati nell’Oceano Indiano per catturare marlin, tonni, barracuda e altre grandi specie di pesci.' },
                        { title: 'Pesca in Laguna e Fiume', description: 'Rilassati pescando in lagune serene e fiumi ricchi di pesci come tilapia e pesce gatto.' },
                        { title: 'Pesca Notturna', description: 'Prova l’emozione di pescare sotto le stelle, una pratica comune nei villaggi costieri.' }
                    ]
                },
                images: {
                    main: 'Pesca a Sri Lanka',
                    stilt: 'La pesca sui trampoli è un metodo tradizionale e un’immagine iconica del patrimonio peschereccio dello Sri Lanka.',
                    deepSea: 'La pesca d’altura offre un’esperienza avventurosa, mirando a grandi specie di pesci nell’Oceano Indiano.'
                },
                tips: {
                    title: 'Consigli per un Viaggio di Pesca Piacevole',
                    list: [
                        'Scegli la stagione giusta per la tua spedizione di pesca; ottobre-aprile è ideale per la costa meridionale, mentre marzo-ottobre è adatto alla costa orientale.',
                        'Porta crema solare, cappello e abbigliamento protettivo per stare comodo durante il viaggio.',
                        'Prenota una guida di pesca o un charter per sfruttare al massimo l’esperienza e imparare dagli esperti.',
                        'Rispetta l’ambiente locale evitando di gettare rifiuti e seguendo pratiche di pesca sostenibili.',
                        'Rimani idratato e porta snack per viaggi di pesca più lunghi.'
                    ]
                }
            },

            // === ELEPHANT RIDE PAGE (IT) ===
            elephantRidePage: {
                heroTitle: 'Passeggiata a Dorso di Elefante',
                intro: {
                    paragraph1: 'Il trekking sugli elefanti è un’attività affascinante, emozionante e un’esperienza unica a Sri Lanka. Se soggiorni vicino al triangolo culturale in zone come Habarana, Sigiriya o Dambulla, puoi partecipare a un safari sugli elefanti. Queste escursioni partono da circa $30 per un’ora di avventura indimenticabile.',
                    paragraph2: 'Prima della passeggiata, gli elefanti vengono sellati con un cestello multiplo progettato per 4-6 persone. Questi giganti gentili ti portano attraverso sentieri panoramici nella giungla, attraversano aree allagate e si muovono tra la vegetazione lussureggiante. Gli elefanti camminano lentamente, permettendoti di apprezzare appieno la bellezza della natura circostante, anche se possono raggiungere velocità fino a 40 km/h.'
                },
                highlights: {
                    title: 'Punti Salienti di una Passeggiata sugli Elefanti',
                    intro: 'Cavalcare un elefante a Sri Lanka offre un modo unico per connettersi con la natura ed esplorare la campagna. Alcuni momenti salienti dell’esperienza includono:',
                    list: [
                        'Camminare attraverso giungle dense piene di vegetazione esotica e fauna selvatica.',
                        'Attraversare fiumi e zone allagate, offrendo viste mozzafiato del paesaggio naturale.',
                        'Scoprire il profondo legame tra gli elefanti e la cultura dello Sri Lanka.',
                        'Rilassarsi su una sella comoda mentre l’elefante ti trasporta dolcemente su vari terreni.'
                    ]
                },
                images: {
                    main: 'Passeggiata a Dorso di Elefante',
                    jungle: 'Esplora giungle dense e sentieri panoramici cavalcando un elefante.',
                    water: 'Attraversa fiumi e goditi la bellezza tranquilla dell’acqua e della vegetazione.'
                },
                tips: {
                    title: 'Consigli per una Passeggiata Sicura e Piacevole sugli Elefanti',
                    list: [
                        'Indossa abbigliamento comodo e calzature adatte alle attività all’aperto.',
                        'Segui le istruzioni della guida per una passeggiata sicura e piacevole.',
                        'Assicurati che gli elefanti siano trattati bene e che il fornitore segua pratiche etiche.',
                        'Porta una fotocamera per catturare paesaggi mozzafiato e momenti speciali.',
                        'Rispetta gli elefanti ed evita azioni che potrebbero stressarli o ferirli.'
                    ]
                }
            },

            // === DIVING PAGE (IT) ===
            divingPage: {
                heroTitle: 'Immersioni a Sri Lanka',
                intro: {
                    paragraph1: 'Una vasta barriera corallina circonda la costa dello Sri Lanka a profondità comprese tra 2 e 40 metri. Le calde acque dell’Oceano Indiano, tra 27°C e 30°C, e l’alta trasparenza dell’acqua, da 15 a 35 metri, offrono condizioni eccellenti per immersioni e snorkeling. Durante le immersioni a Sri Lanka, potrai esplorare infinite barriere coralline intatte, antichi relitti e affascinanti grotte sottomarine.',
                    paragraph2: 'Il nord-est dell’isola offre una varietà di oltre 130 specie di coralli colorati, che ospitano una ricca vita marina come tartarughe marine, pesci pagliaccio, pesci leone e cavallucci marini. Visita i relitti vicino a scogliere e barriere sottomarine per un’esperienza indimenticabile. Fluttuando nelle acque limpide, ti immergerai nel passato affascinante di Ceylon.'
                },
                facilities: {
                    title: 'Strutture e Migliori Punti di Immersione',
                    paragraph1: 'I centri immersione dell’isola sono equipaggiati con attrezzature moderne di produttori rinomati. Istruttori certificati PADI e CMAS garantiscono immersioni sicure e piacevoli. I centri si trovano lungo la costa sud-occidentale, operativi da metà ottobre a fine aprile. La costa nord-orientale, inclusi Nilaveli e Trincomalee, è ideale per immersioni da marzo a ottobre.',
                    paragraph2: 'Le barriere coralline vicino a Kalpitiya a ovest e i siti di immersione sui relitti a Hikkaduwa sono tra le attrazioni più popolari per i subacquei.'
                },
                images: {
                    main: 'Immersioni a Sri Lanka',
                    coral: 'Esplora vibranti barriere coralline ricche di vita marina.',
                    shipwreck: 'Scopri antichi relitti che offrono uno sguardo sul passato marittimo dello Sri Lanka.'
                },
                tips: {
                    title: 'Consigli per i Subacquei',
                    list: [
                        'Scegli la stagione migliore in base alla località: costa sud-ovest (ottobre-aprile) o costa nord-est (marzo-ottobre).',
                        'Assicurati che il centro immersioni sia certificato e dotato di attrezzature moderne per un’esperienza sicura.',
                        'Ascolta i consigli dell’istruttore, soprattutto se sei un principiante.',
                        'Rispetta la vita marina evitando di toccare i coralli o disturbare l’ambiente sottomarino.',
                        'Porta una fotocamera subacquea per catturare la bellezza mozzafiato del mondo sottomarino dello Sri Lanka.'
                    ]
                }
            },

            // === BALLOONING PAGE (IT) ===
            ballooningPage: {
                heroTitle: 'Mongolfiera a Sri Lanka',
                intro: {
                    paragraph1: 'La mongolfiera a Sri Lanka offre un’esperienza indimenticabile di fluttuare dolcemente sopra i paesaggi mozzafiato dell’isola. Partendo all’alba, i voli in mongolfiera regalano viste aeree mozzafiato di colline ondulate, foreste lussureggianti, rovine antiche e villaggi sereni.',
                    paragraph2: 'La destinazione più popolare per la mongolfiera a Sri Lanka è Dambulla, situata nel cuore del triangolo culturale. I voli qui spesso sorvolano la celebre Rocca di Sigiriya, offrendo una prospettiva unica. I voli durano generalmente 60-90 minuti, dando ampio tempo per immergersi nella bellezza dello Sri Lanka dall’alto.'
                },
                highlights: {
                    title: 'Perché Provare la Mongolfiera a Sri Lanka?',
                    intro: 'La mongolfiera unisce avventura e tranquillità, permettendo di vivere la bellezza dello Sri Lanka in modo unico. Alcuni punti salienti includono:',
                    list: [
                        'Vedute panoramiche ininterrotte dei paesaggi mozzafiato dell’isola.',
                        'Sorvolare monumenti iconici come la Rocca di Sigiriya e i laghi vicini.',
                        'Un volo sereno e pacifico sopra la vegetazione lussureggiante e i villaggi affascinanti.',
                        'Assistere a un’alba spettacolare dal cielo.',
                        'Perfetto per gli appassionati di fotografia che desiderano catturare la bellezza scenica dall’alto.'
                    ]
                },
                images: {
                    main: 'Mongolfiera a Sri Lanka',
                    sunrise: 'Alba in Mongolfiera',
                    landscape: 'Paesaggi dallo Sri Lanka'
                },
                tips: {
                    title: 'Consigli per un Volo in Mongolfiera Memorabile',
                    list: [
                        'Prenota il tuo volo con anticipo, poiché la mongolfiera dipende dal meteo e i posti si esauriscono rapidamente.',
                        'Indossa abiti comodi e porta una giacca leggera, le mattine presto possono essere fresche.',
                        'Porta una fotocamera o uno smartphone per catturare le viste mozzafiato.',
                        'Ascolta attentamente le istruzioni di sicurezza fornite dal pilota.',
                        'Arriva in orario per osservare la preparazione e il gonfiaggio della mongolfiera, un processo affascinante.'
                    ]
                }
            },

            // === AYURVEDA PAGE (IT) ===
            ayurvedaPage: {
                pageTitle: 'Ayurveda - L’Antica Scienza della Vita',
                heroTitle: 'Ayurveda - L’Antica Scienza della Vita',
                intro: {
                    paragraph1: 'La parola “Ayurveda” esiste da più di tremila anni. In sanscrito significa “scienza della vita”. La tecnica si basa sulla visione ayurvedica della malattia piuttosto che sulle sue conseguenze, che di solito combatte la medicina europea. Postula i seguenti principi:',
                    principlesTitle: 'Principi Fondamentali',
                    principles: [
                        'Il corpo deve essere libero di energia e mantenere l’equilibrio per un’attività metabolica e cardiaca normale.',
                        'Il corpo deve avere una contrazione muscolare normale con attività ormonale regolare.',
                        'Il corpo ha bisogno di un sistema immunitario sano per funzionare correttamente.'
                    ],
                    paragraph2: 'Secondo dati recenti, in Sri Lanka ci sono più di 6.000 laureati formati in Ayurveda. Frequentano sette anni di studio e due anni di pratica negli ospedali pubblici. I programmi di Ayurveda includono:'
                },
                benefits: [
                    'Rimozione di stress, affaticamento e ansia',
                    'Saturazione di ossigeno',
                    'Stimolazione dei sistemi muscolari ed eliminazione delle tossine',
                    'Ripristino dell’equilibrio del sistema nervoso',
                    'Ripristino del flusso sanguigno agli organi interni',
                    'Produzione di endorfine'
                ],
                treatments: {
                    description: 'I trattamenti standard includono massaggi al corpo e alla testa con oli speciali, trattamenti con sauna alle erbe e bagni infusi con erbe. La tecnica più popolare è la procedura “Shirodhara”, in cui olio caldo alle erbe viene fatto gocciolare ritmicamente sulla fronte. Questo aiuta a ripristinare l’equilibrio del sistema nervoso e a raggiungere il rilassamento.'
                },
                tips: {
                    title: 'Consigli per il Trattamento Ayurvedico',
                    list: [
                        'Dimentica i problemi. Rilassati e svuota la mente per ottenere i migliori risultati.',
                        'Scegli la location giusta. Seleziona un ambiente che si allinea con il tuo comfort e preferenze per una guarigione ottimale.',
                        'Scegli il programma corretto. Discuti le tue preoccupazioni con il medico e prova diverse terapie per trovare quella più adatta a te.',
                        'Fai un bagno caldo prima del trattamento per rilassare i muscoli e preparare il corpo.',
                        'Mangia un pasto leggero prima della procedura. Evita pasti pesanti per permettere un corretto flusso sanguigno durante il massaggio.',
                        'Il rilassamento dopo le procedure è essenziale. Un adeguato rilassamento aumenta l’efficacia dei trattamenti ayurvedici.'
                    ]
                },
                images: {
                    main: 'Ayurveda',
                    face: 'Trattamento Viso Ayurveda',
                    massage: 'Trattamento Massaggio Ayurveda'
                }
            },

            hero: {
                title: "Scopri lo Sri Lanka con Pick Lanka Tours",
                subtitle: "Il tuo partner fidato per viaggi culturali autentici, safari nella natura e avventure indimenticabili sull’isola.",
                cta: "Esplora i Tour",
                videoFallback: "Il tuo browser non supporta il tag video."
            },

            // === SECTIONS ===
            sections: {
                recommendations: {
                    title: "Raccomandazioni Destinazioni",
                    subtitle: "Confuso? Ecco i nostri consigli"
                },
                excursions: {
                    title: "Le Nostre Escursioni",
                    description: "Viaggi su più giorni su misura in Sri Lanka — da immersioni culturali ad avventure nella natura."
                },
                packages: { title: "I Nostri Pacchetti" },
                reviews: {
                    title: "Cosa Dicono i Nostri Ospiti",
                    subtitle: "Esperienze reali di viaggiatori che hanno esplorato lo Sri Lanka con noi"
                },
                crafting: {
                    title: "Pick Lanka Tours – Creiamo il Tuo Viaggio Perfetto",
                    description: "Esplora lo Sri Lanka con Pick Lanka Tours — ogni viaggio è progettato con cura, unendo cultura, avventura e relax per ricordi indimenticabili."
                }
            },

            // === BUTTONS ===
            buttons: {
                viewAll: "Vedi Tutti",
                bookNow: "Prenota Ora",
                contactUs: "Contattaci"
            },

            // === RECOMMENDATIONS ===
            recommendations: {
                sigiriya: { label: "Sigiriya", name: "Fortezza del Leone con vista mozzafiato." },
                udawalawa: { label: "Udawalawa", name: "Famoso per safari con elefanti selvatici." },
                ella: { label: "Ella", name: "Vista collinare e viaggi in treno panoramici." },
                mirissa: { label: "Mirissa", name: "Paradiso balneare e avvistamento balene." },
                nuwaraeliya: { label: "Nuwara Eliya", name: "Paese del tè con fascino coloniale." },
                kandy: { label: "Kandy", name: "Capitale culturale con il Tempio della Sacra Reliquia del Dente." },
                galle: { label: "Galle", name: "Città fortificata storica sull’oceano." },
                jaffna: { label: "Jaffna", name: "Melting pot culturale con ricca storia." },
                anuradhapura: { label: "Anuradhapura", name: "Città antica piena di siti sacri." },
                polonnaruwa: { label: "Polonnaruwa", name: "Rovine storiche dei re dello Sri Lanka antico." }
            },

            // === EXCURSIONS ===
            excursions: {
                classic7: {
                    title: "7 Giorni / 6 Notti – Tour Classico",
                    des: "Scopri i punti salienti dello Sri Lanka, da Kandy alla costa meridionale, in un viaggio equilibrato di una settimana."
                },
                northern11: {
                    title: "11 Giorni / 10 Notti – Tour del Nord",
                    des: "Esplora le meraviglie del nord dello Sri Lanka, tra Jaffna, Anuradhapura e tesori culturali intatti."
                },
                meditation9: {
                    title: "9 Giorni / 8 Notti – Tour Meditazione",
                    des: "Ritrova la pace interiore tra templi sereni, ritiri di meditazione ed escursioni nella natura."
                },
                classic9: {
                    title: "9 Giorni / 8 Notti – Tour Classico",
                    des: "Vivi paesaggi diversi e la ricca cultura dello Sri Lanka in un’avventura di nove giorni adatta a tutti."
                }
            },

            // === PACKAGES ===
            packages: {
                classic7: {
                    title: "7 Giorni / 6 Notti: Tour Classico",
                    duration: "7 Giorni",
                    description: "Scopri i punti salienti iconici dello Sri Lanka — città antiche, colline del tè e monumenti culturali — perfetto per i primi viaggiatori.",
                    category: "Cultura & Patrimonio"
                },
                northern11: {
                    title: "11 Giorni / 10 Notti: Tour del Nord",
                    duration: "11 Giorni",
                    description: "Scopri i tesori nascosti del nord dello Sri Lanka — Jaffna, Mannar e Trincomalee — dove storia incontra bellezza incontaminata.",
                    category: "Avventura & Scoperta"
                },
                meditation9: {
                    title: "9 Giorni / 8 Notti: Tour Meditazione",
                    duration: "9 Giorni",
                    description: "Un viaggio spirituale pacifico tra templi e monasteri sacri dello Sri Lanka, pensato per relax e mindfulness.",
                    category: "Spiritualità & Benessere"
                },
                classic9: {
                    title: "9 Giorni / 8 Notti: Tour Classico",
                    duration: "9 Giorni",
                    description: "Un’avventura culturale estesa — esplora Kandy, Sigiriya e Galle godendo di tradizioni locali autentiche e cucina.",
                    category: "Cultura & Natura"
                }
            },

            // === FEATURED EXPERIENCES ===
            featured: {
                perahera: {
                    h2: "E se andassi a",
                    h3: "Kandy Esala Perahera",
                    h4: "(Il Festival del Dente)",
                    paragraph: `Uno dei più grandi e antichi festival buddisti dell'Asia, che si tiene ogni anno a Kandy, Sri Lanka. La celebrazione è dedicata all'onore della Sacra Reliquia del Dente di Buddha, conservata nel Tempio del Dente (Dalada Maligawa) Vivi questa celebrazione spettacolare con <strong class="text-[#009CE6]">Pick Lanka Sri Lankan Tours</strong> — dove fede, cultura e colore si uniscono in un viaggio indimenticabile.`,
                    button: "Scopri di Più"
                },
                safari: {
                    h2: "Sri Lanka",
                    h3: "Avventure Safari",
                    paragraph: `Lo Sri Lanka è uno dei migliori posti in Asia per safari indimenticabili nella natura. Dalle praterie aperte di <span class="text-[#96BA33] font-semibold">Yala</span> e <span class="text-[#96BA33] font-semibold">Udawalawa</span> alle zone umide serene di <span class="text-[#96BA33] font-semibold">Wilpattu</span>, ogni parco offre incontri emozionanti con elefanti, leopardi, coccodrilli e uccelli esotici. Parti per un viaggio emozionante con <strong class="text-[#009CE6]">Pick Lanka Sri Lankan Tours</strong> — dove ogni safari è una nuova storia di avventura, natura e scoperta.`,
                    button: "Scopri di Più"
                },
            },

            // === ABOUT PAGE (IT) ===
            about: {
                hero: {
                    explore: 'ESPLORA',
                    pickLanka: 'PICK LANKA',
                    text1: 'Dagli antichi regni ai rigogliosi giardini di tè e ai safari selvatici,l’isola è viva di meraviglia.Sri Lanka non è solo una destinazione — è un viaggio del cuore.',
                    text2: 'Sri Lanka ti accoglie con spiagge dorate, montagne nebbiose e avventure senza fine.Qui, ogni sentiero porta alla bellezza e ogni momento diventa un ricordo.',
                },
                sectionTitle: 'About Pick Lanka',
                signatureTour: {
                    title: 'Tour Signature Sri Lanka',
                    images: {
                        0: 'Colombo',
                        1: 'Kandy',
                        2: 'Nuwara Eliya',
                        3: 'Ella',
                        4: 'Yala',
                        5: 'Galle',
                    },
                    labels: {
                        0: { days: '7 giorni', title: 'TOUR CLASSICO' },
                        1: { days: '10/11 giorni', title: 'Tour del Nord' },
                        2: { days: '8/9 giorni', title: 'Tour Meditazione' },
                    },
                    desc1: 'Con Pick Lanka Sri Lankan Tours, esplora ogni provincia di questa splendida isola.Dalle città vibranti alle colline nebbiose e alle spiagge dorate — ti portiamo ovunque.',
                    desc2: 'Scopri il meglio dello Sri Lanka con noi — dal cuore culturale di Kandy alle vivaci strade di Colombo e alla spettacolare Costa Meridionale.',
                    desc3: 'Che tu cerchi avventura, cultura, fauna o relax, Pick Lanka Sri Lankan Tours offre viaggi indimenticabili in tutta l’isola — tutto l’anno.',
                },
                whoWeAre: {
                    title: 'Chi Siamo?',
                    description: 'Benvenuto a Pick Lanka Sri Lankan Tours — il tuo fidato compagno di viaggio in ogni provincia dello Sri Lanka. Il nostro team locale dedicato è appassionato nel creare viaggi che vanno oltre il semplice turismo — aiutandoti a scoprire la ricca cultura dell’isola, l’ospitalità calorosa e la bellezza naturale indimenticabile.',
                    imageAlt: 'Chi Siamo',
                    0: { title: 'Tour in Tutta l’Isola', description: 'Pick Lanka Sri Lankan Tours opera in tutte le province — dal Nord al profondo Sud, offrendo esperienze locali autentiche ovunque.' },
                    1: { title: 'Esperienze Personalizzate', description: 'Ogni tour è su misura per i tuoi interessi — avventura, cultura, natura o relax.' },
                    2: { title: 'Competenza Locale Affidabile', description: 'Le nostre guide esperte condividono veri approfondimenti sui tesori nascosti dello Sri Lanka, le tradizioni e lo stile di vita.' },
                    3: { title: 'Assistenza Viaggio 24/7', description: 'Con Pick Lanka non sei mai solo — il nostro team di supporto amichevole è disponibile 24 ore su 24 per aiutarti durante il tuo viaggio.' },
                },
                whatWeOffer: {
                    title: 'Cosa Offriamo',
                    0: { title: 'Immersione Culturale', description: 'Vivi tradizioni autentiche, festival e vita locale.' },
                    1: { title: 'Tour Avventura', description: 'Escursioni, safari, surf e attività all’aperto emozionanti.' },
                    2: { title: 'Lusso & Comfort', description: 'Soggiorni premium, trasferimenti privati ed esperienze VIP.' },
                    3: { title: 'Ritiri Benessere', description: 'Yoga, Ayurveda e rigenerazione in ambientazioni serene.' },
                },
                heroSlider: [
                    'Rocca di Sigiriya',
                    'Safari a Yala',
                    'Piantagioni di Tè',
                    'Spiagge Dorate',
                    'Templi Antichi',
                ],
                ourGuides: {
                    title: 'Le Nostre Guide',
                    description: 'Il nostro team di guide professionali e autorizzate è il cuore di ogni viaggio. Amichevoli, competenti e appassionate dello Sri Lanka, vanno oltre il semplice mostrare luoghi — condividono storie, tradizioni e gemme nascoste che portano l’isola in vita.',
                    imageAlt: 'Le Nostre Guide',
                },
                tourExpert: {
                    name: 'competenti e cordiali',
                    role: '(Guide esperte)',
                    description: 'Con oltre 12 anni di esperienza come guida turistica autorizzata, questo esperto è appassionato nel mostrare la vera bellezza dello Sri Lanka. Dalle spiagge mozzafiato alle colline verdeggianti, dai safari emozionanti alle avventure panoramiche, la sua competenza garantisce che ogni viaggiatore possa vivere il meglio dell’isola — nello stile unico di Pick Lanka.',
                    imageAlt: 'Esperto di Tour',
                },
                vehicles: {
                    title: 'Quali Veicoli Usiamo',
                    description: 'A Pick Lanka, la tua sicurezza e comfort sono la priorità. Forniamo veicoli affidabili, climatizzati e ben mantenuti per garantire che ogni viaggio attraverso lo Sri Lanka sia fluido e piacevole.',
                    bookNow: 'Prenota Ora',
                    arrowAlt: 'Freccia',
                    van: { type: 'Van', description: 'Ideale per famiglie o piccoli gruppi (fino a 6 passeggeri). Spazioso, comodo e perfetto per lunghi tragitti.' },
                    minibus: { type: 'Minibus', description: 'Perfetto per gruppi più grandi (8–12 passeggeri). Sedili comodi e ampio spazio bagagli.' },
                    luxury: { type: 'Lusso', description: 'Veicoli premium con sedili in pelle, Wi-Fi e servizio autista per viaggi VIP.' },
                    car: { type: 'Auto', description: 'Ideale per viaggi individuali o coppie. Comfort e stile per esplorare lo Sri Lanka in modo indipendente.' },
                },
            },

            // === SRI LANKA PAGE (IT) ===
            sriLanka: {
                heroTitle: 'Scopri lo Sri Lanka',
                heroSubtitle: 'Perla dell’Oceano Indiano',
                heroAlt: 'Sri Lanka',
                introImageAlt: 'Mappa dello Sri Lanka con le città principali',
                intro: [
                    'Lo Sri Lanka, noto come "Isola di Smeraldo", è un gioiello tropicale celebrato per i suoi paesaggi mozzafiato, il ricco patrimonio antico e l’ospitalità sincera.',
                    'Con una storia di oltre due millenni, lo Sri Lanka ospita siti UNESCO come la fortezza di Sigiriya e la città sacra di Anuradhapura. La sua ricchezza culturale unisce influenze buddiste, hindu e coloniali, visibili nei festival vivaci e nell’architettura intricata.',
                    'Il territorio vario dell’isola affascina: dalle piantagioni di tè di Ella alle acque turchesi di Trincomalee. I parchi nazionali come Wilpattu ospitano leopardi, coccodrilli e rare specie di uccelli, deliziando gli amanti della natura.',
                    'Per gli avventurosi, lo Sri Lanka offre rafting, surf ad Arugam Bay e trekking in giungle lussureggianti. La sua cucina, infusa di spezie aromatiche, pesce fresco e jackfruit, racconta una storia di tradizione e sapore.',
                    'Dalle pellegrinaggi sacri alle fughe in spiaggia serene, lo Sri Lanka promette un’esperienza incantevole immersa in bellezza e cultura.'
                ],
                placesTitle: 'Luoghi Attrattivi in Sri Lanka',
                viewMore: 'Scopri di Più',
                closeModal: 'Chiudi',
                fullImageAlt: 'Anteprima completa',
                places: {
                    list: {
                        0: { name: 'Rocca di Sigiriya', desc: 'Patrimonio UNESCO, con giardini antichi, affreschi e vista mozzafiato dalla cima.' },
                        1: { name: 'Tempio del Dente Sacro', desc: 'Sito buddista sacro che custodisce una reliquia del dente di Buddha.' },
                        2: { name: 'Ella', desc: 'Cittadina circondata da piantagioni di tè, famosa per il Ponte dei Nove Archi.' },
                        3: { name: 'Parco Nazionale di Yala', desc: 'Rinomato per elefanti, leopardi e safari naturalistici.' },
                        4: { name: 'Forte di Galle', desc: 'Sito coloniale con stradine acciottolate e architettura olandese.' },
                        5: { name: 'Nuwara Eliya', desc: 'Conosciuta come "Piccola Inghilterra", con clima fresco e piantagioni di tè.' },
                        6: { name: 'Picco di Adamo', desc: 'Montagna sacra con un’impronta unica in cima, meta di pellegrinaggio.' },
                        7: { name: 'Pianure di Horton', desc: 'Con colline, cascate e il famoso punto panoramico World’s End.' },
                        8: { name: 'Spiaggia di Bentota', desc: 'Destinazione costiera con sabbia dorata e sport acquatici.' },
                        9: { name: 'Jaffna', desc: 'Ricca di cultura Tamil, siti storici e cucina deliziosa.' },
                        10: { name: 'Anuradhapura', desc: 'Antica città con siti buddisti sacri e rovine storiche.' },
                        11: { name: 'Polonnaruwa', desc: 'Patrimonio UNESCO con templi e statue ben conservati.' },
                        12: { name: 'Spiaggia di Unawatuna', desc: 'Vibrante destinazione costiera con snorkeling e vita notturna.' },
                        13: { name: 'Colombo', desc: 'Capitale vivace con grattacieli moderni e mercati tradizionali.' },
                        14: { name: 'Parco Nazionale di Udawalawe', desc: 'Famoso per grandi branchi di elefanti e paesaggi mozzafiato.' },
                        15: { name: 'Tempio delle Grotte di Dambulla', desc: 'Patrimonio UNESCO con murales e statue buddiste antiche.' },
                    },
                },
                famousTitle: 'Cose Famose in Sri Lanka',
                famous: {
                    list: {
                        0: { title: 'Tè di Ceylon', desc: 'Famoso per il suo sapore unico, soprattutto da Nuwara Eliya e Uva.' },
                        1: { title: 'Spezie', desc: 'Cannella, cardamomo, chiodi di garofano — la cannella dello Sri Lanka è la migliore al mondo.' },
                        2: { title: 'Gemme', desc: 'Zaffiri, rubini e pietre lunari — l’isola è famosa per le sue gemme rare.' },
                        3: { title: 'Ayurveda', desc: 'Trattamenti benessere con massaggi e terapie alle erbe.' },
                        4: { title: 'Artigianato', desc: 'Maschere, batik, intagli in legno e lacca.' },
                        5: { title: 'Elefanti', desc: 'Simbolo culturale, presenti in festival come l’Esala Perahera.' },
                        6: { title: 'Cucina Tradizionale', desc: 'Riso e curry, hoppers, kottu roti e wattalappam.' },
                        7: { title: 'Festival', desc: 'Esala Perahera, Vesak e Capodanno Sinhala-Tamil.' },
                        8: { title: 'Prodotti di Cocco', desc: 'Olio, latte e fibra di cocco per corde e tappeti.' },
                        9: { title: 'Saree Kandyan', desc: 'Abito tradizionale elegante per cerimonie.' },
                        10: { title: 'Danze Tradizionali', desc: 'Danze Kandyan, danze del diavolo e danze basse.' },
                        11: { title: 'Pesca su Trampoli', desc: 'Tecnica iconica dei pescatori sulla costa meridionale.' },
                        12: { title: 'Pietre Lunari', desc: 'Gemme semipreziose, famose le miniere di Meetiyagoda.' },
                        13: { title: 'Cricket', desc: 'Passione nazionale — vittoria Coppa del Mondo 1996.' },
                        14: { title: 'Erbe Ayurvediche', desc: 'Gotu kola, cannella, neem per rimedi tradizionali.' },
                        15: { title: 'Maschere', desc: 'Maschere di Ambalangoda usate in danze rituali.' },
                    },
                },
            },

            // === EVENTS PAGE (IT) ===
            events: {
                pageTitle: 'Eventi',
                subtitle: 'Celebra lo Spirito dello Sri Lanka Attraverso i Suoi Festival — dalle cerimonie buddiste sacre alle colorate parate culturali, ogni evento è un’occasione per vivere il battito dell’isola.',
                tabs: {
                    places: 'Luoghi',
                    events: 'Eventi',
                },
                lightboxAria: 'Apri immagine evento {{number}}',
                labels: {
                    kandyPerahera: 'Kandy Esala Perahera (Festa del Dente)',
                    vesak: 'Festival Vesak',
                    sinhalaTamilNewYear: 'Capodanno Sinhala e Tamil',
                    christmas: 'Natale',
                    thaiPongal: 'Thai Pongal',
                    deepavali: 'Deepavali',
                    holi: 'Holi',
                    poson: 'Festival Poson',
                },
            },

            // === GALLERY PAGE (IT) ===
            gallery: {
                pageTitle: 'Galleria',
                subtitle: 'Momenti Catturati, Ricordi Indimenticabili — la nostra galleria mostra le avventure, i sorrisi e le viste mozzafiato che rendono ogni viaggio in Sri Lanka unico',
                tabs: {
                    places: 'Luoghi',
                    events: 'Eventi',
                },
                labels: {
                    nuwaraEliya: 'Nuwara Eliya',
                    sigiriya: 'Sigiriya',
                    anuradhapura: 'Anuradhapura',
                    rambodaFalls: 'Cascate Ramboda',
                    ella: 'Ella',
                    yala: 'Yala',
                    kandy: 'Kandy',
                    bodhiViharaya: 'Bodhi Viharaya',
                    knuckles: 'Knuckles',
                    udawalawe: 'Udawalawe',
                    bentota: 'Safari in Barca a Bentota',
                    colombo: 'Colombo',
                    galle: 'Galle',
                    mirrissa: 'Mirissa',
                    jaffna: 'Jaffna',
                    ambuluwawa: 'Torre Ambuluwawa',
                    turtle: 'Fattoria delle Tartarughe',
                    polonnaruwa: 'Polonnaruwa',
                    polgampala: 'Piscina Naturale di Polgampala',
                    beach: 'Spiaggia',
                },
            },

            // === TOUR PACKAGES PAGE (IT) ===
            tourPackages: {
                pageTitle: 'Pacchetti Turistici',
                subtitle: 'Pick Lanka - La Tua Porta per Avventure Indimenticabili a Sri Lanka',
                heroAlt: 'Pacchetti Turistici a Sri Lanka',
                sectionTitle: 'Esplora i Nostri Pacchetti Curati',
                sectionDesc: 'Dalla cultura al safari, offriamo esperienze su misura per ogni viaggiatore.',
                viewDetails: 'Vedi Dettagli',
                hotel: 'Hotel',
                meals: 'Pasti',
                included: 'Incluso',
                excluded: 'Non Incluso',
                bookOnWhatsApp: 'Prenota su WhatsApp',
                whatsappMessage: `Ciao Pick Lanka! Sono interessato a prenotare:\n\n*{{title}}*\nDurata: {{duration}}\n\nPuoi inviarmi più dettagli e disponibilità?`,

                // === PACCHETTO 1: 7 GIORNI CLASSICO ===
                classic7: {
                    title: '7 Giorni / 6 Notti: Tour Classico',
                    duration: '7 Giorni',
                    description: 'Vivi i punti salienti dello Sri Lanka — città antiche, colline del tè e siti culturali — perfetto per i primi viaggiatori.',
                    category: 'Cultura & Patrimonio',
                    itinerary: [
                        { day: 'Giorno 1 – Aeroporto → Habarana', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Cena', details: 'Cena e pernottamento in hotel.' },
                        { day: 'Giorno 2 – Habarana → Anuradhapura → Aukana → Habarana', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Pensione Completa', details: `Partenza al mattino per Anuradhapura, la prima capitale del regno Sinhala, dal IV secolo a.C. al X secolo d.C.<br><br>Visite: Sri Maha Bodhi, l’albero sacro discendente dall’albero originale sotto cui Buddha raggiunse l’illuminazione; Ruwanwelisaya Dagoba, la grande stupa bianca circondata da un muro decorato con fregi di elefanti.<br><br>Visita anche a Thuparamaya, la prima dagoba dell’isola, e Lankarama.<br><br>Cena e pernottamento in hotel.` },
                        { day: 'Giorno 3 – Habarana → Sigiriya → Polonnaruwa → Habarana', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Pensione Completa', details: `Partenza per Sigiriya, visita alle rovine di un complesso monastico del IX secolo con la più bella moonstone dello Sri Lanka e l’imponente Abhayagiri Dagoba (75 m).<br><br>Proseguimento per Kuttam Pokuna, i laghi gemelli per abluzioni rituali, e Jetavanarama Dagoba, la più alta al mondo al momento della costruzione.<br><br>Pranzo in ristorante locale (Priyamali Gedara) con cucina tradizionale.<br><br>Pomeriggio: visita alla Rocca di Sigiriya, Patrimonio UNESCO, alta 370 m (salita di 2 ore, oltre 1.000 gradini).<br><br>Proseguimento per Polonnaruwa, seconda capitale Sinhala (XI-XIII sec.), anch’essa UNESCO.<br><br>Ritorno a Dambulla. Cena e pernottamento.` },
                        { day: 'Giorno 4 – Habarana → Dambulla → Kandy', hotel: 'Oak Ray Heritage', meals: 'Pensione Completa', details: `Mattina: visita ai Templi Rupestri di Dambulla, in cima a una collina (400 gradini, 40 min). Oltre 150 statue di Buddha e divinità.<br><br>Proseguimento per Kandy con sosta a una piantagione di spezie a Matale.<br>Pranzo al ristorante Spice Garden.<br><br>Pomeriggio: visita a Kandy, città sacra e terza capitale Sinhala. Visita al Tempio del Dente Sacro (Dalada Maligawa).<br><br>Cena e pernottamento.` },
                        { day: 'Giorno 5 – Kandy → Nuwara Eliya', hotel: 'Galway Heights', meals: 'Pensione Completa', details: `Dopo colazione, partenza per Nuwara Eliya.<br>Uno dei percorsi più panoramici dello Sri Lanka, con viste mozzafiato sulle montagne.<br><br>Pranzo in ristorante locale.<br>Pomeriggio: visita a una fabbrica di tè.<br><br>Cena e pernottamento a Nuwara Eliya.` },
                        { day: 'Giorno 6 – Nuwara Eliya → Kitulgala → Colombo → Negombo', hotel: 'Fairway Colombo', meals: 'Pensione Completa', details: `Dopo colazione, partenza per Colombo con sosta a Kitulgala per ammirare il fiume.<br><br>Arrivo a Colombo: tour della città con visita a:<br><ul class="list-disc pl-6 mt-2"><li>Bandaranaike Memorial International Conference Hall (BMICH)</li><li>Piazza dell’Indipendenza</li><li>Nuovo Parlamento</li><li>Municipio di Colombo</li><li>Edifici storici</li></ul><br>Pranzo a Colombo, poi proseguimento per Negombo.<br>Cena e pernottamento.` },
                        { day: 'Giorno 7 – Colombo → Aeroporto', meals: 'Colazione', details: 'Colazione in hotel.<br>Trasferimento in aeroporto per il volo di rientro. Fine dei servizi.' },
                    ],
                    includes: [
                        'Tutti gli hotel menzionati o simili (in base alla disponibilità)',
                        'Tour con pensione completa, a partire dalla cena del primo giorno e colazione dell’ultimo',
                        'Veicolo con aria condizionata e guida in italiano',
                        'Tutte le visite guidate e tour come da itinerario',
                        'Tutti i biglietti d’ingresso'
                    ],
                    excludes: ['Mance per l’autista', 'Bevande e pasti extra'],
                },

                // === PACCHETTO 2: 11 GIORNI NORD ===
                northern11: {
                    title: '11 Giorni / 10 Notti: Tour del Nord',
                    duration: '11 Giorni',
                    description: 'Scopri i tesori nascosti del Nord dello Sri Lanka — Jaffna, Mannar, Trincomalee — dove storia e natura incontaminata si incontrano.',
                    category: 'Avventura & Scoperta',
                    itinerary: [
                        { day: 'Giorno 1 – Aeroporto – Chilaw', hotel: 'Anantaya Resort & Spa', meals: 'Cena', details: `Arrivo all’aeroporto di Colombo. Incontro con la guida in italiano.<br><br>Partenza per Chilaw (3 ore). Check-in in hotel (camere disponibili dalle 14:00). Relax.<br><br>Cena in hotel.` },
                        { day: 'Giorno 2 – Chilaw – Jaffna', hotel: 'Jetwing Hotel Jaffna / Hotel Fox', meals: 'Pensione Completa', details: `Partenza per Jaffna.<br>Visita pomeridiana della città, cuore culturale Tamil per secoli, conquistata da Portoghesi, Olandesi e Britannici. Fu teatro della guerra civile (fino al 2009).<br><br>Pranzo in ristorante locale.<br><br>Visita alla Biblioteca Pubblica di Jaffna e al Forte di Jaffna.<br><br>Cena e pernottamento.` },
                        { day: 'Giorno 3 – Jaffna', hotel: 'Jetwing Hotel Jaffna / Hotel Fox', meals: 'Pensione Completa', details: `Mattina: visita al Tempio Nallur Kandasamy Kovil (dedicato a Murugan).<br><br>Visita a Sangili Thoppu, Mantri Mannai, Pozzo di Nilavarai, Mercato di Chunnakam, Rovine di Kadurugoda Viharaya, Sorgenti di Keerimalai.<br><br>Pranzo in ristorante locale.<br><br>Pomeriggio: Keerimalai e Tempio di Maruthanamadam Anjaneyar Kovil.<br>Cena e pernottamento.` },
                        { day: 'Giorno 4 – Jaffna – Anuradhapura', hotel: 'The Lake Forest Hotel', meals: 'Pensione Completa', details: `Partenza presto per Anuradhapura.<br>Visite: Sri Maha Bodhi, Ruvanvelisaya Dagoba, Thuparamaya, Lankarama.<br><br>Cena e pernottamento ad Anuradhapura.` },
                        { day: 'Giorno 5 – Anuradhapura – Mihintale – Aukana – Dambulla', hotel: 'Amaya Lake / Habarana Village by Cinnamon', meals: 'Pensione Completa', details: `Visita a Mihintale (luogo di diffusione del Buddismo), Abhayagiri Dagoba, Kuttam Pokuna, Jethavanarama Dagoba.<br><br>Visita alla Statua del Buddha di Aukana (V sec., 14 m).<br><br>Tempo libero (massaggio ayurvedico, safari elefanti, tour villaggio).<br>Cena in hotel.` },
                        { day: 'Giorno 6 – Dambulla – Sigiriya – Polonnaruwa – Dambulla', hotel: 'Amaya Lake / Habarana Village by Cinnamon', meals: 'Pensione Completa', details: `Visita alla Rocca di Sigiriya (370 m, 1.000+ gradini).<br>Pranzo al Priyamali Gedara.<br><br>Pomeriggio: Polonnaruwa (Palazzo Reale, Vatadage, Gal Viharaya).<br><br>Ritorno a Dambulla. Cena.` },
                        { day: 'Giorno 7 – Dambulla – Kandy', hotel: 'Amaya Hills / Cinnamon Citadel', meals: 'Pensione Completa', details: `Visita ai Templi di Dambulla.<br>Sosta a piantagione di spezie a Matale.<br><br>Pomeriggio: Kandy e Tempio del Dente Sacro.<br>Cena e pernottamento.` },
                        { day: 'Giorno 8 – Kandy – Nuwara Eliya', hotel: 'Jetwing St. Andrews / Galway Heights', meals: 'Pensione Completa', details: `Viaggio in treno per Nuwara Eliya (panoramico).<br>Pranzo in ristorante locale.<br>Cena e pernottamento.` },
                        { day: 'Giorno 9 – Nuwara Eliya – Ella – Yala', hotel: 'Jetwing Yala', meals: 'Pensione Completa', details: `Partenza per Ella. Pranzo.<br><br>Visita a Cascate Ravana, Ponte dei Nove Archi, fabbrica di tè.<br>Proseguimento per Yala.<br>Cena e pernottamento.` },
                        { day: 'Giorno 10 – Yala – Galle', hotel: 'The Heritage Fort / Tamarind Hills', meals: 'Pensione Completa', details: `Safari mattutino a Yala (colazione al sacco).<br><br>Partenza per Galle. Pranzo.<br><br>Pomeriggio: visita al Forte di Galle (UNESCO).<br>Cena e pernottamento.` },
                        { day: 'Giorno 11 – Galle – Aeroporto', meals: 'Colazione', details: 'Colazione. Trasferimento in aeroporto. Fine dei servizi.' },
                    ],
                    includes: [
                        'Tutti gli hotel menzionati o simili (in base alla disponibilità)',
                        'Tour con pensione completa (cena Giorno 1 → colazione Giorno 11)',
                        'Veicolo con aria condizionata e guida in italiano',
                        'Tutte le visite e biglietti d’ingresso come da itinerario'
                    ],
                    excludes: ['Mance per guida/autista', 'Bevande e spese personali'],
                },

                // === PACCHETTO 3: 9 GIORNI MEDITAZIONE ===
                meditation9: {
                    title: '9 Giorni / 8 Notti: Tour Meditazione',
                    duration: '9 Giorni',
                    description: 'Un viaggio spirituale tra templi e monasteri sacri, per relax e consapevolezza.',
                    category: 'Spirituale & Benessere',
                    itinerary: [
                        { day: 'Giorno 1 – Aeroporto – Habarana', hotel: 'Elephant Lake Habarana', meals: 'Cena', details: `Arrivo a Colombo. Incontro con guida in italiano.<br>Partenza per Habarana. Relax.<br>Cena e pernottamento.` },
                        { day: 'Giorno 2 – Habarana – Anuradhapura – Habarana', hotel: 'Elephant Lake Habarana', meals: 'Pensione Completa', details: `Programma di meditazione a Kaludiya Pokuna.<br>Cerimonia “Dana” con monaci.<br><br>Pomeriggio: Anuradhapura (Sri Maha Bodhi, Ruwanwelisaya, ecc.).<br>Cena e pernottamento.` },
                        { day: 'Giorno 3 – Habarana – Sigiriya – Polonnaruwa – Habarana', hotel: 'Elephant Lake Habarana', meals: 'Pensione Completa', details: `Visita a Sigiriya e Polonnaruwa (Gal Viharaya).<br>Pranzo al Priyamali Gedara.<br>Ritorno a Habarana.` },
                        { day: 'Giorno 4 – Habarana – Dambulla – Kandy', hotel: 'Oak Ray Heritage, Kandy', meals: 'Pensione Completa', details: `Templi di Dambulla. Sosta a Matale.<br><br>Pomeriggio: Tempio del Dente Sacro.<br>Cena e pernottamento.` },
                        { day: 'Giorno 5 – Kandy – Treno – Nuwara Eliya', hotel: 'Galway Heights, Nuwara Eliya', meals: 'Pensione Completa', details: `Treno panoramico per Nuwara Eliya.<br>Visita a fabbrica di tè.<br>Cena e pernottamento.` },
                        { day: 'Giorno 6 – Nuwara Eliya – Ella – Yala', hotel: 'Oak Ray Wild, Yala', meals: 'Pensione Completa', details: `Ponte dei Nove Archi, Cascate Ravana.<br>Proseguimento per Yala.<br>Cena e pernottamento.` },
                        { day: 'Giorno 7 – Yala – Galle', hotel: 'Tamarind Hill, Galle', meals: 'Pensione Completa', details: `Safari mattutino a Yala.<br>Partenza per Galle. Visita al Forte.<br>Cena e pernottamento.` },
                        { day: 'Giorno 8 – Galle – Colombo – Negombo', hotel: 'Amagi Lagoon', meals: 'Pensione Completa', details: `Tour di Colombo (BMICH, Parlamento, ecc.).<br>Pranzo. Proseguimento per Negombo.<br>Cena.` },
                        { day: 'Giorno 9 – Negombo – Aeroporto', meals: 'Colazione', details: 'Colazione. Trasferimento in aeroporto. Fine dei servizi.' },
                    ],
                    includes: [
                        'Sistemazione negli hotel indicati o simili',
                        'Pensione completa (cena Giorno 1 → colazione Giorno 9)',
                        'Veicolo con aria condizionata e guida in italiano',
                        'Tutti i biglietti d’ingresso e visite guidate'
                    ],
                    excludes: ['Mance per guida/autista', 'Bevande ed extra'],
                },

                // === PACCHETTO 4: 9 GIORNI CLASSICO ===
                classic9: {
                    title: '9 Giorni / 8 Notti: Tour Classico',
                    duration: '9 Giorni',
                    description: 'Un’avventura culturale estesa — Kandy, Sigiriya, Galle con tradizioni e cucina autentica.',
                    category: 'Cultura & Natura',
                    itinerary: [
                        { day: 'Giorno 1 – Aeroporto – Dambulla', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Cena', details: `Arrivo a Colombo. Partenza per Dambulla. Relax.<br>Cena e pernottamento.` },
                        { day: 'Giorno 2 – Dambulla – Anuradhapura – Dambulla', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Pensione Completa', details: `Visita ad Anuradhapura (Sri Maha Bodhi, Ruwanwelisaya, ecc.).<br>Tempo libero per massaggio o safari.<br>Cena e pernottamento.` },
                        { day: 'Giorno 3 – Dambulla – Sigiriya – Polonnaruwa – Dambulla', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Pensione Completa', details: `Sigiriya (salita 1.000+ gradini). Pranzo al Priyamali Gedara.<br><br>Polonnaruwa (Palazzo Reale, Gal Viharaya).<br>Ritorno a Dambulla.` },
                        { day: 'Giorno 4 – Dambulla – Kandy', hotel: 'Oak Ray Heritage', meals: 'Pensione Completa', details: `Templi di Dambulla. Sosta a Matale.<br><br>Kandy e Tempio del Dente Sacro.<br>Cena e pernottamento.` },
                        { day: 'Giorno 5 – Kandy – Nuwara Eliya', hotel: 'Galway Heights', meals: 'Pensione Completa', details: `Partenza per Nuwara Eliya. Pranzo a Ella.<br><br>Visita a Cascate Ravana. Proseguimento per Yala.<br>Cena e pernottamento.` },
                        { day: 'Giorno 6 – Nuwara Eliya – Yala', hotel: 'Oak Ray Wild Yala', meals: 'Pensione Completa', details: `Ponte dei Nove Archi. Pranzo a Ella.<br><br>Visita a Cascate Ravana. Arrivo a Yala.<br>Cena e pernottamento.` },
                        { day: 'Giorno 7 – Yala – Galle', hotel: 'Tamarind Hill Galle', meals: 'Pensione Completa', details: `Safari mattutino a Yala (colazione al sacco).<br><br>Partenza per Galle. Visita al Forte.<br>Cena e pernottamento.` },
                        { day: 'Giorno 8 – Galle – Colombo – Negombo', hotel: 'Amagi Lagoon', meals: 'Pensione Completa', details: `Tour di Colombo. Pranzo.<br>Proseguimento per Negombo.<br>Cena e pernottamento.` },
                        { day: 'Giorno 9 – Negombo – Aeroporto', meals: 'Colazione', details: 'Colazione. Trasferimento in aeroporto. Fine dei servizi.' },
                    ],
                    includes: [
                        'Tutti gli hotel menzionati o simili (soggetti a disponibilità)',
                        'Tour con pensione completa (cena Giorno 1 → colazione ultimo giorno)',
                        'Veicolo con aria condizionata e guida in italiano',
                        'Tutti i biglietti d’ingresso e visite guidate'
                    ],
                    excludes: ['Mance per guida/autista', 'Bevande ed extra'],
                },
            },
            // === THINGS TO DO PAGE (OGGETTO ANNIDATO) ===
            thingsToDoPage: { // <-- Rinominato per evitare conflitti
                pageTitle: 'Cose da Fare a Sri Lanka',
                sectionTitle: 'Cose da Fare a Sri Lanka',
                subtitle: 'Avventura, Cultura & Benessere',
                heroAlt: 'Cose da Fare a Sri Lanka',
                viewMore: 'Scopri di Più',

                ayurveda: {
                    title: 'Ayurveda - Antica Scienza della Vita',
                    alt: 'Terapia Ayurvedica a Sri Lanka',
                },
                diving: {
                    title: 'Immersioni a Sri Lanka',
                    alt: 'Esperienza di Immersione a Sri Lanka',
                },
                elephantRide: {
                    title: 'Giro in Elefante',
                    alt: 'Giro in Elefante a Sri Lanka',
                },
                fishing: {
                    title: 'Pesca a Sri Lanka',
                    alt: 'Attività di Pesca a Sri Lanka',
                },
                ballooning: {
                    title: 'Mongolfiera a Sri Lanka',
                    alt: 'Giro in Mongolfiera a Sri Lanka',
                },
                jeepSafari: {
                    title: 'Safari in Jeep',
                    alt: 'Safari in Jeep a Sri Lanka',
                },
                whiteWaterRafting: {
                    title: 'Rafting in Acque Bianche',
                    alt: 'Rafting in Acque Bianche a Sri Lanka',
                },
                riverSafari: {
                    title: 'Safari Fluviale',
                    alt: 'Safari Fluviale a Sri Lanka',
                },
                snorkeling: {
                    title: 'Snorkeling a Sri Lanka',
                    alt: 'Esperienza di Snorkeling a Sri Lanka',
                },
                teaTasting: {
                    title: 'Degustazione di Tè',
                    alt: 'Tour di Degustazione di Tè a Sri Lanka',
                },
                templeVisit: {
                    title: 'Visita ai Templi',
                    alt: 'Visita ai Templi a Sri Lanka',
                },
                wildlifeTour: {
                    title: 'Safari Faunistico',
                    alt: 'Safari Faunistico a Sri Lanka',
                },
            },
        },
    },

    en: {
        translation: {
            // === NAVBAR ===
            home: 'Home',
            aboutUs: 'About Us',
            sriLankanav: 'Sri Lanka',
            gallerynav: 'Gallery',
            bookATour: 'Book a Tour',
            thingsToDo: 'Things to Do', // <-- STRINGA
            contactUs: 'Contact Us',

            // === CONTACT US PAGE ===
            contactUsTitle: 'Contact Us',
            contactUsSubtitle: 'Pick Lanka - Your Gateway to Unforgettable Sri Lankan Adventures',
            feelFreeToContact: 'Feel Free To Contact Us',
            planYourDream: 'Plan Your Dream Sri Lankan Adventure',
            contactDescription: 'Reach out to Pick Lanka for personalized tour packages, expert guidance, and unforgettable travel experiences across Sri Lanka.',
            callCenter: 'Call Center',
            email: 'Email',
            ourLocation: 'Our Location',
            socialNetwork: 'Social Network',
            getInTouch: 'Get In Touch',
            getInTouchDesc: 'Discover Sri Lanka with Pick Lanka — we’re here 24/7 to make your journey unforgettable.',
            name: 'Name',
            emailLabel: 'Email',
            contactNumber: 'Contact Number',
            message: 'Message',
            sendMessage: 'Send Message',
            sending: 'Sending...',
            successMessage: 'Your inquiry has been sent via WhatsApp!',
            errorMessage: 'Failed to open WhatsApp. Please try again.',
            findUsInColombo: 'Find Us in Colombo',

            footer: {
                pickLankaTitle: "Pick Lanka Tours",
                getInTouch: "Get in Touch",
                stayConnected: "Stay Connected",
                address: "164, Jambugasmulla Mawatha, Nugegoda, Sri Lanka.",
                email: "info@picklanka.com",
                phone: "+94 77 080 6767",
                newsletterPlaceholder: "Enter your email",
                newsletterAria: "Email for newsletter",
                sendButton: "Send",
                copyright: "Pick Lanka Tours. All Rights Reserved.",
                developedBy: "Designed & Developed by",
                developer: "Redev Solutions (+94 76 460 8225)",

                links: {
                    home: "Home",
                    aboutUs: "About Us",
                    sriLanka: "Sri Lanka",
                    tourPackages: "Tour Packages",
                    gallery: "Gallery",
                    events: "Events",
                    thingsToDo: "Things to Do",
                    contactUs: "Contact Us"
                },

                social: {
                    facebook: "Facebook",
                    instagram: "Instagram",
                    youtube: "YouTube",
                    tiktok: "TikTok"
                }
            },

            // === WILDLIFE SAFARI PAGE (EN) ===
            wildlifeSafariPage: {
                heroTitle: 'Wildlife Safari in Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka, known for its rich biodiversity, offers incredible wildlife safaris in national parks like Yala, Wilpattu, Minneriya, and Udawalawe. These safaris provide a chance to witness elephants, leopards, sloth bears, and a variety of bird species in their natural habitats.',
                    paragraph2: 'Explore diverse landscapes ranging from dense forests to open grasslands, and capture unforgettable moments of wildlife in action. With expert guides and well-maintained safari jeeps, a wildlife safari in Sri Lanka is a must for nature enthusiasts and adventure seekers.'
                },
                highlights: {
                    title: 'Why Choose a Wildlife Safari?',
                    intro: 'A wildlife safari in Sri Lanka offers a unique opportunity to connect with nature and explore the island\'s remarkable biodiversity. Highlights include:',
                    list: [
                        'Witnessing iconic species like elephants, leopards, and crocodiles.',
                        'Exploring lush forests, wetlands, and open plains teeming with wildlife.',
                        'Capturing stunning wildlife photography in natural settings.',
                        'Experiencing the thrill of spotting elusive animals like the Sri Lankan leopard.',
                        'Learning about conservation efforts from experienced guides and naturalists.'
                    ]
                },
                images: {
                    main: 'Wildlife Safari in Sri Lanka',
                    elephants: 'Witness majestic elephants roaming freely in Sri Lanka\'s national parks.',
                    leopard: 'Spot the elusive Sri Lankan leopard, a highlight of any wildlife safari.'
                },
                tips: {
                    title: 'Tips for an Exciting Wildlife Safari',
                    list: [
                        'Wear neutral-colored clothing to blend into the environment.',
                        'Carry sunscreen, a hat, and insect repellent for protection.',
                        'Bring binoculars and a camera to spot and capture wildlife.',
                        'Follow your guide\'s instructions for a safe and enjoyable experience.',
                        'Book early, especially during peak seasons, to secure a spot in popular parks.'
                    ]
                }
            },

            // === WHITE WATER RAFTING PAGE (EN) ===
            whiteWaterRaftingPage: {
                heroTitle: 'White Water Rafting in Sri Lanka',
                intro: {
                    paragraph1: 'White water rafting in Sri Lanka is an exhilarating experience, especially in Kitulgala, the adventure capital of the island. The Kelani River, with its roaring rapids and scenic surroundings, offers a perfect setting for both beginners and experienced rafters.',
                    paragraph2: 'Rafting expeditions typically cover a 5-kilometer stretch with rapids ranging from Grade 2 to Grade 4. Participants can enjoy the thrill of navigating challenging currents while taking in the lush greenery and breathtaking views of the riverbanks.'
                },
                highlights: {
                    title: 'Why Choose White Water Rafting in Sri Lanka?',
                    intro: 'White water rafting in Sri Lanka offers a unique combination of adventure and natural beauty. Here are some highlights of the experience:',
                    list: [
                        'Navigate through thrilling rapids under the guidance of experienced instructors.',
                        'Enjoy stunning views of the surrounding rainforest and mountainous terrain.',
                        'Combine rafting with other activities like trekking, birdwatching, and canyoning in Kitulgala.',
                        'Perfect for groups, families, or solo travelers looking for an adrenaline rush.'
                    ]
                },
                images: {
                    main: 'White Water Rafting in Sri Lanka',
                    action: 'Feel the adrenaline rush as you conquer challenging rapids on the Kelani River.',
                    scenic: 'Enjoy the serene beauty of the lush surroundings during your rafting adventure.'
                },
                tips: {
                    title: 'Tips for a Safe and Exciting Rafting Trip',
                    list: [
                        'Wear a life jacket and helmet provided by your rafting guide for safety.',
                        'Listen carefully to the safety instructions before starting your trip.',
                        'Wear comfortable, quick-drying clothing and secure footwear like water shoes.',
                        'Carry a change of clothes and a towel for after the trip.',
                        'Book your rafting trip with a reputable operator to ensure a safe and enjoyable experience.'
                    ]
                }
            },

            // === TEMPLE VISIT PAGE (EN) ===
            templeVisitPage: {
                heroTitle: 'Temple Visit in Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka, known as the Land of Buddha, is home to ancient temples that reflect its rich spiritual and cultural heritage. Embark on a journey to explore iconic temples such as the Temple of the Tooth in Kandy, the Dambulla Cave Temple, and Ruwanwelisaya in Anuradhapura.',
                    paragraph2: 'These sacred sites, adorned with intricate carvings, murals, and statues, offer a glimpse into the island\'s spiritual traditions and architectural brilliance. A temple visit is not only a cultural experience but also an opportunity to find peace and tranquility.'
                },
                highlights: {
                    title: 'Why Visit Temples in Sri Lanka?',
                    intro: 'Visiting temples in Sri Lanka offers a unique opportunity to connect with the island’s history, culture, and spirituality. Here are some highlights:',
                    list: [
                        'Admire the intricate architecture and centuries-old statues.',
                        'Learn about Buddhist traditions and rituals from knowledgeable guides.',
                        'Explore UNESCO World Heritage Sites like the Golden Temple of Dambulla.',
                        'Experience the serenity and spiritual ambiance of sacred spaces.',
                        'Witness vibrant festivals like Esala Perahera at the Temple of the Tooth.'
                    ]
                },
                images: {
                    main: 'Temple Visit in Sri Lanka',
                    interior: 'Marvel at the stunning interiors adorned with intricate carvings and murals.',
                    sacred: 'Visit sacred temples like Ruwanwelisaya and immerse yourself in spiritual traditions.'
                },
                tips: {
                    title: 'Tips for Visiting Temples in Sri Lanka',
                    list: [
                        'Dress modestly, covering your shoulders and knees, as a sign of respect.',
                        'Remove your shoes before entering temple premises.',
                        'Refrain from touching statues or sacred objects.',
                        'Bring a small donation for the temple if you wish to contribute.',
                        'Respect the silence and spiritual atmosphere during your visit.'
                    ]
                }
            },

            // === TEA TASTING PAGE (EN) ===
            teaTastingPage: {
                heroTitle: 'Tea Tasting Tour in Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka, often referred to as the \'Pearl of the Indian Ocean,\' is famous for its world-class tea production. Embark on a tea tasting tour and explore the lush tea plantations in regions like Nuwara Eliya, Ella, and Kandy. Learn about the art of tea cultivation, the meticulous process of tea production, and savor the rich flavors of authentic Ceylon tea.',
                    paragraph2: 'Whether you\'re a tea enthusiast or simply curious, a tea tasting tour offers a unique opportunity to delve into Sri Lanka’s tea heritage and experience the serene beauty of its highlands.'
                },
                highlights: {
                    title: 'Why Choose a Tea Tasting Tour?',
                    intro: 'A tea tasting tour in Sri Lanka is not just about tasting tea—it\'s an immersive cultural experience. Here are some highlights:',
                    list: [
                        'Visit picturesque tea plantations nestled in the cool highlands.',
                        'Learn about the history and significance of Ceylon tea.',
                        'Participate in tea plucking and observe the production process in tea factories.',
                        'Savor different varieties of tea, from black to green to flavored blends.',
                        'Enjoy the breathtaking scenery of misty mountains and cascading waterfalls.'
                    ]
                },
                images: {
                    main: 'Tea Tasting Tour in Sri Lanka',
                    plantation: 'Explore lush tea plantations and learn about tea cultivation.',
                    preparation: 'Discover the art of tea preparation and savor authentic Ceylon tea.'
                },
                tips: {
                    title: 'Tips for an Enjoyable Tea Tasting Tour',
                    list: [
                        'Wear comfortable clothing and footwear for walking through plantations.',
                        'Bring a light jacket, as highland regions can be cool and misty.',
                        'Try different varieties of tea and take some favorites home as souvenirs.',
                        'Ask questions during the tour to learn more about the tea-making process.',
                        'Combine your tea tour with visits to nearby attractions like waterfalls and viewpoints.'
                    ]
                }
            },

            // === SNORKELING PAGE (EN) ===
            snorkelingPage: {
                heroTitle: 'Snorkeling in Sri Lanka',
                intro: {
                    paragraph1: 'Snorkeling in Sri Lanka offers an unforgettable underwater experience, where you can explore vibrant coral reefs and diverse marine life. With its crystal-clear waters and abundant aquatic ecosystems, Sri Lanka is a paradise for snorkelers of all skill levels.',
                    paragraph2: 'Some of the most popular snorkeling spots include Hikkaduwa, known for its colorful coral gardens and turtles, Pigeon Island in Trincomalee, famous for its pristine reefs, and Mirissa, where you might even spot a whale or two during the snorkeling season.'
                },
                highlights: {
                    title: 'Why Choose Snorkeling in Sri Lanka?',
                    intro: 'Snorkeling in Sri Lanka is a magical experience, combining adventure and natural beauty. Here are some highlights:',
                    list: [
                        'Explore vibrant coral reefs teeming with life.',
                        'Swim alongside colorful tropical fish, turtles, and even reef sharks.',
                        'Discover pristine underwater landscapes in clear, warm waters.',
                        'Suitable for both beginners and experienced snorkelers.',
                        'Accessible from some of the best beach destinations in Sri Lanka.'
                    ]
                },
                images: {
                    main: 'Snorkeling in Sri Lanka',
                    coral: 'Discover stunning coral reefs and their vibrant ecosystems.',
                    marine: 'Encounter diverse marine life, including turtles, tropical fish, and more.'
                },
                tips: {
                    title: 'Tips for a Memorable Snorkeling Experience',
                    list: [
                        'Wear a comfortable mask and snorkel to ensure a clear view underwater.',
                        'Apply reef-safe sunscreen to protect both your skin and marine life.',
                        'Swim gently to avoid disturbing coral reefs and aquatic creatures.',
                        'Stay hydrated and take breaks between sessions.',
                        'Join a guided tour for the best snorkeling spots and safety tips.'
                    ]
                }
            },

            // === RIVER SAFARI PAGE (EN) ===
            riverSafariPage: {
                heroTitle: 'River Safari in Sri Lanka',
                intro: {
                    paragraph1: 'A river safari in Sri Lanka offers a unique way to explore the island\'s rich biodiversity and scenic beauty. Glide along tranquil waterways surrounded by lush mangroves, spot exotic wildlife, and enjoy picturesque sunsets that will leave you mesmerized.',
                    paragraph2: 'Popular river safari destinations include the Madu Ganga (Madu River) and Bentota River. These safaris provide a chance to witness various bird species, monitor lizards, crocodiles, and even monkeys in their natural habitats. The serene environment is perfect for nature lovers and photographers.'
                },
                highlights: {
                    title: 'Why Choose a River Safari?',
                    intro: 'A river safari is a relaxing and immersive experience that combines nature, wildlife, and cultural exploration. Here are some highlights:',
                    list: [
                        'Explore lush mangroves teeming with life.',
                        'Spot exotic birds, crocodiles, and other wildlife.',
                        'Visit small islands and local villages along the river.',
                        'Enjoy the tranquility and picturesque beauty of Sri Lanka\'s waterways.',
                        'Perfect for families, couples, and solo travelers seeking a peaceful escape.'
                    ]
                },
                images: {
                    main: 'River Safari in Sri Lanka',
                    mangroves: 'Discover the lush mangroves that line Sri Lanka\'s scenic waterways.',
                    wildlife: 'Spot exotic wildlife like crocodiles, monitor lizards, and colorful birds during your safari.'
                },
                tips: {
                    title: 'Tips for an Enjoyable River Safari',
                    list: [
                        'Wear comfortable clothing and bring a hat and sunscreen for protection.',
                        'Carry binoculars to spot distant wildlife and birds.',
                        'Bring a camera or smartphone to capture the stunning scenery and wildlife.',
                        'Follow the instructions of your guide for a safe and enjoyable experience.',
                        'Respect the natural environment by avoiding littering and disturbing wildlife.'
                    ]
                }
            },

            // === JEEP SAFARI PAGE (EN) ===
            jeepSafariPage: {
                heroTitle: 'Jeep Safari in Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka\'s national parks offer a thrilling jeep safari experience, allowing you to explore the island\'s rich biodiversity and witness wildlife in their natural habitats. Yala National Park, Wilpattu National Park, and Udawalawe National Park are among the most popular destinations for jeep safaris.',
                    paragraph2: 'These safaris provide a chance to see elephants, leopards, sloth bears, water buffalo, crocodiles, and a wide variety of bird species. Guided by experienced naturalists and trackers, jeep safaris are perfect for wildlife enthusiasts and photographers alike.'
                },
                highlights: {
                    title: 'Why Choose a Jeep Safari?',
                    intro: 'Jeep safaris are one of the best ways to explore the diverse wildlife of Sri Lanka. Here are some highlights:',
                    list: [
                        'Close encounters with iconic species like elephants and leopards.',
                        'Access to remote and scenic areas within national parks.',
                        'Opportunities for wildlife photography in a natural setting.',
                        'Guidance from knowledgeable naturalists and park rangers.',
                        'An adventure suitable for all age groups, combining excitement with education.'
                    ]
                },
                images: {
                    main: 'Jeep Safari in Sri Lanka',
                    wildlife: 'Witness iconic wildlife like leopards, elephants, and crocodiles during your safari.',
                    landscape: 'Explore the stunning landscapes of Sri Lanka\'s national parks, from dense forests to open plains.'
                },
                tips: {
                    title: 'Tips for an Enjoyable Jeep Safari',
                    list: [
                        'Wear comfortable, neutral-colored clothing to blend in with the environment.',
                        'Carry sunscreen, a hat, and insect repellent for protection.',
                        'Bring binoculars and a camera to enhance your experience and capture wildlife.',
                        'Follow the guide\'s instructions to ensure safety and respect for the animals.',
                        'Book your safari early, especially during peak seasons, to secure a spot.'
                    ]
                }
            },

            // === FISHING PAGE (EN) ===
            fishingPage: {
                heroTitle: 'Fishing in Sri Lanka',
                intro: {
                    paragraph1: 'Sri Lanka, with its vast coastline and abundance of freshwater lakes and rivers, offers an unparalleled fishing experience. Whether you\'re a professional angler or a hobbyist, Sri Lanka has something to offer. From deep-sea fishing expeditions to the traditional stilt fishing practiced by local fishermen, you\'ll have an unforgettable adventure.',
                    paragraph2: 'Popular fishing destinations include the southern coast around Galle and Mirissa, the Negombo lagoon, and the calm waters of Trincomalee. Depending on your preference, you can try different fishing techniques such as trolling, bottom fishing, or fly fishing.'
                },
                experiences: {
                    title: 'Fishing Experiences in Sri Lanka',
                    intro: 'Fishing in Sri Lanka is not just about catching fish; it is an opportunity to immerse yourself in the culture and traditions of the island. Some unique fishing experiences include:',
                    list: [
                        { title: 'Stilt Fishing', description: 'A traditional method where fishermen perch on stilts to catch fish near the shore, a practice unique to Sri Lanka.' },
                        { title: 'Deep-Sea Fishing', description: 'Venture into the Indian Ocean to catch marlins, tunas, barracudas, and other large fish species.' },
                        { title: 'Lagoon and River Fishing', description: 'Relax while fishing in serene lagoons and rivers teeming with fish like tilapia and catfish.' },
                        { title: 'Night Fishing', description: 'Experience the thrill of fishing under the stars, a common practice in coastal villages.' }
                    ]
                },
                images: {
                    main: 'Fishing in Sri Lanka',
                    stilt: 'Stilt fishing is a traditional method and an iconic image of Sri Lanka\'s fishing heritage.',
                    deepSea: 'Deep-sea fishing offers an adventurous experience, targeting large fish species in the Indian Ocean.'
                },
                tips: {
                    title: 'Tips for an Enjoyable Fishing Trip',
                    list: [
                        'Choose the right season for your fishing expedition; October to April is ideal for the southern coast, while March to October suits the eastern coast.',
                        'Bring sunscreen, a hat, and protective clothing to stay comfortable during your trip.',
                        'Book a fishing guide or charter to make the most of your experience and learn from the experts.',
                        'Respect the local environment by avoiding littering and adhering to sustainable fishing practices.',
                        'Stay hydrated and carry snacks for longer fishing trips.'
                    ]
                }
            },

            // === ELEPHANT RIDE PAGE (EN) ===
            elephantRidePage: {
                heroTitle: 'Elephant Back Ride',
                intro: {
                    paragraph1: 'Elephant trekking is a fascinating, exciting activity and a unique experience in Sri Lanka. If you are staying near the cultural triangle in areas like Habarana, Sigiriya, or Dambulla, you can participate in an elephant safari. These rides start at around $30 for an hour of unforgettable adventure.',
                    paragraph2: 'Before the ride, elephants are saddled with a multi-basket designed for 4 to 6 people. These gentle giants take you through scenic jungle paths, cross areas flooded with water, and navigate through lush vegetation. Elephants usually walk slowly, allowing you to fully appreciate the beauty of the surrounding nature, even though they can reach speeds of up to 40 km/h.'
                },
                highlights: {
                    title: 'Highlights of an Elephant Ride',
                    intro: 'Riding an elephant in Sri Lanka provides a unique way to connect with nature and explore the countryside. Some highlights of the experience include:',
                    list: [
                        'Walking through dense jungles filled with exotic vegetation and wildlife.',
                        'Crossing rivers and flooded areas, offering stunning views of the natural landscape.',
                        'Learning about the close relationship between elephants and Sri Lankan culture.',
                        'Relaxing on a comfortable saddle while the elephant gently carries you through various terrains.'
                    ]
                },
                images: {
                    main: 'Elephant Back Ride',
                    jungle: 'Explore dense jungles and scenic paths while riding on an elephant.',
                    water: 'Cross rivers and enjoy the tranquil beauty of the water and vegetation.'
                },
                tips: {
                    title: 'Tips for a Safe and Enjoyable Elephant Ride',
                    list: [
                        'Wear comfortable clothing and footwear suitable for outdoor activities.',
                        'Follow the instructions of your guide for a safe and enjoyable ride.',
                        'Ensure that the elephants are well-treated and the ride provider follows ethical practices.',
                        'Bring a camera to capture the breathtaking scenery and moments.',
                        'Respect the elephants and avoid actions that might stress or harm them.'
                    ]
                }
            },

            // === DIVING PAGE (EN) ===
            divingPage: {
                heroTitle: 'Diving in Sri Lanka',
                intro: {
                    paragraph1: 'A wide coral reef surrounds the coast of Sri Lanka at depths of 2 to 40 meters. The warm waters of the Indian Ocean, between 27°C and 30°C, and the high transparency of the water, from 15 to 35 meters, provide excellent conditions for diving and snorkeling. While diving in Sri Lanka, you can explore endless untouched coral reefs, old wrecks, and mesmerizing underwater caves.',
                    paragraph2: 'The northeast of the island offers a variety of more than 130 species of colorful corals, which are home to marine life such as sea turtles, clownfish, lionfish, and seahorses. Visit shipwrecks near underwater rocks and reefs for an unforgettable experience. Floating in the clear waters, you\'ll find yourself immersed in the fascinating past of Ceylon.'
                },
                facilities: {
                    title: 'Facilities and Best Dive Spots',
                    paragraph1: 'Island dive centers are equipped with the latest diving equipment from renowned manufacturers. Certified instructors with PADI and CMAS qualifications ensure safe and enjoyable dives. Dive centers are located along the southwest coast of the island, operating between mid-October and the end of April. The northeast coast, including Nilaveli and Trincomalee, is ideal for diving from March to October.',
                    paragraph2: 'The coral reefs near Kalpitiya in the west and the shipwreck diving sites in Hikkaduwa are among the most popular attractions for divers.'
                },
                images: {
                    main: 'Diving in Sri Lanka',
                    coral: 'Explore vibrant coral reefs that are home to diverse marine life.',
                    shipwreck: 'Discover historic shipwrecks that offer a glimpse into Sri Lanka\'s maritime past.'
                },
                tips: {
                    title: 'Tips for Divers',
                    list: [
                        'Choose the best season for diving based on the location: southwest coast (October to April) or northeast coast (March to October).',
                        'Ensure your dive center is certified and equipped with modern gear for a safe experience.',
                        'Listen to your instructor\'s advice, especially if you are a beginner.',
                        'Respect marine life by not touching corals or disturbing the underwater environment.',
                        'Carry a waterproof camera to capture the mesmerizing beauty of Sri Lanka\'s underwater world.'
                    ]
                }
            },

            // === BALLOONING PAGE (EN) ===
            ballooningPage: {
                heroTitle: 'Ballooning in Sri Lanka',
                intro: {
                    paragraph1: 'Hot air ballooning in Sri Lanka offers an unforgettable experience of floating gently above the stunning landscapes of the island. Starting at sunrise, balloon rides provide breathtaking aerial views of rolling hills, lush forests, ancient ruins, and serene villages.',
                    paragraph2: 'The most popular ballooning destination in Sri Lanka is Dambulla, located in the heart of the cultural triangle. Balloon rides here often take you over the iconic Sigiriya Rock Fortress, offering a perspective like no other. Flights typically last 60-90 minutes, giving you ample time to soak in the beauty of Sri Lanka from above.'
                },
                highlights: {
                    title: 'Why Try Hot Air Ballooning in Sri Lanka?',
                    intro: 'Hot air ballooning combines adventure with tranquility, allowing you to experience Sri Lanka’s beauty in a unique way. Some of the highlights of ballooning include:',
                    list: [
                        'Uninterrupted panoramic views of the island’s stunning landscapes.',
                        'Flying over iconic landmarks like Sigiriya Rock and nearby lakes.',
                        'A serene and peaceful ride above lush greenery and charming villages.',
                        'Witnessing a spectacular sunrise from the sky.',
                        'Perfect for photography enthusiasts looking to capture scenic beauty from above.'
                    ]
                },
                images: {
                    main: 'Hot Air Ballooning in Sri Lanka',
                    sunrise: 'Enjoy breathtaking views of the sunrise while floating gently in a hot air balloon.',
                    landscape: 'Witness stunning landscapes of Sri Lanka from above, including rolling hills and lush forests.'
                },
                tips: {
                    title: 'Tips for a Memorable Balloon Ride',
                    list: [
                        'Book your ride early, as ballooning is weather-dependent and slots fill up quickly.',
                        'Wear comfortable clothing and carry a light jacket, as early mornings can be cool.',
                        'Carry a camera or smartphone to capture the stunning views.',
                        'Listen carefully to the safety instructions provided by your pilot.',
                        'Arrive on time to watch the preparation and inflation of the balloon, which is a fascinating process.'
                    ]
                }
            },

            // === AYURVEDA PAGE (EN) ===
            ayurvedaPage: {
                pageTitle: 'Ayurveda - The Ancient Science of Life',
                heroTitle: 'Ayurveda - The Ancient Science of Life',
                intro: {
                    paragraph1: 'The word “Ayurveda” has existed for more than three thousand years. In Sanskrit, the word means “science of life.” The technique is based on the Ayurvedic healing view of disease rather than its consequences, which usually fights European medicine. It postulates the following principles:',
                    principlesTitle: 'Core Principles',
                    principles: [
                        'The body should be free of energy and maintain balance for normal metabolic and cardiac activity.',
                        'The body should have normal muscle contraction with regular hormonal activity.',
                        'The body needs a healthy immune system to function properly.'
                    ],
                    paragraph2: 'According to recent data, in Sri Lanka, there are more than 6,000 graduates trained in Ayurveda. They undergo seven years of study and two years of practice in public hospitals. Ayurveda programs include:'
                },
                benefits: [
                    'Removing stress, fatigue, and anxiety',
                    'Oxygen saturation',
                    'Stimulation of muscular systems and elimination of toxins',
                    'Restoring the balance of the nervous system',
                    'Restoring blood flow to internal organs',
                    'Producing endorphins'
                ],
                treatments: {
                    description: 'Standard treatments include body massages and scalp massages using special oils, herbal sauna treatments, and baths infused with herbs. The most popular technique is the “Shirodhara procedure,” where warm herbal oil is rhythmically dripped on the forehead. This helps restore balance to the nervous system and achieve relaxation.'
                },
                tips: {
                    title: 'Tips for Ayurvedic Treatment',
                    list: [
                        'Forget about problems. Relax and clear your mind for the best results.',
                        'Choose the correct location. Select a setting that aligns with your comfort and preferences for optimal healing.',
                        'Select the correct program. Discuss your concerns with the doctor and try different therapies to find what suits you best.',
                        'Take a warm bath before treatment to relax your muscles and prepare your body.',
                        'Eat a light meal before the procedure. Avoid heavy meals to allow proper blood flow during the massage.',
                        'Relaxation after procedures is essential. Proper relaxation enhances the effectiveness of Ayurvedic treatments.'
                    ]
                },
                images: {
                    main: 'Ayurveda',
                    face: 'Ayurveda Face Treatment',
                    massage: 'Ayurveda Massage Treatment'
                }
            },


            // i18n.js — ADD THIS OBJECT TO BOTH LANGUAGES
            hero: {
                title: "Discover Sri Lanka with Pick Lanka Tours",
                subtitle: "Your trusted partner for authentic cultural journeys, wildlife safaris, and unforgettable island adventures.",
                cta: "Explore Tours",
                videoFallback: "Your browser does not support the video tag."
            },

            sections: {
                recommendations: { title: "Destination Recommendations", subtitle: "Confusion? Here are recommendations" },
                excursions: { title: "Our Excursions", description: "Tailored multi-day journeys across Sri Lanka — from cultural immersions to wildlife adventures." },
                packages: { title: "Our Packages" },
                reviews: { title: "What Our Guests Say", subtitle: "Real experiences from travelers who explored Sri Lanka with us" },
                crafting: { title: "Pick Lanka Tours – Crafting Your Perfect Journey", description: "Explore Sri Lanka with Pick Lanka Tours — where every journey is designed with care, blending culture, adventure, and relaxation for unforgettable memories." }
            },
            buttons: { viewAll: "View All", bookNow: "Book Now", contactUs: "Contact Us" },
            recommendations: {
                sigiriya: { label: "Sigiriya", name: "Iconic Lion Rock fortress with stunning views." },
                udawalawa: { label: "Udawalawa", name: "Famous for wild elephant safaris." },
                ella: { label: "Ella", name: "Hill country views and scenic train rides." },
                mirissa: { label: "Mirissa", name: "Beach paradise and whale watching spot." },
                nuwaraeliya: { label: "Nuwara Eliya", name: "Cool tea country with colonial charm." },
                kandy: { label: "Kandy", name: "Cultural capital with the Temple of the Tooth." },
                galle: { label: "Galle", name: "Historic fort city by the ocean." },
                jaffna: { label: "Jaffna", name: "Cultural melting pot with rich history." },
                anuradhapura: { label: "Anuradhapura", name: "Ancient city filled with sacred sites." },
                polonnaruwa: { label: "Polonnaruwa", name: "Historic ruins of ancient Sri Lankan kings." }
            },
            excursions: {
                classic7: { title: "7 Days / 6 Nights – Classic Tour", des: "Discover Sri Lanka’s must-see highlights, from Kandy to the Southern Coast, in a perfectly balanced week-long journey." },
                northern11: { title: "11 Days / 10 Nights – Northern Tour", des: "Venture through Sri Lanka’s northern wonders, including Jaffna, Anuradhapura, and untouched cultural treasures." },
                meditation9: { title: "9 Days / 8 Nights – Meditation Tour", des: "Reconnect with inner peace through serene temples, meditation retreats, and nature escapes across the island." },
                classic9: { title: "9 Days / 8 Nights – Classic Tour", des: "Experience Sri Lanka’s diverse landscapes and rich culture in a nine-day island adventure crafted for all travelers." }
            },
            packages: {
                classic7: { title: "7 Days / 6 Nights: Classic Tour", duration: "7 Days", description: "Experience Sri Lanka’s iconic highlights — ancient cities, tea hills, and cultural landmarks — perfect for first-time travelers.", category: "Culture & Heritage" },
                northern11: { title: "11 Days / 10 Nights: Northern Tour", duration: "11 Days", description: "Discover the hidden gems of Northern Sri Lanka — Jaffna, Mannar, and Trincomalee — where history meets unspoiled beauty.", category: "Adventure & Discovery" },
                meditation9: { title: "9 Days / 8 Nights: Meditation Tour", duration: "9 Days", description: "A peaceful spiritual journey through Sri Lanka’s sacred temples and monasteries, designed for relaxation and mindfulness.", category: "Spiritual & Wellness" },
                classic9: { title: "9 Days / 8 Nights: Classic Tour", duration: "9 Days", description: "An extended cultural adventure — explore Kandy, Sigiriya, and Galle while enjoying authentic local traditions and cuisine.", category: "Culture & Nature" }
            },
            featured: {
                perahera: {
                    h2: "How About Go To",
                    h3: "Kandy Esala Perahera",
                    h4: "(The Festival of the Tooth)",
                    paragraph: `One of Asia’s grandest Buddhist festivals, held annually in Kandy to honor the Sacred Tooth Relic of Lord Buddha. The streets come alive with majestic elephants adorned in vibrant costumes, traditional drummers, fire dancers, and cultural performers, creating a breathtaking procession of devotion and heritage. Experience this spectacular celebration with <strong class="text-[#009CE6]">Pick Lanka Sri Lankan Tours</strong> — where faith, culture, and color come together in an unforgettable journey.`,
                    button: "Learn More"
                },
                safari: {
                    h2: "Sri Lanka",
                    h3: "Safari Adventures",
                    paragraph: `Sri Lanka is one of the best places in Asia for unforgettable wildlife safaris. From the open grasslands of <span class="text-[#96BA33] font-semibold">Yala</span> and <span class="text-[#96BA33] font-semibold">Udawalawa</span> to the serene wetlands of <span class="text-[#96BA33] font-semibold">Wilpattu</span>, each park offers thrilling encounters with elephants, leopards, crocodiles, and exotic birds. Embark on an exciting journey with <strong class="text-[#009CE6]">Pick Lanka Sri Lankan Tours</strong> — where every safari is a new story of adventure, nature, and discovery.`,
                    button: "Learn More"
                },
            },

            // === ABOUT PAGE (EN) ===
            about: {
                hero: {
                    explore: 'EXPLORE',
                    pickLanka: 'PICK LANKA',
                    text1: 'From ancient kingdoms to lush tea gardens and wild safaris,the island is alive with wonder.Sri Lanka is not just a destination — it is a journey of the heart.',
                    text2: 'Sri Lanka welcomes you with golden beaches, misty mountains, and endless adventures.Here, every path leads to beauty, and every moment becomes a memory.',
                },
                sectionTitle: 'About Pick Lanka',
                signatureTour: {
                    title: 'Signature Sri Lanka Tour',
                    images: {
                        0: 'Colombo',
                        1: 'Kandy',
                        2: 'Nuwara Eliya',
                        3: 'Ella',
                        4: 'Yala',
                        5: 'Galle',
                    },
                    labels: {
                        0: { days: '7 days', title: 'CLASSIC TOUR' },
                        1: { days: '10/11 days', title: 'Northern Tour' },
                        2: { days: '8/9 days', title: 'Meditation Tour' },
                    },
                    desc1: 'With Pick Lanka Sri Lankan Tours, explore every province of this stunning island.From the vibrant cities to the misty hills and golden beaches — we take you everywhere.',
                    desc2: 'Discover the best of Sri Lanka with us — from the cultural heart of Kandy to the lively streets of Colombo and the breathtaking Southern Coast.',
                    desc3: 'Whether you seek adventure, culture, wildlife, or relaxation, Pick Lanka Sri Lankan Tours offers unforgettable journeys across the island — any time of the year.',
                },
                whoWeAre: {
                    title: 'Who We Are?',
                    description: 'Welcome to Pick Lanka Sri Lankan Tours — your trusted travel companion across every province of Sri Lanka. Our dedicated local team is passionate about creating journeys that go beyond sightseeing — helping you discover the island’s rich culture, warm hospitality, and unforgettable natural beauty.',
                    imageAlt: 'Who We Are',
                    0: { title: 'All-Island Tours', description: 'Pick Lanka Sri Lankan Tours operates across all provinces — from the North to the deep South, offering authentic local experiences everywhere.' },
                    1: { title: 'Personalized Experiences', description: 'Every tour is tailor-made to match your interests — whether it’s adventure, culture, nature, or relaxation.' },
                    2: { title: 'Trusted Local Expertise', description: 'Our experienced local guides share real insights into Sri Lanka’s hidden gems, traditions, and way of life.' },
                    3: { title: '24/7 Travel Assistance', description: 'With Pick Lanka, you’re never alone — our friendly support team is available around the clock to help throughout your journey.' },
                },
                whatWeOffer: {
                    title: 'What We Offer',
                    0: { title: 'Cultural Immersion', description: 'Experience authentic traditions, festivals, and local life.' },
                    1: { title: 'Adventure Tours', description: 'Hiking, safaris, surfing, and thrilling outdoor activities.' },
                    2: { title: 'Luxury & Comfort', description: 'Premium stays, private transfers, and VIP experiences.' },
                    3: { title: 'Wellness Retreats', description: 'Yoga, Ayurveda, and rejuvenation in serene settings.' },
                },
                heroSlider: [
                    'Sigiriya Rock',
                    'Yala Safari',
                    'Tea Plantations',
                    'Golden Beaches',
                    'Ancient Temples',
                ],
                ourGuides: {
                    title: 'Our Guides',
                    description: 'Our team of professional, licensed guides is the heart of every journey. Friendly, knowledgeable, and passionate about Sri Lanka, they go beyond showing you places — they share stories, traditions, and hidden gems that bring the island to life.',
                    imageAlt: 'Our Guides',
                },
                tourExpert: {
                    name: 'Competent and Friendly',
                    role: '(Tour Expert)',
                    description: 'With over 12 years of experience as a licensed tour guide, Malinda Kudagamage is passionate about showcasing the true beauty of Sri Lanka. From breathtaking beaches and lush hill country to thrilling wildlife safaris and scenic adventures, his expertise ensures every traveler experiences the island’s best — the Pick Lanka way.',
                    imageAlt: 'Tour Expert',
                },
                vehicles: {
                    title: 'What Vehicles We Use',
                    description: 'At Pick Lanka, your safety and comfort come first. We provide reliable, air-conditioned, and well-maintained vehicles to ensure every journey across Sri Lanka is smooth and enjoyable.',
                    bookNow: 'Book Now',
                    arrowAlt: 'Arrow',
                    van: { type: 'Van', description: 'Ideal for families or small groups (up to 6 passengers). Spacious, comfortable, and perfect for long journeys.' },
                    minibus: { type: 'Minibus', description: 'Best for larger groups (8–12 passengers). Comfortable seating and ample storage.' },
                    luxury: { type: 'Luxury', description: 'Premium vehicles with leather seats, Wi-Fi, and chauffeur service for VIP travel.' },
                    car: { type: 'Car', description: 'Ideal for individual travelers or couples. Comfort and style for exploring Sri Lanka independently.' },
                },
            },

            // === SRI LANKA PAGE (EN) ===
            sriLanka: {
                heroTitle: 'Discover Sri Lanka',
                heroSubtitle: 'Pearl of the Indian Ocean',
                heroAlt: 'Sri Lanka',
                introImageAlt: 'Sri Lanka Map with Major Cities',
                intro: [
                    'Sri Lanka, known as the "Emerald Isle", is a tropical gem celebrated for its stunning landscapes, ancient heritage, and heartfelt hospitality.',
                    'With a legacy of over two millennia, Sri Lanka is home to UNESCO-listed sites like Sigiriya’s rock fortress and the sacred city of Anuradhapura. Its cultural richness blends Buddhist, Hindu, and colonial influences, seen in its vibrant festivals and intricate architecture.',
                    'The island’s diverse terrain captivates — from rolling tea plantations in Ella to the turquoise waters of Trincomalee. National parks like Wilpattu harbor leopards, crocodiles, and rare bird species, delighting nature lovers.',
                    'For thrill-seekers, Sri Lanka offers white-water rafting, surfing in Arugam Bay, and trekking through lush jungles. Its cuisine, infused with aromatic spices, fresh fish, and jackfruit, tells a story of tradition and flavor.',
                    'From sacred pilgrimages to serene beach escapes, Sri Lanka promises an enchanting experience steeped in beauty and culture.'
                ],
                placesTitle: 'Attractive Places in Sri Lanka',
                viewMore: 'View More',
                closeModal: 'Close',
                fullImageAlt: 'Full Preview',
                places: {
                    list: {
                        0: { name: 'Sigiriya Rock Fortress', desc: 'UNESCO site with ancient gardens, frescoes, and breathtaking summit views.' },
                        1: { name: 'Temple of the Tooth', desc: 'Sacred Buddhist site housing a relic of Buddha’s tooth.' },
                        2: { name: 'Ella', desc: 'Hill town surrounded by tea estates, famous for Nine Arch Bridge.' },
                        3: { name: 'Yala National Park', desc: 'Renowned for elephants, leopards, and wildlife safaris.' },
                        4: { name: 'Galle Fort', desc: 'Colonial fort with cobblestone streets and Dutch architecture.' },
                        5: { name: 'Nuwara Eliya', desc: 'Known as "Little England" with cool climate and tea plantations.' },
                        6: { name: 'Adam’s Peak', desc: 'Sacred mountain with a unique footprint, a pilgrimage site.' },
                        7: { name: 'Horton Plains', desc: 'Rolling hills, waterfalls, and World’s End viewpoint.' },
                        8: { name: 'Bentota Beach', desc: 'Pristine coast with golden sands and water sports.' },
                        9: { name: 'Jaffna', desc: 'Rich in Tamil culture, history, and cuisine.' },
                        10: { name: 'Anuradhapura', desc: 'Ancient city with sacred Buddhist sites and ruins.' },
                        11: { name: 'Polonnaruwa', desc: 'UNESCO site with well-preserved temples and statues.' },
                        12: { name: 'Unawatuna Beach', desc: 'Vibrant beach with snorkeling and nightlife.' },
                        13: { name: 'Colombo', desc: 'Bustling capital with modern and colonial architecture.' },
                        14: { name: 'Udawalawe National Park', desc: 'Famous for large elephant herds and stunning landscapes.' },
                        15: { name: 'Dambulla Cave Temple', desc: 'UNESCO site with ancient Buddhist murals and statues.' },
                    },
                },
                famousTitle: 'Famous Things in Sri Lanka',
                famous: {
                    list: {
                        0: { title: 'Ceylon Tea', desc: 'World-famous for its flavor, especially from Nuwara Eliya and Uva.' },
                        1: { title: 'Spices', desc: 'Cinnamon, cardamom, cloves — Sri Lankan cinnamon is the best.' },
                        2: { title: 'Gems', desc: 'Sapphires, rubies, moonstones — island of rare gems.' },
                        3: { title: 'Ayurveda', desc: 'Wellness treatments with massages and herbal therapies.' },
                        4: { title: 'Handicrafts', desc: 'Masks, batik, wood carvings, lacquerware.' },
                        5: { title: 'Elephants', desc: 'Cultural symbol, featured in grand festival processions.' },
                        6: { title: 'Traditional Food', desc: 'Rice and curry, hoppers, kottu roti, wattalappam.' },
                        7: { title: 'Festivals', desc: 'Esala Perahera, Vesak, Sinhala-Tamil New Year.' },
                        8: { title: 'Coconut Products', desc: 'Oil, milk, coir fiber for ropes and mats.' },
                        9: { title: 'Kandyan Saree', desc: 'Elegant traditional attire for ceremonies.' },
                        10: { title: 'Traditional Dances', desc: 'Kandyan, devil, and low-country dances.' },
                        11: { title: 'Stilt Fishing', desc: 'Iconic southern coast fishing technique.' },
                        12: { title: 'Moonstones', desc: 'Semi-precious gems, famous Meetiyagoda mines.' },
                        13: { title: 'Cricket', desc: 'National passion — 1996 World Cup winners.' },
                        14: { title: 'Ayurvedic Herbs', desc: 'Gotu kola, cinnamon, neem for remedies.' },
                        15: { title: 'Masks', desc: 'Ambalangoda masks used in ritual performances.' },
                    },
                },
            },

            // === EVENTS PAGE (EN) ===
            events: {
                pageTitle: 'Events',
                subtitle: 'Celebrate the Spirit of Sri Lanka Through Its Festivals — from sacred Buddhist ceremonies to colorful cultural parades, every event is a chance to experience the heartbeat of the island.',
                tabs: {
                    places: 'Places',
                    events: 'Events',
                },
                lightboxAria: 'Open event image {{number}}',
                labels: {
                    kandyPerahera: 'Kandy Esala Perahera (The Festival of the Tooth)',
                    vesak: 'Vesak Festival',
                    sinhalaTamilNewYear: 'Sinhala and Tamil New Year',
                    christmas: 'Christmas',
                    thaiPongal: 'Thai Pongal',
                    deepavali: 'Deepavali',
                    holi: 'Holi',
                    poson: 'Poson Festival',
                },
            },

            // === GALLERY PAGE (EN) ===
            gallery: {
                pageTitle: 'Gallery',
                subtitle: 'Moments Captured, Memories Cherished — our gallery showcases the adventures, smiles, and breathtaking views that make every journey in Sri Lanka unforgettable',
                tabs: {
                    places: 'Places',
                    events: 'Events',
                },
                labels: {
                    nuwaraEliya: 'Nuwara Eliya',
                    sigiriya: 'Sigiriya',
                    anuradhapura: 'Anuradhapura',
                    rambodaFalls: 'Ramboda Falls',
                    ella: 'Ella',
                    yala: 'Yala',
                    kandy: 'Kandy',
                    bodhiViharaya: 'Bodhi Viharaya',
                    knuckles: 'Knuckles',
                    udawalawe: 'Udawalawe',
                    bentota: 'Bentota Boat Safari',
                    colombo: 'Colombo',
                    galle: 'Galle',
                    mirrissa: 'Mirissa',
                    jaffna: 'Jaffna',
                    ambuluwawa: 'Ambuluwawa Tower',
                    turtle: 'Turtle Farm',
                    polonnaruwa: 'Polonnaruwa',
                    polgampala: 'Polgampala Water Pool',
                    beach: 'Beach',
                },
            },

            // === TOUR PACKAGES PAGE (EN) ===
            tourPackages: {
                pageTitle: 'Tour Packages',
                subtitle: 'Pick Lanka - Your Gateway to Unforgettable Sri Lankan Adventures',
                heroAlt: 'Tour Packages in Sri Lanka',
                sectionTitle: 'Explore Our Curated Packages',
                sectionDesc: 'From cultural heritage to wildlife safaris, we offer tailored experiences for every traveler.',
                viewDetails: 'View Details',
                hotel: 'Hotel',
                meals: 'Meals',
                included: 'Included',
                excluded: 'Not Included',
                bookOnWhatsApp: 'Book This Tour on WhatsApp',
                whatsappMessage: `Hi Pick Lanka! I'm interested in booking:\n\n*{{title}}*\nDuration: {{duration}}\n\nCan you send me more details and availability?`,

                // === PACKAGE 1: 7 DAYS CLASSIC ===
                classic7: {
                    title: '7 Days / 6 Nights: Classic Tour',
                    duration: '7 Days',
                    description: 'Experience Sri Lanka’s iconic highlights — ancient cities, tea hills, and cultural landmarks — perfect for first-time travelers.',
                    category: 'Culture & Heritage',
                    itinerary: [
                        { day: 'Day 1 – Airport → Habarana', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Dinner', details: 'Dinner and overnight stay at the hotel.' },
                        { day: 'Day 2 – Habarana → Anuradhapura → Aukana → Habarana', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Full Board', details: `In the morning, departure for Anuradhapura, the first capital of the Sinhalese kingdom, dating from the 4th century B.C. to the 10th century A.D.<br><br>Visits include Sri Maha Bodhi, the sacred fig tree descended from the original Bodhi tree under which Buddha attained enlightenment, and the Ruwanwelisaya Dagoba, the great white stupa surrounded by a wall decorated with a frieze of hundreds of elephants.<br><br>You’ll also see Thuparamaya, the first dagoba built on the island, and Lankarama.<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 3 – Habarana → Sigiriya → Polonnaruwa → Habarana', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Full Board', details: `Departure for Sigiriya, with a visit to the ruins of a 9th-century monastic complex that preserves the most beautiful moonstone in Sri Lanka and the impressive Abhayagiri Dagoba, about 75 meters high.<br><br>Continue to Kuttam Pokuna, the twin ponds used for ritual bathing, and the Jetavanarama Dagoba, which at the time of its construction in the 3rd century was the tallest stupa in the world.<br><br>Lunch at a local restaurant (Priyamali Gedara) — meals are prepared in the traditional way.<br><br>Afternoon visit to the Sigiriya Rock Fortress, a UNESCO World Heritage Site built in the 5th century, rising about 370 meters high (the climb takes about two hours with over 1,000 steps).<br><br>Later, proceed to Polonnaruwa, also a UNESCO World Heritage Site and the second ancient capital of the Sinhalese Kingdom between the 11th and 13th centuries. The temples and sculptures here are among the best preserved in the country.<br><br>Return to hotel in Dambulla. Dinner and overnight stay.` },
                        { day: 'Day 4 – Habarana → Dambulla → Kandy', hotel: 'Oak Ray Heritage', meals: 'Full Board', details: `Morning visit to the beautiful Dambulla Cave Temples, located atop a hill with 400 steps (approximately 40 minutes climb). Inside are over 150 Buddha statues in various postures, along with statues of gods, kings, and historical figures.<br><br>Continue to Kandy, stopping en route at a spice plantation in Matale.<br>Lunch at Spice Garden restaurant.<br><br>Afternoon visit to Kandy, the most sacred city in Sri Lanka and the third capital of the Sinhalese Kingdom. Visit the Temple of the Sacred Tooth Relic (Dalada Maligawa).<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 5 – Kandy → Nuwara Eliya', hotel: 'Galway Heights', meals: 'Full Board', details: `After breakfast, depart for Nuwara Eliya.<br>This journey offers one of the most scenic routes in Sri Lanka, with breathtaking mountain landscapes viewed from a unique perspective.<br><br>Lunch at a local restaurant.<br>Afternoon visit to a tea factory to observe tea production.<br><br>Dinner and overnight stay in Nuwara Eliya.` },
                        { day: 'Day 6 – Nuwara Eliya → Kitulgala → Colombo → Negombo', hotel: 'Fairway Colombo', meals: 'Full Board', details: `After breakfast, depart for Colombo, stopping at Kitulgala to view the beautiful river scenery.<br><br>Upon arrival in Colombo, enjoy a city tour including:<br><ul class="list-disc pl-6 mt-2"><li>Bandaranaike Memorial International Conference Hall (BMICH)</li><li>Independence Memorial Square</li><li>New Parliament</li><li>Colombo Town Hall</li><li>Other historic buildings</li></ul><br>Lunch in Colombo, then continue to Negombo.<br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 7 – Colombo → Airport', meals: 'Breakfast', details: 'Breakfast at the hotel.<br>Transfer to the airport for departure. End of services.' },
                    ],
                    includes: [
                        'All mentioned hotels or similar (depending on availability)',
                        'Full board tour, starting with dinner on the first day and ending with breakfast on the last day',
                        'Air-conditioned vehicle with Italian-speaking guide',
                        'All sightseeing and guided city tours as per the itinerary',
                        'All entrance tickets'
                    ],
                    excludes: ['Driver’s tips', 'Drinks and extra meals'],
                },

                // === PACKAGE 2: 11 DAYS NORTHERN ===
                northern11: {
                    title: '11 Days / 10 Nights: Northern Tour',
                    duration: '11 Days',
                    description: 'Discover the hidden gems of Northern Sri Lanka — Jaffna, Mannar, and Trincomalee — where history meets unspoiled beauty.',
                    category: 'Adventure & Discovery',
                    itinerary: [
                        { day: 'Day 1 – Airport – Chilaw', hotel: 'Anantaya Resort & Spa', meals: 'Dinner', details: `Arrival at Colombo Airport (Bandaranaike International Airport) with your international flight. After completing entry and baggage formalities, you’ll meet your Italian-speaking guide, who will accompany you throughout your stay in Sri Lanka.<br><br>Departure for Chilaw.<br>Note: If your flight arrives in the morning or afternoon, transfer to the hotel (approx. 3 hours). Check-in to the reserved rooms (available from 2:00 PM). Rest of the day free for relaxation.<br><br>Dinner at the hotel.` },
                        { day: 'Day 2 – Chilaw – Jaffna', hotel: 'Jetwing Hotel Jaffna / Hotel Fox', meals: 'Full Board', details: `Morning departure for Jaffna.<br>The history of Jaffna is rich and complex.<br><br>In the afternoon, visit the city, which for centuries was the religious and cultural heart of the Tamil Hindu community in Sri Lanka. It was later conquered by the Portuguese, then the Dutch, and finally the British. The Jaffna region was also one of the main scenes of the country’s tragic civil war, which ended in 2009.<br><br>Lunch at a local restaurant.<br><br>In the afternoon, visit the Jaffna Public Library, a significant symbol of Tamil culture and history in Sri Lanka. Then visit Jaffna Fort, one of the most important and historic fortresses in the country, whose story is deeply intertwined with Sri Lanka’s colonial past and recent civil war.<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 3 – Jaffna', hotel: 'Jetwing Hotel Jaffna / Hotel Fox', meals: 'Full Board', details: `Morning visit to Nallur Kandasamy Kovil (dedicated to Murugan, brother of Ganesh) – one of the most important Hindu temples in Sri Lanka.<br><br>Then visit Sangili Thoppu (royal palace entrance arch), Mantri Mannai (minister’s residence), and the Nilavarai Bottomless Well, a mysterious natural attraction of Jaffna Peninsula.<br><br>Afterward, visit Chunnakam Market (the old Dutch market building), Kadurugoda Viharaya ruins, and Keerimalai Springs.<br><br>Lunch at a local restaurant.<br><br>Visit Keerimalai, literally “The Mongoose’s Burrow,” followed by Maruthanamadam Anjaneyar Kovil, home to a gigantic Hanuman statue.<br>Return to the hotel.<br>Dinner and overnight stay.` },
                        { day: 'Day 4 – Jaffna – Anuradhapura', hotel: 'The Lake Forest Hotel', meals: 'Full Board', details: `Early morning departure for Anuradhapura, the first Sinhalese capital (4th century BC to 10th century AD).<br>Visits include: Sri Maha Bodhi (sacred fig tree descended from the original Bodhi Tree under which Buddha attained enlightenment), Ruvanvelisaya Dagoba, Thuparamaya, and Lankarama.<br><br>Dinner and overnight stay in Anuradhapura.` },
                        { day: 'Day 5 – Anuradhapura – Mihintale – Aukana – Dambulla', hotel: 'Amaya Lake / Habarana Village by Cinnamon', meals: 'Full Board', details: `After breakfast, visit Mihintale, one of the holiest Buddhist sites in Sri Lanka, believed to be where Buddhism spread across the island. The climb is steep (almost 2,000 steps) but rewarded with beautiful views. Visit the ancient hospital ruins, monastery, refectory, and Kantaka Cetiya Stupa.<br><br>Continue to Abhayagiri Dagoba, Kuttam Pokuna (Twin Ponds), and Jethavanarama Dagoba, once the tallest stupa in the world.<br><br>Later, visit Aukana Buddha Statue (14 meters high, 5th century AD).<br><br>Rest of the day free for relaxation (you can enjoy an Ayurvedic massage, elephant safari, or village tour).<br>Dinner at the hotel.` },
                        { day: 'Day 6 – Dambulla – Sigiriya – Polonnaruwa – Dambulla', hotel: 'Amaya Lake / Habarana Village by Cinnamon', meals: 'Full Board', details: `Morning departure for Sigiriya. Visit the famous Sigiriya Rock Fortress, a UNESCO World Heritage Site built in the 5th century, about 370 meters high (the climb takes about 2 hours – over 1,000 steps!).<br><br>Lunch at Priyamali Gedara, a local restaurant with traditional Sri Lankan cuisine.<br><br>Afternoon visit to Polonnaruwa, another UNESCO World Heritage Site and the second capital of the Sinhalese kingdom (11th–13th centuries). Visit Parakramabahu Palace, Vatadage, Hatadage, and the stunning Gal Viharaya, featuring four Buddha statues carved from one massive granite rock.<br><br>Return to Dambulla.<br>Dinner at the hotel.` },
                        { day: 'Day 7 – Dambulla – Kandy', hotel: 'Amaya Hills / Cinnamon Citadel', meals: 'Full Board', details: `Morning visit to the Dambulla Cave Temples, located atop a hill (about 400 steps, 40-minute climb). The complex features over 150 Buddha statues, as well as deities and historical figures.<br><br>Continue to Kandy, with a stop at a spice garden in Matale.<br><br>In the afternoon, visit Kandy city and the Temple of the Sacred Tooth Relic (Dalada Maligawa).<br><br>Dinner and overnight stay in Kandy.` },
                        { day: 'Day 8 – Kandy – Nuwara Eliya', hotel: 'Jetwing St. Andrews / Galway Heights', meals: 'Full Board', details: `After breakfast, travel to Nuwara Eliya by train – one of the most scenic routes in Sri Lanka, showcasing mountain landscapes.<br><br>Upon arrival (1,889 meters above sea level), transfer to the hotel.<br>Lunch at a local restaurant.<br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 9 – Nuwara Eliya – Ella – Yala', hotel: 'Jetwing Yala', meals: 'Full Board', details: `After breakfast, departure for Ella.<br>Lunch at a local restaurant in Ella.<br><br>Afternoon visits to Ravana Falls, Nine Arches Bridge, and a tea factory.<br>Then continue to Yala.<br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 10 – Yala – Galle', hotel: 'The Heritage Fort / Tamarind Hills', meals: 'Full Board', details: `Early morning private game drive in Yala National Park (breakfast box provided by hotel).<br><br>Yala, located in Sri Lanka’s southeastern dry zone, covers 151,778 hectares, with Block I (14,100 ha) open to the public. The park dates back to the 5th century BC and is famous for its wildlife, especially leopards and elephants.<br><br>After the safari, return to hotel around 11:00 AM, check out, and drive to Galle.<br><br>Lunch at a local restaurant.<br><br>Afternoon visit to Galle Fort, built by the Portuguese, expanded by the Dutch, and later occupied by the British. The 3 km-long fort walls survived the 2004 tsunami with minimal damage. The best way to explore is a peaceful walk along the ramparts.<br><br>Dinner and overnight stay in Galle.` },
                        { day: 'Day 11 – Galle – Airport', meals: 'Breakfast', details: 'Breakfast at the hotel.<br>Transfer to the airport for your flight to Italy.<br>End of services.' },
                    ],
                    includes: [
                        'All hotels mentioned or similar (depending on availability)',
                        'Full-board tour (starts with dinner on Day 1, ends with breakfast on Day 11)',
                        'Air-conditioned vehicle with Italian-speaking guide',
                        'All tours and entrance tickets as per itinerary'
                    ],
                    excludes: ['Tips for driver/guide', 'Drinks and personal expenses'],
                },

                // === PACKAGE 3: 9 DAYS MEDITATION ===
                meditation9: {
                    title: '9 Days / 8 Nights: Meditation Tour',
                    duration: '9 Days',
                    description: 'A peaceful spiritual journey through Sri Lanka’s sacred temples and monasteries, designed for relaxation and mindfulness.',
                    category: 'Spiritual & Wellness',
                    itinerary: [
                        { day: 'Day 1 – Airport – Habarana', hotel: 'Elephant Lake Habarana', meals: 'Dinner', details: `Upon arrival at Colombo Bandaranaike International Airport, meet your Italian-speaking guide who will accompany you throughout your stay.<br>After airport formalities, depart for Habarana and check in at Elephant Lake Habarana.<br>Spend the rest of the day relaxing.<br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 2 – Habarana – Anuradhapura – Habarana', hotel: 'Elephant Lake Habarana', meals: 'Full Board', details: `After breakfast, depart at 8:30 a.m. for a special meditation program near Kaludiya Pokuna, an ancient and peaceful site close to Mihintale.<br>You will also participate in a “Dana” ceremony — an almsgiving to Buddhist monks — and experience a spiritual introduction to traditional Buddhist meditation techniques guided by a local monk.<br>After lunch, visit the ancient city of Anuradhapura, Sri Lanka’s first capital from the 4th century BC. Explore the Sri Maha Bodhi, Ruwanwelisaya Dagoba, Thuparamaya, Abhayagiri Dagoba, and the Twin Ponds (Kuttam Pokuna).<br>Dinner and overnight stay at Elephant Lake Habarana.` },
                        { day: 'Day 3 – Habarana – Sigiriya – Polonnaruwa – Habarana', hotel: 'Elephant Lake Habarana', meals: 'Full Board', details: `In the morning, visit Sigiriya Rock Fortress, a UNESCO World Heritage Site rising 370 meters high.<br>Lunch at Priyamali Gedara, a local restaurant offering authentic Sri Lankan cuisine.<br>In the afternoon, explore Polonnaruwa, the second ancient capital of Sri Lanka, famous for its well-preserved temples and sculptures, including the Royal Palace, Vatadage, and Gal Viharaya with its four magnificent Buddha statues carved from a single granite rock.<br>Return to Habarana for dinner and overnight stay.` },
                        { day: 'Day 4 – Habarana – Dambulla – Kandy', hotel: 'Oak Ray Heritage, Kandy', meals: 'Full Board', details: `After breakfast, visit the Dambulla Cave Temples, home to over 150 Buddha statues and stunning wall paintings.<br>En route to Kandy, stop at a spice garden in Matale for lunch and a short tour.<br>In the afternoon, visit the Temple of the Sacred Tooth Relic (Dalada Maligawa), the most sacred Buddhist site in Sri Lanka.<br>Dinner and overnight stay at Oak Ray Heritage, Kandy.` },
                        { day: 'Day 5 – Kandy – Train Ride – Nuwara Eliya', hotel: 'Galway Heights, Nuwara Eliya', meals: 'Full Board', details: `After breakfast, enjoy one of the most scenic train rides in the world through lush tea hills to Nuwara Eliya, known as “Little England.”<br>Visit a tea factory to see the traditional process of tea making.<br>Lunch at a local restaurant.<br>Dinner and overnight stay at Galway Heights, Nuwara Eliya.` },
                        { day: 'Day 6 – Nuwara Eliya – Ella – Yala', hotel: 'Oak Ray Wild, Yala', meals: 'Full Board', details: `After breakfast, drive to Ella, stopping at the famous Nine Arches Bridge, a marvel of early 20th-century architecture.<br>Visit the Ravana Falls, then continue to Yala.<br>Dinner and overnight stay at Oak Ray Wild, Yala.` },
                        { day: 'Day 7 – Yala – Galle', hotel: 'Tamarind Hill, Galle', meals: 'Full Board', details: `Early morning private safari at Yala National Park, known for its leopards, elephants, and diverse wildlife.<br>Breakfast will be provided as a packed meal from the hotel.<br>After the safari, travel to Galle and visit the Galle Fort, a UNESCO World Heritage Site and colonial masterpiece that survived the 2004 tsunami.<br>Dinner and overnight stay at Tamarind Hill, Galle.` },
                        { day: 'Day 8 – Galle – Colombo – Negombo', hotel: 'Amagi Lagoon', meals: 'Full Board', details: `After breakfast, drive to Colombo for a city tour, visiting Independence Square, BMICH, Town Hall, and Parliament.<br>Lunch in Colombo, then continue to Negombo for an overnight stay at Amagi Lagoon.<br>Dinner included.` },
                        { day: 'Day 9 – Negombo – Airport', meals: 'Breakfast', details: 'After breakfast, transfer to the airport for your departure.<br>End of our services.' },
                    ],
                    includes: [
                        'Accommodation at listed or similar hotels',
                        'Full board (starts with dinner on Day 1 and ends with breakfast on Day 9)',
                        'Air-conditioned vehicle with Italian-speaking guide',
                        'All entrance tickets and guided tours as per itinerary'
                    ],
                    excludes: ['Tips for driver/guide', 'Beverages and extras during meals'],
                },

                // === PACKAGE 4: 9 DAYS CLASSIC ===
                classic9: {
                    title: '9 Days / 8 Nights: Classic Tour',
                    duration: '9 Days',
                    description: 'An extended cultural adventure — explore Kandy, Sigiriya, and Galle while enjoying authentic local traditions and cuisine.',
                    category: 'Culture & Nature',
                    itinerary: [
                        { day: 'Day 1 – Airport – Dambulla', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Dinner', details: `Arrival at Colombo Bandaranaike International Airport on your international flight.<br>After completing entry and baggage formalities, meet your Italian-speaking guide, who will accompany you throughout your stay in Sri Lanka.<br><br>Depart for Dambulla.<br>In the afternoon, enjoy free time to relax.<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 2 – Dambulla – Anuradhapura – Dambulla', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Full Board', details: `In the morning, depart for Anuradhapura, the first capital of Sri Lanka, founded in the 4th century B.C. and lasting until the 10th century A.D.<br><br>Visit the Sri Maha Bodhi, a sacred fig tree grown from a branch of the original Bodhi tree under which Buddha attained enlightenment;<br>the Ruwanwelisaya Dagoba, the great white stupa surrounded by a wall adorned with a frieze of hundreds of elephants;<br>the Thuparamaya, the first stupa built on the island; and the Lankarama.<br><br>Continue to visit the monastic ruins from the 9th century, home to the most beautiful moonstone in all of Sri Lanka, as well as the Abhayagiri Dagoba (about 75 meters high), the Twin Ponds (Kuttam Pokuna) used for ritual bathing, and finally the Jetavanarama Dagoba, which was once the tallest stupa in the world during the 3rd century.<br><br>Lunch at a local restaurant.<br>Afternoon at leisure for relaxation (you may choose an Ayurvedic massage, an elephant safari, or a village tour).<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 3 – Dambulla – Sigiriya – Polonnaruwa – Dambulla', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: 'Full Board', details: `After breakfast, depart for Sigiriya.<br>Visit the magnificent rock fortress, a UNESCO World Heritage Site built in the 5th century and rising about 370 meters high.<br>(The climb takes around two hours, with over a thousand steps!)<br><br>Lunch at Priyamali Gedara, a local restaurant where meals are cooked in a traditional Sri Lankan style.<br><br>In the afternoon, visit Polonnaruwa, another UNESCO site and the second capital of the Sinhalese Kingdom from the 11th to 13th centuries.<br>Explore the Royal Palace of Parakramabahu, the Audience Hall, and the Quadrangle with its Vatadage.<br>Also see Thuparama Gedige, Hatadage, and the stunning Gal Viharaya, consisting of four colossal Buddha statues carved from a single granite rock.<br><br>Return to Dambulla.<br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 4 – Dambulla – Kandy', hotel: 'Oak Ray Heritage', meals: 'Full Board', details: `In the morning, visit the Dambulla Cave Temples, located atop a hill (400 steps; about a 40-minute climb).<br>The caves house over 150 Buddha statues in different poses, along with statues of gods, kings, and historical figures.<br><br>Continue to Kandy, stopping en route at a spice garden in Matale for lunch.<br><br>In the afternoon, visit Kandy, the most sacred city in Sri Lanka and the third ancient capital of the Sinhalese kingdom.<br>Explore the Temple of the Sacred Tooth Relic (Dalada Maligawa), home to the Buddha’s tooth relic.<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 5 – Kandy – Nuwara Eliya', hotel: 'Galway Heights', meals: 'Full Board', details: `After breakfast, depart for Nuwara Eliya, known as “Little England,” famous for its tea plantations and cool climate.<br><br>Lunch at a local restaurant in Ella.<br>After lunch, visit Ravana Falls, then continue to Yala.<br><br>Dinner and overnight stay at the hotel in Yala.` },
                        { day: 'Day 6 – Nuwara Eliya – Yala', hotel: 'Oak Ray Wild Yala', meals: 'Full Board', details: `After breakfast, depart towards Ella.<br>On the way, stop at the Nine Arches Bridge, also known as the “Bridge in the Sky,” a fine example of early 20th-century railway engineering and architecture.<br><br>Lunch at a local restaurant in Ella.<br>Afterward, visit Ravana Falls, then continue the journey to Yala.<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 7 – Yala – Galle', hotel: 'Tamarind Hill Galle', meals: 'Full Board', details: `Early morning departure for a private jeep safari at Yala National Park.<br>Breakfast will be provided as a packed meal from the hotel.<br><br>Yala National Park, located in southeastern Sri Lanka, spans 151,778 hectares, though only Block 1 (14,100 hectares) is open to the public. Its history dates back to 500 B.C.<br><br>After the safari, return to the hotel around 11 a.m., check out, and depart for Galle.<br>Lunch at a local restaurant.<br><br>In the afternoon, visit Galle Fort, a colonial masterpiece originally built by the Portuguese, expanded by the Dutch, and later occupied by the British.<br>The fort’s thick walls—over a meter in some sections—protected it even during the 2004 tsunami, sustaining minimal damage.<br>The best way to appreciate it is with a walk along its ramparts.<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 8 – Galle – Colombo – Negombo', hotel: 'Amagi Lagoon', meals: 'Full Board', details: `After breakfast, depart for Colombo and enjoy a city tour, passing the Bandaranaike Memorial International Conference Hall (BMICH), Independence Square, the new Parliament, and the Town Hall.<br><br>Lunch in Colombo.<br>Then continue to Negombo.<br><br>Dinner and overnight stay at the hotel.` },
                        { day: 'Day 9 – Negombo – Airport', meals: 'Breakfast only', details: 'After breakfast, transfer to Colombo Airport for your international departure.<br>End of our services.' },
                    ],
                    includes: [
                        'All hotels mentioned or similar (subject to availability)',
                        'Full-board tour, starting with dinner on Day 1 and ending with breakfast on the last day',
                        'Air-conditioned vehicle with Italian-speaking guide',
                        'All entrance tickets and guided visits as per itinerary'
                    ],
                    excludes: ['Tips for driver/guide', 'Beverages and extras during meals'],
                },
            },

            // === THINGS TO DO PAGE ===
            thingsToDoPage: { // <-- Rinominato
                pageTitle: 'Things to Do in Sri Lanka',
                sectionTitle: 'Things to Do in Sri Lanka',
                subtitle: 'Adventure, Culture & Wellness',
                heroAlt: 'Things to Do in Sri Lanka',
                viewMore: 'View More',

                ayurveda: {
                    title: 'Ayurveda - Ancient Science of Life',
                    alt: 'Ayurveda Therapy in Sri Lanka',
                },
                diving: {
                    title: 'Diving in Sri Lanka',
                    alt: 'Diving Experience in Sri Lanka',
                },
                elephantRide: {
                    title: 'Elephant Back Ride',
                    alt: 'Elephant Back Ride in Sri Lanka',
                },
                fishing: {
                    title: 'Fishing in Sri Lanka',
                    alt: 'Fishing Activity in Sri Lanka',
                },
                ballooning: {
                    title: 'Ballooning in Sri Lanka',
                    alt: 'Hot Air Ballooning in Sri Lanka',
                },
                jeepSafari: {
                    title: 'Jeep Safari',
                    alt: 'Jeep Safari in Sri Lanka',
                },
                whiteWaterRafting: {
                    title: 'White Water Rafting',
                    alt: 'White Water Rafting in Sri Lanka',
                },
                riverSafari: {
                    title: 'River Safari',
                    alt: 'River Safari in Sri Lanka',
                },
                snorkeling: {
                    title: 'Snorkeling in Sri Lanka',
                    alt: 'Snorkeling Experience in Sri Lanka',
                },
                teaTasting: {
                    title: 'Tea Tasting Tour',
                    alt: 'Tea Tasting Tour in Sri Lanka',
                },
                templeVisit: {
                    title: 'Temple Visit',
                    alt: 'Temple Visit in Sri Lanka',
                },
                wildlifeTour: {
                    title: 'Wildlife Safari',
                    alt: 'Wildlife Safari in Sri Lanka',
                },
            },
        },
    },

    ja: {
        translation: {
            // === ナビゲーション ===
            home: 'ホーム',
            aboutUs: '私たちについて',
            sriLankanav: 'スリランカ',
            gallerynav: 'ギャラリー',
            bookATour: 'ツアーを予約',
            thingsToDo: 'アクティビティ',
            contactUs: 'お問い合わせ',

            // === お問い合わせページ ===
            contactUsTitle: 'お問い合わせ',
            contactUsSubtitle: 'Pick Lanka - スリランカの忘れられない冒険への入り口',
            feelFreeToContact: 'お気軽にお問い合わせください',
            planYourDream: '夢のスリランカ旅行を計画しよう',
            contactDescription: 'Pick Lankaにお問い合わせいただき、カスタマイズされたツアーパッケージ、専門のガイダンス、スリランカ全土での忘れられない旅行体験をお楽しみください。',
            callCenter: 'コールセンター',
            email: 'メール',
            ourLocation: '所在地',
            socialNetwork: 'ソーシャルネットワーク',
            getInTouch: 'お問い合わせ',
            getInTouchDesc: 'Pick Lankaでスリランカを発見しよう — 年中無休24時間、忘れられない旅をお届けします。',
            name: 'お名前',
            emailLabel: 'メールアドレス',
            contactNumber: '電話番号',
            message: 'メッセージ',
            sendMessage: 'メッセージを送信',
            sending: '送信中...',
            successMessage: 'お問い合わせがWhatsAppで送信されました！',
            errorMessage: 'WhatsAppを開けませんでした。もう一度お試しください。',
            findUsInColombo: 'コロンボで私たちを見つける',

            footer: {
                pickLankaTitle: "Pick Lanka Tours",
                getInTouch: "お問い合わせ",
                stayConnected: "つながりましょう",
                address: "164, Jambugasmulla Mawatha, Nugegoda, Sri Lanka.",
                email: "info@picklanka.com",
                phone: "+94 77 080 6767",
                newsletterPlaceholder: "メールアドレスを入力",
                newsletterAria: "ニュースレター用メール",
                sendButton: "送信",
                copyright: "Pick Lanka Tours. All Rights Reserved.",
                developedBy: "デザイン＆開発",
                developer: "Redev Solutions (+94 76 460 8225)",

                links: {
                    home: "ホーム",
                    aboutUs: "私たちについて",
                    sriLanka: "スリランカ",
                    tourPackages: "ツアーパッケージ",
                    gallery: "ギャラリー",
                    events: "イベント",
                    thingsToDo: "アクティビティ",
                    contactUs: "お問い合わせ"
                },

                social: {
                    facebook: "Facebook",
                    instagram: "Instagram",
                    youtube: "YouTube",
                    tiktok: "TikTok"
                }
            },

            // === ワイルドライフサファリページ ===
            wildlifeSafariPage: {
                heroTitle: 'スリランカのワイルドライフサファリ',
                intro: {
                    paragraph1: '豊かな生物多様性で知られるスリランカは、ヤラ、ウィルパットゥ、ミンネリヤ、ウダワラウェなどの国立公園で素晴らしいワイルドライフサファリを提供しています。これらのサファリでは、自然の生息地でゾウ、ヒョウ、ナマケグマ、さまざまな鳥類を目撃することができます。',
                    paragraph2: '密林から開けた草原まで、多様な景観を探索し、野生動物の忘れられない瞬間を捉えましょう。経験豊富なガイドとよく整備されたサファリジープで、スリランカのワイルドライフサファリは自然愛好家や冒険家にとって必見です。'
                },
                highlights: {
                    title: 'ワイルドライフサファリを選ぶ理由',
                    intro: 'スリランカのワイルドライフサファリは、自然とつながり、島の驚くべき生物多様性を探索するユニークな機会を提供します。ハイライトには以下が含まれます：',
                    list: [
                        'ゾウ、ヒョウ、ワニなどの象徴的な種を目撃する。',
                        '野生動物でにぎわう緑豊かな森、湿地、開けた平原を探索する。',
                        '自然環境で美しい野生動物の写真を撮影する。',
                        'スリランカヒョウなどの珍しい動物を見つけるスリルを体験する。',
                        '経験豊富なガイドや自然保護専門家から保全活動について学ぶ。'
                    ]
                },
                images: {
                    main: 'スリランカのワイルドライフサファリ',
                    elephants: 'スリランカの国立公園で自由に歩き回る雄大なゾウを目撃しましょう。',
                    leopard: 'ワイルドライフサファリのハイライト、珍しいスリランカヒョウを発見しましょう。'
                },
                tips: {
                    title: 'エキサイティングなワイルドライフサファリのコツ',
                    list: [
                        '環境に溶け込むために、ニュートラルカラーの服を着用してください。',
                        '日焼け止め、帽子、虫除けを持参して保護してください。',
                        '野生動物を見つけて撮影するために双眼鏡とカメラを持参してください。',
                        '安全で楽しい体験のために、ガイドの指示に従ってください。',
                        '人気のある公園で場所を確保するために、特にピークシーズンは早めに予約してください。'
                    ]
                }
            },

            // === ホワイトウォーターラフティングページ ===
            whiteWaterRaftingPage: {
                heroTitle: 'スリランカのホワイトウォーターラフティング',
                intro: {
                    paragraph1: 'スリランカのホワイトウォーターラフティングは、特に島の冒険の首都であるキトゥルガラで爽快な体験です。ケラニ川は、轟音を上げる急流と風光明媚な周囲で、初心者から経験豊富なラフターまで完璧な環境を提供します。',
                    paragraph2: 'ラフティング遠征は通常、グレード2からグレード4までの急流で5キロメートルのコースをカバーします。参加者は、挑戦的な流れをナビゲートするスリルを楽しみながら、緑豊かな景色と川岸の息をのむような景色を楽しむことができます。'
                },
                highlights: {
                    title: 'スリランカのホワイトウォーターラフティングを選ぶ理由',
                    intro: 'スリランカのホワイトウォーターラフティングは、冒険と自然の美しさのユニークな組み合わせを提供します。体験のハイライトは以下の通りです：',
                    list: [
                        '経験豊富なインストラクターの指導の下、スリリングな急流をナビゲートする。',
                        '周囲の熱帯雨林と山岳地帯の素晴らしい景色を楽しむ。',
                        'キトゥルガラでトレッキング、バードウォッチング、キャニオニングなどの他のアクティビティとラフティングを組み合わせる。',
                        'アドレナリンラッシュを求めるグループ、家族、個人旅行者に最適。'
                    ]
                },
                images: {
                    main: 'スリランカのホワイトウォーターラフティング',
                    action: 'ケラニ川の挑戦的な急流を征服するアドレナリンラッシュを感じてください。',
                    scenic: 'ラフティング冒険中に緑豊かな周囲の穏やかな美しさを楽しんでください。'
                },
                tips: {
                    title: '安全でエキサイティングなラフティング旅行のコツ',
                    list: [
                        '安全のために、ラフティングガイドから提供されるライフジャケットとヘルメットを着用してください。',
                        '旅行を始める前に、安全指示を注意深く聞いてください。',
                        '快適で速乾性のある服と、ウォーターシューズなどの安全な履物を着用してください。',
                        '旅行後のために着替えとタオルを持参してください。',
                        '安全で楽しい体験を保証するために、信頼できる業者とラフティング旅行を予約してください。'
                    ]
                }
            },

            // === 寺院訪問ページ ===
            templeVisitPage: {
                heroTitle: 'スリランカの寺院訪問',
                intro: {
                    paragraph1: 'ブッダの地として知られるスリランカには、豊かな精神的および文化的遺産を反映する古代の寺院があります。キャンディの仏歯寺、ダンブッラ石窟寺院、アヌラーダプラのルワンウェリサーヤなどの象徴的な寺院を探索する旅に出かけましょう。',
                    paragraph2: 'これらの神聖な場所は、複雑な彫刻、壁画、彫像で飾られており、島の精神的伝統と建築の素晴らしさを垣間見ることができます。寺院訪問は文化体験だけでなく、平和と静けさを見つける機会でもあります。'
                },
                highlights: {
                    title: 'スリランカの寺院を訪れる理由',
                    intro: 'スリランカの寺院を訪れることは、島の歴史、文化、精神性とつながるユニークな機会を提供します。ハイライトは以下の通りです：',
                    list: [
                        '複雑な建築と何世紀も前の彫像を鑑賞する。',
                        '知識豊富なガイドから仏教の伝統と儀式について学ぶ。',
                        'ダンブッラの黄金寺院などのユネスコ世界遺産を探索する。',
                        '神聖な空間の静けさと精神的な雰囲気を体験する。',
                        '仏歯寺のエサラペラヘラなどの活気あるお祭りを目撃する。'
                    ]
                },
                images: {
                    main: 'スリランカの寺院訪問',
                    interior: '複雑な彫刻と壁画で飾られた美しい内部を鑑賞しましょう。',
                    sacred: 'ルワンウェリサーヤなどの神聖な寺院を訪れ、精神的な伝統に浸りましょう。'
                },
                tips: {
                    title: 'スリランカの寺院を訪れるためのコツ',
                    list: [
                        '敬意を示すために、肩と膝を覆う控えめな服装をしてください。',
                        '寺院の敷地に入る前に靴を脱いでください。',
                        '彫像や神聖な物に触れないでください。',
                        '貢献したい場合は、寺院への少額の寄付を持参してください。',
                        '訪問中は静けさと精神的な雰囲気を尊重してください。'
                    ]
                }
            },

            // === 紅茶試飲ツアーページ ===
            teaTastingPage: {
                heroTitle: 'スリランカの紅茶試飲ツアー',
                intro: {
                    paragraph1: '「インド洋の真珠」と呼ばれることが多いスリランカは、世界クラスの紅茶生産で有名です。紅茶試飲ツアーに参加して、ヌワラエリヤ、エッラ、キャンディなどの地域の緑豊かな茶園を探索しましょう。紅茶栽培の芸術、細心の紅茶生産プロセスについて学び、本物のセイロンティーの豊かな風味を味わいましょう。',
                    paragraph2: '紅茶愛好家でも、単に興味があるだけでも、紅茶試飲ツアーはスリランカの紅茶遺産に浸り、高地の穏やかな美しさを体験するユニークな機会を提供します。'
                },
                highlights: {
                    title: '紅茶試飲ツアーを選ぶ理由',
                    intro: 'スリランカの紅茶試飲ツアーは、紅茶を味わうだけでなく、没入型の文化体験です。ハイライトは以下の通りです：',
                    list: [
                        '涼しい高地に囲まれた絵のような茶園を訪れる。',
                        'セイロンティーの歴史と重要性について学ぶ。',
                        '茶摘みに参加し、茶工場で生産プロセスを観察する。',
                        '紅茶から緑茶、フレーバーブレンドまで、さまざまな種類の紅茶を味わう。',
                        '霧のかかった山々と流れ落ちる滝の息をのむような景色を楽しむ。'
                    ]
                },
                images: {
                    main: 'スリランカの紅茶試飲ツアー',
                    plantation: '緑豊かな茶園を探索し、紅茶栽培について学びましょう。',
                    preparation: '紅茶の準備の芸術を発見し、本物のセイロンティーを味わいましょう。'
                },
                tips: {
                    title: '楽しい紅茶試飲ツアーのコツ',
                    list: [
                        '茶園を歩くために快適な服と履物を着用してください。',
                        '高地は涼しく霧が多いので、軽いジャケットを持参してください。',
                        'さまざまな種類の紅茶を試して、お気に入りをお土産として持ち帰りましょう。',
                        'ツアー中に質問をして、紅茶製造プロセスについてもっと学びましょう。',
                        '紅茶ツアーと近くの滝や展望台への訪問を組み合わせてください。'
                    ]
                }
            },

            // === シュノーケリングページ ===
            snorkelingPage: {
                heroTitle: 'スリランカのシュノーケリング',
                intro: {
                    paragraph1: 'スリランカのシュノーケリングは、鮮やかなサンゴ礁と多様な海洋生物を探索できる忘れられない水中体験を提供します。透き通った水と豊富な水生生態系で、スリランカはあらゆるスキルレベルのシュノーケラーにとって楽園です。',
                    paragraph2: '最も人気のあるシュノーケリングスポットには、カラフルなサンゴ庭園とカメで知られるヒッカドゥワ、手つかずのサンゴ礁で有名なトリンコマリーのピジョン島、シュノーケリングシーズン中にクジラを見ることができるミリッサなどがあります。'
                },
                highlights: {
                    title: 'スリランカのシュノーケリングを選ぶ理由',
                    intro: 'スリランカのシュノーケリングは、冒険と自然の美しさを組み合わせた魔法のような体験です。ハイライトは以下の通りです：',
                    list: [
                        '生命でにぎわう鮮やかなサンゴ礁を探索する。',
                        'カラフルな熱帯魚、カメ、さらにはリーフシャークと一緒に泳ぐ。',
                        '透明で暖かい水で手つかずの水中景観を発見する。',
                        '初心者から経験豊富なシュノーケラーまで適している。',
                        'スリランカの最高のビーチ目的地からアクセス可能。'
                    ]
                },
                images: {
                    main: 'スリランカのシュノーケリング',
                    coral: '美しいサンゴ礁とその鮮やかな生態系を発見しましょう。',
                    marine: 'カメ、熱帯魚などの多様な海洋生物に出会いましょう。'
                },
                tips: {
                    title: '思い出に残るシュノーケリング体験のコツ',
                    list: [
                        '水中で明瞭な視界を確保するために、快適なマスクとシュノーケルを着用してください。',
                        '肌と海洋生物の両方を保護するために、サンゴ礁に安全な日焼け止めを塗ってください。',
                        'サンゴ礁や水生生物を乱さないように、優しく泳いでください。',
                        '水分補給を心がけ、セッション間に休憩を取ってください。',
                        '最高のシュノーケリングスポットと安全のヒントのために、ガイド付きツアーに参加してください。'
                    ]
                }
            },

            // === リバーサファリページ ===
            riverSafariPage: {
                heroTitle: 'スリランカのリバーサファリ',
                intro: {
                    paragraph1: 'スリランカのリバーサファリは、島の豊かな生物多様性と風光明媚な美しさを探索するユニークな方法を提供します。緑豊かなマングローブに囲まれた静かな水路を滑り、エキゾチックな野生動物を見つけ、あなたを魅了する絵のような夕日を楽しみましょう。',
                    paragraph2: '人気のあるリバーサファリの目的地には、マドゥガンガ（マドゥ川）とベントタ川が含まれます。これらのサファリは、自然の生息地でさまざまな鳥種、オオトカゲ、ワニ、さらにはサルを目撃する機会を提供します。穏やかな環境は、自然愛好家や写真家にとって完璧です。'
                },
                highlights: {
                    title: 'リバーサファリを選ぶ理由',
                    intro: 'リバーサファリは、自然、野生動物、文化探索を組み合わせたリラックスした没入型の体験です。ハイライトは以下の通りです：',
                    list: [
                        '生命でにぎわう緑豊かなマングローブを探索する。',
                        'エキゾチックな鳥、ワニ、その他の野生動物を見つける。',
                        '川沿いの小さな島や地元の村を訪れる。',
                        'スリランカの水路の静けさと絵のような美しさを楽しむ。',
                        '平和な逃避を求める家族、カップル、個人旅行者に最適。'
                    ]
                },
                images: {
                    main: 'スリランカのリバーサファリ',
                    mangroves: 'スリランカの風光明媚な水路沿いに並ぶ緑豊かなマングローブを発見しましょう。',
                    wildlife: 'サファリ中にワニ、オオトカゲ、カラフルな鳥などのエキゾチックな野生動物を見つけましょう。'
                },
                tips: {
                    title: '楽しいリバーサファリのコツ',
                    list: [
                        '保護のために、快適な服を着て、帽子と日焼け止めを持参してください。',
                        '遠くの野生動物や鳥を見つけるために双眼鏡を持参してください。',
                        '美しい景色と野生動物を撮影するためにカメラまたはスマートフォンを持参してください。',
                        '安全で楽しい体験のために、ガイドの指示に従ってください。',
                        'ゴミを捨てたり野生動物を乱したりせず、自然環境を尊重してください。'
                    ]
                }
            },

            // === ジープサファリページ ===
            jeepSafariPage: {
                heroTitle: 'スリランカのジープサファリ',
                intro: {
                    paragraph1: 'スリランカの国立公園は、島の豊かな生物多様性を探索し、自然の生息地で野生動物を目撃できるスリリングなジープサファリ体験を提供します。ヤラ国立公園、ウィルパットゥ国立公園、ウダワラウェ国立公園は、ジープサファリで最も人気のある目的地です。',
                    paragraph2: 'これらのサファリは、ゾウ、ヒョウ、ナマケグマ、水牛、ワニ、さまざまな鳥種を見る機会を提供します。経験豊富な自然保護専門家やトラッカーにガイドされて、ジープサファリは野生動物愛好家や写真家にとって完璧です。'
                },
                highlights: {
                    title: 'ジープサファリを選ぶ理由',
                    intro: 'ジープサファリは、スリランカの多様な野生動物を探索する最良の方法の1つです。ハイライトは以下の通りです：',
                    list: [
                        'ゾウやヒョウなどの象徴的な種との近い出会い。',
                        '国立公園内の遠隔地や風光明媚なエリアへのアクセス。',
                        '自然環境での野生動物写真の機会。',
                        '知識豊富な自然保護専門家や公園レンジャーによるガイダンス。',
                        '興奮と教育を組み合わせた、すべての年齢層に適した冒険。'
                    ]
                },
                images: {
                    main: 'スリランカのジープサファリ',
                    wildlife: 'サファリ中にヒョウ、ゾウ、ワニなどの象徴的な野生動物を目撃しましょう。',
                    landscape: '密林から開けた平原まで、スリランカの国立公園の素晴らしい景観を探索しましょう。'
                },
                tips: {
                    title: '楽しいジープサファリのコツ',
                    list: [
                        '環境に溶け込むために、快適でニュートラルカラーの服を着用してください。',
                        '保護のために、日焼け止め、帽子、虫除けを持参してください。',
                        '体験を向上させ、野生動物を撮影するために、双眼鏡とカメラを持参してください。',
                        '安全と動物への敬意を確保するために、ガイドの指示に従ってください。',
                        '場所を確保するために、特にピークシーズンは早めにサファリを予約してください。'
                    ]
                }
            },

            // === 釣りページ ===
            fishingPage: {
                heroTitle: 'スリランカでの釣り',
                intro: {
                    paragraph1: '広大な海岸線と豊富な淡水湖や川を持つスリランカは、比類のない釣り体験を提供します。プロの釣り人でも趣味の釣り人でも、スリランカには何かがあります。大海での釣り遠征から、地元の漁師が実践する伝統的な高床釣りまで、忘れられない冒険があなたを待っています。',
                    paragraph2: '人気のある釣りの目的地には、ガレとミリッサ周辺の南海岸、ネゴンボラグーン、トリンコマリーの穏やかな水域が含まれます。好みに応じて、トローリング、底釣り、フライフィッシングなどのさまざまな釣り技術を試すことができます。'
                },
                experiences: {
                    title: 'スリランカでの釣り体験',
                    intro: 'スリランカでの釣りは、魚を捕まえるだけではありません。島の文化と伝統に浸る機会です。ユニークな釣り体験には以下が含まれます：',
                    list: [
                        { title: '高床釣り', description: '漁師が海岸近くで魚を捕まえるために高床に腰掛ける伝統的な方法で、スリランカ独特の慣習です。' },
                        { title: '大海釣り', description: 'インド洋に出て、マカジキ、マグロ、バラクーダ、その他の大型魚種を捕まえます。' },
                        { title: 'ラグーンと川釣り', description: 'ティラピアやナマズなどの魚が豊富な穏やかなラグーンや川でリラックスして釣りを楽しみましょう。' },
                        { title: '夜釣り', description: '沿岸の村で一般的な慣習である、星の下での釣りのスリルを体験してください。' }
                    ]
                },
                images: {
                    main: 'スリランカでの釣り',
                    stilt: '高床釣りは伝統的な方法であり、スリランカの漁業遺産の象徴的なイメージです。',
                    deepSea: '大海釣りは、インド洋で大型魚種を狙う冒険的な体験を提供します。'
                },
                tips: {
                    title: '楽しい釣り旅行のコツ',
                    list: [
                        '釣り遠征に適した季節を選んでください。南海岸は10月から4月が理想的で、東海岸は3月から10月が適しています。',
                        '旅行中に快適に過ごすために、日焼け止め、帽子、保護服を持参してください。',
                        '体験を最大限に活用し、専門家から学ぶために、釣りガイドまたはチャーターを予約してください。',
                        'ゴミを捨てず、持続可能な釣り慣行を守ることで、地元の環境を尊重してください。',
                        '長い釣り旅行のために、水分補給を心がけ、スナックを持参してください。'
                    ]
                }
            },

            // === ゾウ乗りページ ===
            elephantRidePage: {
                heroTitle: 'ゾウの背中乗り',
                intro: {
                    paragraph1: 'ゾウトレッキングは、スリランカで魅力的でエキサイティングな活動であり、ユニークな体験です。ハバラナ、シギリヤ、ダンブッラなどの文化三角地帯の近くに滞在している場合、ゾウサファリに参加できます。これらの乗り物は、忘れられない冒険の1時間で約30ドルから始まります。',
                    paragraph2: '乗る前に、ゾウは4〜6人用に設計されたマルチバスケットサドルで鞍を付けられます。これらの優しい巨人は、ジャングルの風光明媚な小道を通り、水で満たされたエリアを渡り、緑豊かな植生の間を移動します。ゾウは通常ゆっくりと歩き、周囲の自然の美しさを完全に味わうことができますが、最大40 km/hの速度に達することができます。'
                },
                highlights: {
                    title: 'ゾウ乗りのハイライト',
                    intro: 'スリランカでのゾウ乗りは、自然とつながり、田園地帯を探索するユニークな方法を提供します。体験のハイライトには以下が含まれます：',
                    list: [
                        'エキゾチックな植生と野生動物でいっぱいの密林を歩く。',
                        '川や水で満たされたエリアを渡り、自然景観の素晴らしい景色を提供する。',
                        'ゾウとスリランカ文化との深いつながりについて学ぶ。',
                        'ゾウがさまざまな地形を優しく運んでくれる間、快適なサドルでリラックスする。'
                    ]
                },
                images: {
                    main: 'ゾウの背中乗り',
                    jungle: 'ゾウに乗って密林と風光明媚な小道を探索しましょう。',
                    water: '川を渡り、水と植生の静かな美しさを楽しみましょう。'
                },
                tips: {
                    title: '安全で楽しいゾウ乗りのコツ',
                    list: [
                        '屋外活動に適した快適な服と履物を着用してください。',
                        '安全で楽しい乗り物のために、ガイドの指示に従ってください。',
                        'ゾウが適切に扱われ、提供者が倫理的な慣行に従っていることを確認してください。',
                        '息をのむような景色と特別な瞬間を撮影するためにカメラを持参してください。',
                        'ゾウを尊重し、ストレスを与えたり傷つけたりする可能性のある行動を避けてください。'
                    ]
                }
            },

            // === ダイビングページ ===
            divingPage: {
                heroTitle: 'スリランカでのダイビング',
                intro: {
                    paragraph1: 'スリランカの海岸を囲む広いサンゴ礁は、深さ2〜40メートルにあります。27°Cから30°Cのインド洋の暖かい水と、15〜35メートルの高い水の透明度は、ダイビングとシュノーケリングに優れた条件を提供します。スリランカでのダイビング中は、手つかずのサンゴ礁、古い難破船、魅惑的な水中洞窟を探索できます。',
                    paragraph2: '島の北東部には、ウミガメ、クマノミ、ミノカサゴ、タツノオトシゴなどの海洋生物の生息地である130種類以上のカラフルなサンゴがあります。水中の岩やサンゴ礁の近くの難破船を訪れて、忘れられない体験をしてください。透明な水に浮かんでいると、セイロンの魅力的な過去に浸ることができます。'
                },
                facilities: {
                    title: '施設と最高のダイビングスポット',
                    paragraph1: '島のダイビングセンターは、有名なメーカーの最新のダイビング機器を備えています。PADIとCMASの資格を持つ認定インストラクターが、安全で楽しいダイビングを保証します。ダイビングセンターは、10月中旬から4月末までサービスを提供する島の南西海岸沿いにあります。ニラウェリとトリンコマリーを含む北東海岸は、3月から10月までダイビングに理想的です。',
                    paragraph2: '西のカルピティヤ近くのサンゴ礁とヒッカドゥワの難破船ダイビングサイトは、ダイバーにとって最も人気のある観光スポットの1つです。'
                },
                images: {
                    main: 'スリランカでのダイビング',
                    coral: '多様な海洋生物の生息地である鮮やかなサンゴ礁を探索しましょう。',
                    shipwreck: 'スリランカの海事の過去を垣間見る歴史的な難破船を発見しましょう。'
                },
                tips: {
                    title: 'ダイバーのためのコツ',
                    list: [
                        '場所に基づいてダイビングに最適な季節を選択してください：南西海岸（10月〜4月）または北東海岸（3月〜10月）。',
                        '安全な体験のために、ダイビングセンターが認定されており、最新の機器を備えていることを確認してください。',
                        '特に初心者の場合は、インストラクターのアドバイスに耳を傾けてください。',
                        'サンゴに触れたり、水中環境を乱したりせず、海洋生物を尊重してください。',
                        'スリランカの水中世界の魅惑的な美しさを撮影するために、防水カメラを持参してください。'
                    ]
                }
            },

            // === 熱気球ページ ===
            ballooningPage: {
                heroTitle: 'スリランカでの熱気球',
                intro: {
                    paragraph1: 'スリランカでの熱気球は、島の素晴らしい景観の上を優しく浮かぶ忘れられない体験を提供します。日の出から始まる気球乗りは、起伏のある丘、緑豊かな森、古代の遺跡、穏やかな村の息をのむような空中景観を提供します。',
                    paragraph2: 'スリランカで最も人気のある熱気球の目的地は、文化三角地帯の中心に位置するダンブッラです。ここでの気球乗りは、象徴的なシギリヤロックフォートレスの上を通過することが多く、他に類を見ない視点を提供します。フライトは通常60〜90分続き、上からスリランカの美しさに浸る十分な時間を提供します。'
                },
                highlights: {
                    title: 'スリランカで熱気球を試す理由',
                    intro: '熱気球は冒険と静けさを組み合わせ、スリランカの美しさをユニークな方法で体験できます。熱気球のハイライトには以下が含まれます：',
                    list: [
                        '島の素晴らしい景観の途切れないパノラマビュー。',
                        'シギリヤロックや近くの湖などの象徴的なランドマークの上を飛ぶ。',
                        '緑豊かな植生と魅力的な村の上を穏やかで平和に乗る。',
                        '空から壮大な日の出を目撃する。',
                        '上から風光明媚な美しさを捉えたい写真愛好家に最適。'
                    ]
                },
                images: {
                    main: 'スリランカでの熱気球',
                    sunrise: '熱気球で優しく浮かびながら、息をのむような日の出の景色を楽しみましょう。',
                    landscape: '起伏のある丘や緑豊かな森を含む、スリランカの素晴らしい景観を上から目撃しましょう。'
                },
                tips: {
                    title: '思い出に残る気球乗りのコツ',
                    list: [
                        '熱気球は天候に依存し、スロットがすぐに埋まるため、早めに乗り物を予約してください。',
                        '快適な服を着て、早朝は涼しくなる可能性があるため、軽いジャケットを持参してください。',
                        '素晴らしい景色を撮影するためにカメラまたはスマートフォンを持参してください。',
                        'パイロットが提供する安全指示を注意深く聞いてください。',
                        '気球の準備と膨張を見るために時間通りに到着してください。これは魅力的なプロセスです。'
                    ]
                }
            },

            // === アーユルヴェーダページ ===
            ayurvedaPage: {
                pageTitle: 'アーユルヴェーダ - 生命の古代科学',
                heroTitle: 'アーユルヴェーダ - 生命の古代科学',
                intro: {
                    paragraph1: '「アーユルヴェーダ」という言葉は、3000年以上前から存在しています。サンスクリット語では、「生命の科学」を意味します。この技術は、通常ヨーロッパの医学が戦う結果ではなく、病気のアーユルヴェーダ治療の見解に基づいています。次の原則を仮定しています：',
                    principlesTitle: '核心原則',
                    principles: [
                        '体は、正常な代謝活動と心臓活動のためにエネルギーを自由にし、バランスを維持する必要があります。',
                        '体は、定期的なホルモン活動とともに正常な筋肉収縮を持つ必要があります。',
                        '体が正常に機能するためには、健康な免疫システムが必要です。'
                    ],
                    paragraph2: '最近のデータによると、スリランカにはアーユルヴェーダで訓練された6,000人以上の卒業生がいます。彼らは7年間の勉強と公立病院での2年間の実習を受けます。アーユルヴェーダプログラムには以下が含まれます：'
                },
                benefits: [
                    'ストレス、疲労、不安の除去',
                    '酸素飽和',
                    '筋肉システムの刺激と毒素の除去',
                    '神経系のバランスの回復',
                    '内臓への血流の回復',
                    'エンドルフィンの生成'
                ],
                treatments: {
                    description: '標準的な治療には、特別なオイルを使用した体とスカルプのマッサージ、ハーブサウナトリートメント、ハーブを注入したバスが含まれます。最も人気のある技術は、「シロダーラ手順」で、温かいハーブオイルを額にリズミカルに滴下します。これは、神経系のバランスを回復し、リラクゼーションを達成するのに役立ちます。'
                },
                tips: {
                    title: 'アーユルヴェーダ治療のコツ',
                    list: [
                        '問題を忘れる。最良の結果を得るために、リラックスして心をクリアにしてください。',
                        '正しい場所を選ぶ。最適な癒しのために、あなたの快適さと好みに合った環境を選択してください。',
                        '正しいプログラムを選択する。医師と懸念事項について話し合い、さまざまな治療法を試して、最も適したものを見つけてください。',
                        '筋肉をリラックスさせ、体を準備するために、治療前に温かいお風呂に入ってください。',
                        '手順の前に軽い食事を食べる。マッサージ中の適切な血流を可能にするために、重い食事を避けてください。',
                        '手順後のリラクゼーションは不可欠です。適切なリラクゼーションは、アーユルヴェーダ治療の効果を高めます。'
                    ]
                },
                images: {
                    main: 'アーユルヴェーダ',
                    face: 'アーユルヴェーダフェイストリートメント',
                    massage: 'アーユルヴェーダマッサージトリートメント'
                }
            },

            hero: {
                title: "Pick Lanka Toursでスリランカを発見",
                subtitle: "本格的な文化の旅、野生動物サファリ、忘れられない島の冒険のための信頼できるパートナー。",
                cta: "ツアーを探索",
                videoFallback: "お使いのブラウザは動画タグをサポートしていません。"
            },

            sections: {
                recommendations: { title: "目的地の推奨", subtitle: "混乱していますか？ここに私たちの推奨があります" },
                excursions: { title: "私たちのエクスカーション", description: "スリランカ全土のカスタマイズされた複数日の旅 — 文化的没入から野生動物の冒険まで。" },
                packages: { title: "私たちのパッケージ" },
                reviews: { title: "ゲストの声", subtitle: "私たちと一緒にスリランカを探索した旅行者の実際の体験" },
                crafting: { title: "Pick Lanka Tours – 完璧な旅を作る", description: "Pick Lanka Toursでスリランカを探索しましょう — すべての旅は、文化、冒険、リラクゼーションを融合させた思い出に残るものとして、注意深く設計されています。" }
            },
            buttons: { viewAll: "すべて見る", bookNow: "今すぐ予約", contactUs: "お問い合わせ" },
            recommendations: {
                sigiriya: { label: "シギリヤ", name: "素晴らしい景色を持つ象徴的なライオンロック要塞。" },
                udawalawa: { label: "ウダワラウェ", name: "野生のゾウサファリで有名。" },
                ella: { label: "エッラ", name: "丘陵地帯の景色と風光明媚な列車の旅。" },
                mirissa: { label: "ミリッサ", name: "ビーチパラダイスとホエールウォッチングスポット。" },
                nuwaraeliya: { label: "ヌワラエリヤ", name: "植民地時代の魅力を持つ涼しい紅茶の国。" },
                kandy: { label: "キャンディ", name: "仏歯寺がある文化の首都。" },
                galle: { label: "ゴール", name: "海のそばの歴史的な要塞都市。" },
                jaffna: { label: "ジャフナ", name: "豊かな歴史を持つ文化のるつぼ。" },
                anuradhapura: { label: "アヌラーダプラ", name: "神聖な遺跡でいっぱいの古代都市。" },
                polonnaruwa: { label: "ポロンナルワ", name: "古代スリランカの王の歴史的遺跡。" }
            },
            excursions: {
                classic7: { title: "7日間 / 6泊 – クラシックツアー", des: "キャンディから南海岸まで、スリランカの必見のハイライトを、完璧にバランスの取れた1週間の旅で発見しましょう。" },
                northern11: { title: "11日間 / 10泊 – ノーザンツアー", des: "ジャフナ、アヌラーダプラ、手つかずの文化的宝物を含む、スリランカの北部の驚異を冒険しましょう。" },
                meditation9: { title: "9日間 / 8泊 – 瞑想ツアー", des: "島全体の穏やかな寺院、瞑想リトリート、自然の逃避を通じて、内なる平和と再接続しましょう。" },
                classic9: { title: "9日間 / 8泊 – クラシックツアー", des: "すべての旅行者のために作られた9日間の島の冒険で、スリランカの多様な景観と豊かな文化を体験しましょう。" }
            },
            packages: {
                classic7: { title: "7日間 / 6泊：クラシックツアー", duration: "7日間", description: "スリランカの象徴的なハイライトを体験 — 古代都市、紅茶の丘、文化的ランドマーク — 初めての旅行者に最適。", category: "文化＆遺産" },
                northern11: { title: "11日間 / 10泊：ノーザンツアー", duration: "11日間", description: "北スリランカの隠れた宝石を発見 — ジャフナ、マンナール、トリンコマリー — 歴史と手つかずの美しさが出会う場所。", category: "冒険＆発見" },
                meditation9: { title: "9日間 / 8泊：瞑想ツアー", duration: "9日間", description: "スリランカの神聖な寺院と修道院を通る平和な精神的な旅、リラクゼーションとマインドフルネスのために設計されています。", category: "精神的＆ウェルネス" },
                classic9: { title: "9日間 / 8泊：クラシックツアー", duration: "9日間", description: "拡張された文化的冒険 — 本格的な地元の伝統と料理を楽しみながら、キャンディ、シギリヤ、ゴールを探索しましょう。", category: "文化＆自然" }
            },
            featured: {
                perahera: {
                    h2: "どうですか",
                    h3: "キャンディエサラペラヘラ",
                    h4: "（仏歯の祭り）",
                    paragraph: `アジア最大の仏教祭りの1つで、キャンディで毎年開催され、ブッダの聖なる歯の遺物を称えます。通りは、鮮やかな衣装で飾られた雄大なゾウ、伝統的な太鼓奏者、火の踊り手、文化的パフォーマーで活気づき、献身と遺産の息をのむような行列を作り出します。<strong class="text-[#009CE6]">Pick Lanka Sri Lankan Tours</strong>でこの壮大な祝賀会を体験してください — 信仰、文化、色が忘れられない旅に集まる場所。`,
                    button: "詳細を見る"
                },
                safari: {
                    h2: "スリランカ",
                    h3: "サファリアドベンチャー",
                    paragraph: `スリランカは、忘れられない野生動物サファリのためのアジアで最高の場所の1つです。<span class="text-[#96BA33] font-semibold">ヤラ</span>と<span class="text-[#96BA33] font-semibold">ウダワラウェ</span>の開けた草原から、<span class="text-[#96BA33] font-semibold">ウィルパットゥ</span>の穏やかな湿地まで、各公園はゾウ、ヒョウ、ワニ、エキゾチックな鳥とのスリリングな出会いを提供します。<strong class="text-[#009CE6]">Pick Lanka Sri Lankan Tours</strong>でエキサイティングな旅に出かけましょう — すべてのサファリが冒険、自然、発見の新しい物語である場所。`,
                    button: "詳細を見る"
                },
            },

            // === ABOUTページ ===
            about: {
                hero: {
                    explore: '探索する',
                    pickLanka: 'PICK LANKA',
                    text1: '古代の王国から緑豊かな茶園、野生のサファリまで、島は驚きに満ちています。スリランカは単なる目的地ではありません — それは心の旅です。',
                    text2: 'スリランカは、黄金のビーチ、霧のかかった山々、終わりのない冒険であなたを歓迎します。ここでは、すべての道が美しさにつながり、すべての瞬間が思い出になります。',
                },
                sectionTitle: 'Pick Lankaについて',
                signatureTour: {
                    title: 'シグネチャースリランカツアー',
                    images: {
                        0: 'コロンボ',
                        1: 'キャンディ',
                        2: 'ヌワラエリヤ',
                        3: 'エッラ',
                        4: 'ヤラ',
                        5: 'ゴール',
                    },
                    labels: {
                        0: { days: '7日間', title: 'クラシックツアー' },
                        1: { days: '10/11日間', title: 'ノーザンツアー' },
                        2: { days: '8/9日間', title: '瞑想ツアー' },
                    },
                    desc1: 'Pick Lanka Sri Lankan Toursで、この素晴らしい島のすべての州を探索しましょう。活気ある都市から霧のかかった丘や黄金のビーチまで — 私たちはどこにでもあなたを連れて行きます。',
                    desc2: '私たちと一緒にスリランカの最高を発見しましょう — キャンディの文化的中心から、コロンボの活気ある通りや息をのむような南海岸まで。',
                    desc3: '冒険、文化、野生動物、リラクゼーションを求めているかどうかにかかわらず、Pick Lanka Sri Lankan Toursは年中島全体で忘れられない旅を提供します。',
                },
                whoWeAre: {
                    title: '私たちは誰ですか？',
                    description: 'Pick Lanka Sri Lankan Toursへようこそ — スリランカのすべての州であなたの信頼できる旅行の仲間。私たちの献身的な地元チームは、単なる観光を超えた旅を作ることに情熱を持っています — 島の豊かな文化、温かいもてなし、忘れられない自然の美しさを発見するのを手伝います。',
                    imageAlt: '私たちは誰ですか',
                    0: { title: '全島ツアー', description: 'Pick Lanka Sri Lankan Toursはすべての州で運営されています — 北から深い南まで、どこでも本格的な地元の体験を提供します。' },
                    1: { title: 'パーソナライズされた体験', description: 'すべてのツアーはあなたの興味に合わせて調整されています — 冒険、文化、自然、リラクゼーションのいずれであっても。' },
                    2: { title: '信頼できる地元の専門知識', description: '私たちの経験豊富な地元ガイドは、スリランカの隠れた宝石、伝統、生活様式についての本当の洞察を共有します。' },
                    3: { title: '24時間年中無休の旅行支援', description: 'Pick Lankaでは、あなたは決して一人ではありません — 私たちのフレンドリーなサポートチームは、旅を通してあなたを助けるために24時間利用可能です。' },
                },
                whatWeOffer: {
                    title: '私たちが提供するもの',
                    0: { title: '文化的没入', description: '本格的な伝統、祭り、地元の生活を体験してください。' },
                    1: { title: 'アドベンチャーツアー', description: 'ハイキング、サファリ、サーフィン、スリリングな屋外活動。' },
                    2: { title: '豪華＆快適', description: 'プレミアムな滞在、プライベート送迎、VIP体験。' },
                    3: { title: 'ウェルネスリトリート', description: '穏やかな環境でのヨガ、アーユルヴェーダ、若返り。' },
                },
                heroSlider: [
                    'シギリヤロック',
                    'ヤラサファリ',
                    '茶園',
                    '黄金のビーチ',
                    '古代の寺院',
                ],
                ourGuides: {
                    title: '私たちのガイド',
                    description: '私たちのプロフェッショナルでライセンスを持つガイドのチームは、すべての旅の心です。フレンドリーで知識が豊富で、スリランカに情熱を持っており、彼らは場所を見せるだけではありません — 彼らは物語、伝統、島を生き生きとさせる隠れた宝石を共有します。',
                    imageAlt: '私たちのガイド',
                },
                tourExpert: {
                    name: '有能でフレンドリー',
                    role: '（ツアーエキスパート）',
                    description: 'ライセンスを持つツアーガイドとして12年以上の経験を持つマリンダクダガマゲは、スリランカの真の美しさを紹介することに情熱を持っています。息をのむようなビーチや緑豊かな丘陵地帯から、スリリングな野生動物サファリや風光明媚な冒険まで、彼の専門知識は、すべての旅行者が島の最高を体験することを保証します — Pick Lankaのやり方で。',
                    imageAlt: 'ツアーエキスパート',
                },
                vehicles: {
                    title: '使用する車両',
                    description: 'Pick Lankaでは、あなたの安全と快適さが最優先です。スリランカのすべての旅がスムーズで楽しいものになるように、信頼性が高く、エアコン付きで、よく整備された車両を提供しています。',
                    bookNow: '今すぐ予約',
                    arrowAlt: '矢印',
                    van: { type: 'バン', description: '家族や小グループ（最大6人の乗客）に最適。広々として快適で、長い旅に最適です。' },
                    minibus: { type: 'ミニバス', description: '大きなグループ（8〜12人の乗客）に最適。快適な座席と十分な収納スペース。' },
                    luxury: { type: 'ラグジュアリー', description: 'VIP旅行のための革製シート、Wi-Fi、運転手サービス付きのプレミアム車両。' },
                    car: { type: '車', description: '個人旅行者やカップルに最適。スリランカを独立して探索するための快適さとスタイル。' },
                },
            },

            // === スリランカページ ===
            sriLanka: {
                heroTitle: 'スリランカを発見',
                heroSubtitle: 'インド洋の真珠',
                heroAlt: 'スリランカ',
                introImageAlt: '主要都市のスリランカ地図',
                intro: [
                    '「エメラルドの島」として知られるスリランカは、素晴らしい景観、古代の遺産、心からのもてなしで称賛されている熱帯の宝石です。',
                    '2千年以上の遺産を持つスリランカには、シギリヤの岩の要塞やアヌラーダプラの神聖な都市などのユネスコ登録サイトがあります。その文化的豊かさは、仏教、ヒンドゥー教、植民地時代の影響を融合させており、その活気あるお祭りと複雑な建築に見られます。',
                    '島の多様な地形は魅力的です — エッラの起伏のある茶園からトリンコマリーのターコイズブルーの水まで。ウィルパットゥなどの国立公園には、ヒョウ、ワニ、珍しい鳥種が生息しており、自然愛好家を喜ばせます。',
                    'スリルシーカーにとって、スリランカはホワイトウォーターラフティング、アルガンベイでのサーフィン、緑豊かなジャングルでのトレッキングを提供します。その料理は、芳香性のスパイス、新鮮な魚、ジャックフルーツで注入されており、伝統と風味の物語を語ります。',
                    '神聖な巡礼から穏やかなビーチの逃避まで、スリランカは美しさと文化に浸った魅惑的な体験を約束します。'
                ],
                placesTitle: 'スリランカの魅力的な場所',
                viewMore: 'もっと見る',
                closeModal: '閉じる',
                fullImageAlt: 'フルプレビュー',
                places: {
                    list: {
                        0: { name: 'シギリヤロックフォートレス', desc: '古代の庭園、フレスコ画、頂上からの息をのむような景色を持つユネスコサイト。' },
                        1: { name: '仏歯寺', desc: 'ブッダの歯の遺物を収容する神聖な仏教サイト。' },
                        2: { name: 'エッラ', desc: 'ナインアーチブリッジで有名な茶園に囲まれた丘の町。' },
                        3: { name: 'ヤラ国立公園', desc: 'ゾウ、ヒョウ、野生動物サファリで有名。' },
                        4: { name: 'ゴールフォート', desc: '石畳の通りとオランダの建築を持つ植民地時代の要塞。' },
                        5: { name: 'ヌワラエリヤ', desc: '涼しい気候と茶園を持つ「リトルイングランド」として知られています。' },
                        6: { name: 'アダムスピーク', desc: 'ユニークな足跡を持つ神聖な山、巡礼地。' },
                        7: { name: 'ホートンプレインズ', desc: '起伏のある丘、滝、世界の終わりの展望台。' },
                        8: { name: 'ベントタビーチ', desc: '黄金の砂とウォータースポーツを持つ手つかずの海岸。' },
                        9: { name: 'ジャフナ', desc: 'タミル文化、歴史、料理が豊富。' },
                        10: { name: 'アヌラーダプラ', desc: '神聖な仏教サイトと遺跡がある古代都市。' },
                        11: { name: 'ポロンナルワ', desc: 'よく保存された寺院と彫像があるユネスコサイト。' },
                        12: { name: 'ウナワトゥナビーチ', desc: 'シュノーケリングとナイトライフのある活気のあるビーチ。' },
                        13: { name: 'コロンボ', desc: '近代的で植民地時代の建築がある賑やかな首都。' },
                        14: { name: 'ウダワラウェ国立公園', desc: '大きなゾウの群れと素晴らしい景観で有名。' },
                        15: { name: 'ダンブッラ石窟寺院', desc: '古代仏教の壁画と彫像があるユネスコサイト。' },
                    },
                },
                famousTitle: 'スリランカで有名なもの',
                famous: {
                    list: {
                        0: { title: 'セイロンティー', desc: 'その風味で世界的に有名、特にヌワラエリヤとウバから。' },
                        1: { title: 'スパイス', desc: 'シナモン、カルダモン、クローブ — スリランカのシナモンは最高です。' },
                        2: { title: '宝石', desc: 'サファイア、ルビー、ムーンストーン — 珍しい宝石の島。' },
                        3: { title: 'アーユルヴェーダ', desc: 'マッサージとハーブ療法によるウェルネストリートメント。' },
                        4: { title: '手工芸品', desc: 'マスク、バティック、木彫り、漆器。' },
                        5: { title: 'ゾウ', desc: '文化的シンボル、壮大な祭りの行列で特集されています。' },
                        6: { title: '伝統的な食べ物', desc: 'ライスアンドカレー、ホッパーズ、コッツロティ、ワッタラッパム。' },
                        7: { title: '祭り', desc: 'エサラペラヘラ、ヴェサク、シンハラ-タミル新年。' },
                        8: { title: 'ココナッツ製品', desc: 'オイル、ミルク、ロープやマット用のコイアファイバー。' },
                        9: { title: 'キャンディアンサリー', desc: '儀式のためのエレガントな伝統的な服装。' },
                        10: { title: '伝統的なダンス', desc: 'キャンディアン、悪魔、低地のダンス。' },
                        11: { title: '高床釣り', desc: '南海岸の象徴的な釣り技術。' },
                        12: { title: 'ムーンストーン', desc: '半貴石、有名なミーティヤゴダ鉱山。' },
                        13: { title: 'クリケット', desc: '国の情熱 — 1996年ワールドカップ優勝者。' },
                        14: { title: 'アーユルヴェーダハーブ', desc: '治療薬のゴトゥコラ、シナモン、ニーム。' },
                        15: { title: 'マスク', desc: '儀式パフォーマンスで使用されるアンバランゴダマスク。' },
                    },
                },
            },

            // === EVENTSページ ===
            events: {
                pageTitle: 'イベント',
                subtitle: '祭りを通してスリランカの精神を祝う — 神聖な仏教の儀式からカラフルな文化的パレードまで、すべてのイベントは島の鼓動を体験する機会です。',
                tabs: {
                    places: '場所',
                    events: 'イベント',
                },
                lightboxAria: 'イベント画像{{number}}を開く',
                labels: {
                    kandyPerahera: 'キャンディエサラペラヘラ（仏歯の祭り）',
                    vesak: 'ヴェサク祭',
                    sinhalaTamilNewYear: 'シンハラとタミルの新年',
                    christmas: 'クリスマス',
                    thaiPongal: 'タイポンガル',
                    deepavali: 'ディーパバリ',
                    holi: 'ホーリー',
                    poson: 'ポソン祭',
                },
            },

            // === GALLERYページ ===
            gallery: {
                pageTitle: 'ギャラリー',
                subtitle: '瞬間を捉え、思い出を大切に — 私たちのギャラリーは、スリランカでのすべての旅を忘れられないものにする冒険、笑顔、息をのむような景色を紹介しています',
                tabs: {
                    places: '場所',
                    events: 'イベント',
                },
                labels: {
                    nuwaraEliya: 'ヌワラエリヤ',
                    sigiriya: 'シギリヤ',
                    anuradhapura: 'アヌラーダプラ',
                    rambodaFalls: 'ランボダ滝',
                    ella: 'エッラ',
                    yala: 'ヤラ',
                    kandy: 'キャンディ',
                    bodhiViharaya: 'ボディビハラヤ',
                    knuckles: 'ナックルズ',
                    udawalawe: 'ウダワラウェ',
                    bentota: 'ベントタボートサファリ',
                    colombo: 'コロンボ',
                    galle: 'ゴール',
                    mirrissa: 'ミリッサ',
                    jaffna: 'ジャフナ',
                    ambuluwawa: 'アンブルワワタワー',
                    turtle: 'カメ農場',
                    polonnaruwa: 'ポロンナルワ',
                    polgampala: 'ポルガンパラウォータープール',
                    beach: 'ビーチ',
                },
            },

            // === TOUR PACKAGESページ ===
            tourPackages: {
                pageTitle: 'ツアーパッケージ',
                subtitle: 'Pick Lanka - スリランカの忘れられない冒険への入り口',
                heroAlt: 'スリランカのツアーパッケージ',
                sectionTitle: '厳選されたパッケージを探索',
                sectionDesc: '文化遺産から野生動物サファリまで、すべての旅行者のためのカスタマイズされた体験を提供します。',
                viewDetails: '詳細を見る',
                hotel: 'ホテル',
                meals: '食事',
                included: '含まれる',
                excluded: '含まれない',
                bookOnWhatsApp: 'WhatsAppでこのツアーを予約',
                whatsappMessage: `こんにちは、Pick Lanka！予約に興味があります：\n\n*{{title}}*\n期間：{{duration}}\n\n詳細と空き状況を送ってもらえますか？`,

                // === パッケージ1：7日間クラシック ===
                classic7: {
                    title: '7日間 / 6泊：クラシックツアー',
                    duration: '7日間',
                    description: 'スリランカの象徴的なハイライトを体験 — 古代都市、紅茶の丘、文化的ランドマーク — 初めての旅行者に最適。',
                    category: '文化＆遺産',
                    itinerary: [
                        { day: '1日目 – 空港 → ハバラナ', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: '夕食', details: 'ホテルで夕食と宿泊。' },
                        { day: '2日目 – ハバラナ → アヌラーダプラ → アウカナ → ハバラナ', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: '全食事付き', details: `朝、紀元前4世紀から紀元10世紀までのシンハラ王国の最初の首都であるアヌラーダプラに出発。<br><br>訪問には、ブッダが悟りを開いた元の菩提樹から派生した神聖なイチジクの木であるスリマハボディと、象の小像で飾られた壁に囲まれた大きな白いストゥーパであるルワンウェリサーヤダゴバが含まれます。<br><br>また、島で最初のダゴバであるツパラマヤとランカラマも訪れます。<br><br>ホテルで夕食と宿泊。` },
                        { day: '3日目 – ハバラナ → シギリヤ → ポロンナルワ → ハバラナ', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: '全食事付き', details: `シギリヤに出発し、スリランカで最も美しいムーンストーンと印象的なアバヤギリダゴバ（約75メートル）を保存する9世紀の修道院複合体の遺跡を訪れます。<br><br>儀式用の入浴に使用されるツインポンド（クッタムポクナ）と、建設時に世界で最も高かったジェタワナラマダゴバを続けます。<br><br>地元のレストラン（プリヤマリゲダラ）で昼食 — 食事は伝統的な方法で準備されています。<br><br>午後：5世紀に建てられたユネスコ世界遺産のシギリヤロックフォートレス（約370メートルの高さ）を訪れます（登山には約2時間かかり、1,000段以上の階段があります）。<br><br>その後、11〜13世紀のシンハラ王国の第二の古都であるポロンナルワに進みます。ここの寺院と彫刻は国内で最もよく保存されています。<br><br>ダンブッラのホテルに戻ります。夕食と宿泊。` },
                        { day: '4日目 – ハバラナ → ダンブッラ → キャンディ', hotel: 'Oak Ray Heritage', meals: '全食事付き', details: `朝、丘の上にある美しいダンブッラ石窟寺院を訪れます（400段、約40分の登山）。さまざまなポーズのブッダの彫像150以上、神々、王、歴史的人物の彫像があります。<br><br>マタレのスパイスプランテーションに立ち寄りながら、キャンディに向かいます。<br>スパイスガーデンレストランで昼食。<br><br>午後：シンハラ王国の第三の首都であり、スリランカで最も神聖な都市であるキャンディを訪れます。仏歯寺（ダラダマリガワ）を訪れます。<br><br>ホテルで夕食と宿泊。` },
                        { day: '5日目 – キャンディ → ヌワラエリヤ', hotel: 'Galway Heights', meals: '全食事付き', details: `朝食後、ヌワラエリヤに出発。<br>これはスリランカで最も風光明媚なルートの1つで、山の景観の息をのむような景色を独自の視点から見ることができます。<br><br>地元のレストランで昼食。<br>午後：茶生産を観察するために茶工場を訪れます。<br><br>ヌワラエリヤで夕食と宿泊。` },
                        { day: '6日目 – ヌワラエリヤ → キトゥルガラ → コロンボ → ネゴンボ', hotel: 'Fairway Colombo', meals: '全食事付き', details: `朝食後、キトゥルガラに立ち寄って美しい川の景色を見ながらコロンボに出発。<br><br>コロンボに到着したら、以下を含む市内ツアーをお楽しみください：<br><ul class="list-disc pl-6 mt-2"><li>バンダラナイケ記念国際会議場（BMICH）</li><li>独立記念広場</li><li>新議会</li><li>コロンボ市庁舎</li><li>その他の歴史的建物</li></ul><br>コロンボで昼食、その後ネゴンボに向かいます。<br>ホテルで夕食と宿泊。` },
                        { day: '7日目 – コロンボ → 空港', meals: '朝食', details: 'ホテルで朝食。<br>出発のために空港に送迎。サービス終了。' },
                    ],
                    includes: [
                        '記載されているすべてのホテルまたは同様のもの（空室状況による）',
                        '初日の夕食から最終日の朝食まで、全食事付きツアー',
                        'イタリア語を話すガイド付きエアコン付き車両',
                        '旅程に従ったすべての観光とガイド付き市内ツアー',
                        'すべての入場チケット'
                    ],
                    excludes: ['運転手へのチップ', '飲み物と追加の食事'],
                },

                // === パッケージ2：11日間北部 ===
                northern11: {
                    title: '11日間 / 10泊：ノーザンツアー',
                    duration: '11日間',
                    description: '北スリランカの隠れた宝石を発見 — ジャフナ、マンナール、トリンコマリー — 歴史と手つかずの美しさが出会う場所。',
                    category: '冒険＆発見',
                    itinerary: [
                        { day: '1日目 – 空港 – チラウ', hotel: 'Anantaya Resort & Spa', meals: '夕食', details: `国際便でコロンボ空港（バンダラナイケ国際空港）に到着。入国と荷物の手続きを完了した後、スリランカ滞在中ずっとあなたに同行するイタリア語を話すガイドと会います。<br><br>チラウに出発。<br>注：フライトが午前または午後に到着する場合は、ホテルへの送迎（約3時間）。予約された部屋にチェックイン（午後2時から利用可能）。残りの日はリラックスして自由に過ごしてください。<br><br>ホテルで夕食。` },
                        { day: '2日目 – チラウ – ジャフナ', hotel: 'Jetwing Hotel Jaffna / Hotel Fox', meals: '全食事付き', details: `朝、ジャフナに出発。<br>ジャフナの歴史は豊かで複雑です。<br><br>午後、何世紀にもわたってスリランカのタミルヒンドゥーコミュニティの宗教的および文化的中心地であった都市を訪れます。後にポルトガル人、次にオランダ人、最後にイギリス人によって征服されました。ジャフナ地域は、2009年に終わった国の悲劇的な内戦の主な舞台の1つでもありました。<br><br>地元のレストランで昼食。<br><br>午後、スリランカのタミル文化と歴史の重要なシンボルであるジャフナ公共図書館を訪れます。その後、ジャフナフォートを訪れます。これは国内で最も重要で歴史的な要塞の1つで、その物語はスリランカの植民地時代の過去と最近の内戦と深く絡み合っています。<br><br>ホテルで夕食と宿泊。` },
                        { day: '3日目 – ジャフナ', hotel: 'Jetwing Hotel Jaffna / Hotel Fox', meals: '全食事付き', details: `朝、ナルールカンダサミーコビル（ガネーシャの兄弟であるムルガンに捧げられた）を訪れます — スリランカで最も重要なヒンドゥー寺院の1つ。<br><br>その後、サンギリトップ（王宮の入口アーチ）、マントリマンナイ（大臣の住居）、ジャフナ半島の神秘的な自然のアトラクションであるニラワライボトムレスウェルを訪れます。<br><br>その後、チュンナカムマーケット（古いオランダのマーケットビル）、カドゥルゴダビハラヤ遺跡、キーリマライスプリングスを訪れます。<br><br>地元のレストランで昼食。<br><br>文字通り「マングースの巣」であるキーリマライを訪れ、その後、巨大なハヌマーン像があるマルタナマダムアンジャネヤールコビルを訪れます。<br>ホテルに戻ります。<br>夕食と宿泊。` },
                        { day: '4日目 – ジャフナ – アヌラーダプラ', hotel: 'The Lake Forest Hotel', meals: '全食事付き', details: `早朝、紀元前4世紀から紀元10世紀までの最初のシンハラ首都であるアヌラーダプラに出発。<br>訪問には、スリマハボディ（ブッダが悟りを開いた元の菩提樹から派生した神聖なイチジクの木）、ルワンウェリサーヤダゴバ、ツパラマヤ、ランカラマが含まれます。<br><br>アヌラーダプラで夕食と宿泊。` },
                        { day: '5日目 – アヌラーダプラ – ミヒンタレ – アウカナ – ダンブッラ', hotel: 'Amaya Lake / Habarana Village by Cinnamon', meals: '全食事付き', details: `朝食後、スリランカで最も神聖な仏教サイトの1つであるミヒンタレを訪れます。仏教が島全体に広がった場所と信じられています。登山は急です（ほぼ2,000段）が、美しい景色で報われます。古代の病院の遺跡、修道院、食堂、カンタカセティヤストゥーパを訪れます。<br><br>アバヤギリダゴバ、クッタムポクナ（ツインポンド）、ジェタワナラマダゴバ（かつて世界で最も高いストゥーパ）に続きます。<br><br>その後、アウカナブッダ像（14メートルの高さ、紀元5世紀）を訪れます。<br><br>残りの日はリラックスして自由に過ごしてください（アーユルヴェーダマッサージ、ゾウサファリ、村ツアーをお楽しみいただけます）。<br>ホテルで夕食。` },
                        { day: '6日目 – ダンブッラ – シギリヤ – ポロンナルワ – ダンブッラ', hotel: 'Amaya Lake / Habarana Village by Cinnamon', meals: '全食事付き', details: `朝、シギリヤに出発。5世紀に建てられたユネスコ世界遺産の有名なシギリヤロックフォートレス（約370メートルの高さ）を訪れます（登山には約2時間かかります — 1,000段以上の階段！）。<br><br>伝統的なスリランカ料理を提供する地元のレストラン、プリヤマリゲダラで昼食。<br><br>午後、もう1つのユネスコ世界遺産であり、11〜13世紀のシンハラ王国の第二の首都であるポロンナルワを訪れます。パラクラマバフ宮殿、ワタダゲ、ハタダゲ、そして1つの巨大な花崗岩の岩から彫られた4つのブッダ像を特徴とする素晴らしいガルビハラヤを訪れます。<br><br>ダンブッラに戻ります。<br>ホテルで夕食。` },
                        { day: '7日目 – ダンブッラ – キャンディ', hotel: 'Amaya Hills / Cinnamon Citadel', meals: '全食事付き', details: `朝、丘の上にあるダンブッラ石窟寺院を訪れます（約400段、40分の登山）。複合体には、ブッダの彫像150以上、神々、歴史的人物があります。<br><br>マタレのスパイスガーデンに立ち寄りながら、キャンディに向かいます。<br><br>午後、キャンディ市と仏歯寺（ダラダマリガワ）を訪れます。<br><br>キャンディで夕食と宿泊。` },
                        { day: '8日目 – キャンディ – ヌワラエリヤ', hotel: 'Jetwing St. Andrews / Galway Heights', meals: '全食事付き', details: `朝食後、列車でヌワラエリヤに旅行 — スリランカで最も風光明媚なルートの1つで、山の景観を紹介しています。<br><br>到着後（海抜1,889メートル）、ホテルに送迎。<br>地元のレストランで昼食。<br>ホテルで夕食と宿泊。` },
                        { day: '9日目 – ヌワラエリヤ – エッラ – ヤラ', hotel: 'Jetwing Yala', meals: '全食事付き', details: `朝食後、エッラに出発。<br>エッラの地元のレストランで昼食。<br><br>午後、ラバナ滝、ナインアーチブリッジ、茶工場を訪れます。<br>その後、ヤラに向かいます。<br>ホテルで夕食と宿泊。` },
                        { day: '10日目 – ヤラ – ゴール', hotel: 'The Heritage Fort / Tamarind Hills', meals: '全食事付き', details: `早朝、ヤラ国立公園でプライベートゲームドライブ（ホテルから朝食ボックスが提供されます）。<br><br>スリランカの南東部の乾燥地帯に位置するヤラは、151,778ヘクタールをカバーしており、ブロックI（14,100 ha）が一般に公開されています。公園は紀元前5世紀にさかのぼり、特にヒョウとゾウで有名です。<br><br>サファリの後、午前11時頃にホテルに戻り、チェックアウトし、ゴールに向かいます。<br><br>地元のレストランで昼食。<br><br>午後、ポルトガル人によって建てられ、オランダ人によって拡張され、後にイギリス人によって占領されたゴールフォートを訪れます。3 kmの長い要塞の壁は、2004年の津波でもほとんど損傷を受けませんでした。それを鑑賞する最良の方法は、城壁に沿った平和な散歩です。<br><br>ゴールで夕食と宿泊。` },
                        { day: '11日目 – ゴール – 空港', meals: '朝食', details: 'ホテルで朝食。<br>イタリアへのフライトのために空港に送迎。<br>サービス終了。' },
                    ],
                    includes: [
                        '記載されているすべてのホテルまたは同様のもの（空室状況による）',
                        '全食事付きツアー（1日目の夕食から始まり、11日目の朝食で終わります）',
                        'イタリア語を話すガイド付きエアコン付き車両',
                        '旅程に従ったすべてのツアーと入場チケット'
                    ],
                    excludes: ['運転手/ガイドへのチップ', '飲み物と個人的な費用'],
                },

                // === パッケージ3：9日間瞑想 ===
                meditation9: {
                    title: '9日間 / 8泊：瞑想ツアー',
                    duration: '9日間',
                    description: 'スリランカの神聖な寺院と修道院を通る平和な精神的な旅、リラクゼーションとマインドフルネスのために設計されています。',
                    category: '精神的＆ウェルネス',
                    itinerary: [
                        { day: '1日目 – 空港 – ハバラナ', hotel: 'Elephant Lake Habarana', meals: '夕食', details: `コロンボバンダラナイケ国際空港に到着したら、滞在中ずっとあなたに同行するイタリア語を話すガイドと会います。<br>空港の手続き後、ハバラナに出発し、エレファントレイクハバラナにチェックイン。<br>残りの日はリラックスして過ごします。<br>ホテルで夕食と宿泊。` },
                        { day: '2日目 – ハバラナ – アヌラーダプラ – ハバラナ', hotel: 'Elephant Lake Habarana', meals: '全食事付き', details: `朝食後、午前8時30分にミヒンタレ近くの古代で平和な場所であるカルディヤポクナ近くで特別な瞑想プログラムに出発。<br>また、仏教の僧侶への施しである「ダナ」儀式に参加し、地元の僧侶によって導かれた伝統的な仏教瞑想技術への精神的な紹介を体験します。<br>昼食後、スリランカの紀元前4世紀からの最初の首都である古代都市アヌラーダプラを訪れます。スリマハボディ、ルワンウェリサーヤダゴバ、ツパラマヤ、アバヤギリダゴバ、ツインポンド（クッタムポクナ）を探索します。<br>エレファントレイクハバラナで夕食と宿泊。` },
                        { day: '3日目 – ハバラナ – シギリヤ – ポロンナルワ – ハバラナ', hotel: 'Elephant Lake Haバラナ', meals: '全食事付き', details: `朝、370メートルの高さに上昇するユネスコ世界遺産のシギリヤロックフォートレスを訪れます。<br>本格的なスリランカ料理を提供する地元のレストラン、プリヤマリゲダラで昼食。<br>午後、よく保存された寺院と彫刻で有名なスリランカの第二の古都であるポロンナルワを探索します。王宮、ワタダゲ、そして1つの花崗岩の岩から彫られた4つの壮大なブッダ像を持つガルビハラヤを含みます。<br>ハバラナに戻って夕食と宿泊。` },
                        { day: '4日目 – ハバラナ – ダンブッラ – キャンディ', hotel: 'Oak Ray Heritage, Kandy', meals: '全食事付き', details: `朝食後、ブッダの彫像150以上と素晴らしい壁画があるダンブッラ石窟寺院を訪れます。<br>キャンディに向かう途中、マタレのスパイスガーデンに立ち寄って昼食と短いツアー。<br>午後、スリランカで最も神聖な仏教サイトである仏歯寺（ダラダマリガワ）を訪れます。<br>オークレイヘリテージ、キャンディで夕食と宿泊。` },
                        { day: '5日目 – キャンディ – 列車乗車 – ヌワラエリヤ', hotel: 'Galway Heights, Nuwara Eliya', meals: '全食事付き', details: `朝食後、「リトルイングランド」として知られるヌワラエリヤへの緑豊かな茶の丘を通る世界で最も風光明媚な列車の旅の1つを楽しみます。<br>伝統的な茶の製造プロセスを見るために茶工場を訪れます。<br>地元のレストランで昼食。<br>ギャルウェイハイツ、ヌワラエリヤで夕食と宿泊。` },
                        { day: '6日目 – ヌワラエリヤ – エッラ – ヤラ', hotel: 'Oak Ray Wild, Yala', meals: '全食事付き', details: `朝食後、エッラに向かい、20世紀初頭の建築の驚異である有名なナインアーチブリッジに立ち寄ります。<br>ラバナ滝を訪れ、その後ヤラに向かいます。<br>オークレイワイルド、ヤラで夕食と宿泊。` },
                        { day: '7日目 – ヤラ – ゴール', hotel: 'Tamarind Hill, Galle', meals: '全食事付き', details: `早朝、ヒョウ、ゾウ、多様な野生動物で知られるヤラ国立公園でプライベートサファリ。<br>朝食はホテルからパック食として提供されます。<br>サファリ後、ゴールに移動し、2004年の津波を生き延びたユネスコ世界遺産であり植民地時代の傑作であるゴールフォートを訪れます。<br>タマリンドヒル、ゴールで夕食と宿泊。` },
                        { day: '8日目 – ゴール – コロンボ – ネゴンボ', hotel: 'Amagi Lagoon', meals: '全食事付き', details: `朝食後、コロンボに向かって市内ツアーを行い、独立広場、BMICH、市庁舎、議会を訪れます。<br>コロンボで昼食、その後ネゴンボに向かい、アマギラグーンに宿泊。<br>夕食含む。` },
                        { day: '9日目 – ネゴンボ – 空港', meals: '朝食', details: '朝食後、出発のために空港に送迎。<br>私たちのサービスの終了。' },
                    ],
                    includes: [
                        'リストされたホテルまたは同様のホテルでの宿泊',
                        '全食事付き（1日目の夕食から始まり、9日目の朝食で終わります）',
                        'イタリア語を話すガイド付きエアコン付き車両',
                        '旅程に従ったすべての入場チケットとガイド付きツアー'
                    ],
                    excludes: ['運転手/ガイドへのチップ', '食事中の飲み物とエキストラ'],
                },

                // === パッケージ4：9日間クラシック ===
                classic9: {
                    title: '9日間 / 8泊：クラシックツアー',
                    duration: '9日間',
                    description: '拡張された文化的冒険 — 本格的な地元の伝統と料理を楽しみながら、キャンディ、シギリヤ、ゴールを探索しましょう。',
                    category: '文化＆自然',
                    itinerary: [
                        { day: '1日目 – 空港 – ダンブッラ', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: '夕食', details: `国際便でコロンボバンダラナイケ国際空港に到着。<br>入国と荷物の手続きを完了した後、スリランカ滞在中ずっとあなたに同行するイタリア語を話すガイドと会います。<br><br>ダンブッラに出発。<br>午後、リラックスして自由な時間を楽しみます。<br><br>ホテルで夕食と宿泊。` },
                        { day: '2日目 – ダンブッラ – アヌラーダプラ – ダンブッラ', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: '全食事付き', details: `朝、紀元前4世紀に設立され、紀元10世紀まで続いたスリランカの最初の首都であるアヌラーダプラに出発。<br><br>スリマハボディ、ブッダが悟りを開いた元の菩提樹から育った枝から育った神聖なイチジクの木を訪れます；<br>ルワンウェリサーヤダゴバ、数百頭の象の小像で飾られた壁に囲まれた大きな白いストゥーパ；<br>ツパラマヤ、島に建てられた最初のストゥーパ；そしてランカラマ。<br><br>9世紀の修道院遺跡を訪れ続け、スリランカで最も美しいムーンストーンとアバヤギリダゴバ（約75メートルの高さ）、儀式用の入浴に使用されたツインポンド（クッタムポクナ）、そして最後にジェタワナラマダゴバ、3世紀に世界で最も高かったストゥーパ。<br><br>地元のレストランで昼食。<br>午後はリラックスして自由に過ごします（アーユルヴェーダマッサージ、ゾウサファリ、村ツアーを選択できます）。<br><br>ホテルで夕食と宿泊。` },
                        { day: '3日目 – ダンブッラ – シギリヤ – ポロンナルワ – ダンブッラ', hotel: 'Oak Ray Elephant Lake / Fresco Water Villa', meals: '全食事付き', details: `朝食後、シギリヤに出発。<br>5世紀に建てられ、約370メートルの高さに上昇するユネスコ世界遺産の壮大な岩の要塞を訪れます。<br>（登山には約2時間かかり、千段以上の階段があります！）<br><br>伝統的なスリランカ料理で調理される地元のレストラン、プリヤマリゲダラで昼食。<br><br>午後、もう1つのユネスコサイトであり、11〜13世紀のシンハラ王国の第二の首都であるポロンナルワを訪れます。<br>パラクラマバフの王宮、聴衆ホール、ワタダゲを持つクアドラングルを探索します。<br>また、ツパラマゲディゲ、ハタダゲ、そして1つの花崗岩の岩から彫られた4つの巨大なブッダ像からなる素晴らしいガルビハラヤも見ることができます。<br><br>ダンブッラに戻ります。<br>ホテルで夕食と宿泊。` },
                        { day: '4日目 – ダンブッラ – キャンディ', hotel: 'Oak Ray Heritage', meals: '全食事付き', details: `朝、丘の上にあるダンブッラ石窟寺院を訪れます（400段；約40分の登山）。<br>洞窟には、さまざまなポーズのブッダの彫像150以上、神々、王、歴史的人物の彫像があります。<br><br>マタレのスパイスガーデンに立ち寄って昼食をとりながら、キャンディに向かいます。<br><br>午後、シンハラ王国の第三の古都であり、スリランカで最も神聖な都市であるキャンディを訪れます。<br>ブッダの歯の遺物を収容する仏歯寺（ダラダマリガワ）を探索します。<br><br>ホテルで夕食と宿泊。` },
                        { day: '5日目 – キャンディ – ヌワラエリヤ', hotel: 'Galway Heights', meals: '全食事付き', details: `朝食後、その茶園と涼しい気候で有名な「リトルイングランド」として知られるヌワラエリヤに出発。<br><br>エッラの地元のレストランで昼食。<br>昼食後、ラバナ滝を訪れ、その後ヤラに向かいます。<br><br>ヤラのホテルで夕食と宿泊。` },
                        { day: '6日目 – ヌワラエリヤ – ヤラ', hotel: 'Oak Ray Wild Yala', meals: '全食事付き', details: `朝食後、エッラに向けて出発。<br>途中、「空の橋」としても知られるナインアーチブリッジに立ち寄ります。これは20世紀初頭の鉄道工学と建築の優れた例です。<br><br>エッラの地元のレストランで昼食。<br>その後、ラバナ滝を訪れ、その後ヤラへの旅を続けます。<br><br>ホテルで夕食と宿泊。` },
                        { day: '7日目 – ヤラ – ゴール', hotel: 'Tamarind Hill Galle', meals: '全食事付き', details: `早朝、ヤラ国立公園でプライベートジープサファリに出発。<br>朝食はホテルからパック食として提供されます。<br><br>スリランカの南東部に位置するヤラ国立公園は、151,778ヘクタールをカバーしていますが、ブロック1（14,100ヘクタール）のみが一般に公開されています。その歴史は紀元前500年にさかのぼります。<br><br>サファリ後、午前11時頃にホテルに戻り、チェックアウトし、ゴールに出発。<br>地元のレストランで昼食。<br><br>午後、ポルトガル人によって元々建てられ、オランダ人によって拡張され、後にイギリス人によって占領された植民地時代の傑作であるゴールフォートを訪れます。<br>要塞の厚い壁 — いくつかのセクションで1メートル以上 — は、2004年の津波の間でもそれを保護し、最小限の損傷を維持しました。<br>それを鑑賞する最良の方法は、城壁に沿った散歩です。<br><br>ホテルで夕食と宿泊。` },
                        { day: '8日目 – ゴール – コロンボ – ネゴンボ', hotel: 'Amagi Lagoon', meals: '全食事付き', details: `朝食後、コロンボに出発し、バンダラナイケ記念国際会議場（BMICH）、独立広場、新議会、市庁舎を通過する市内ツアーをお楽しみください。<br><br>コロンボで昼食。<br>その後、ネゴンボに向かいます。<br><br>ホテルで夕食と宿泊。` },
                        { day: '9日目 – ネゴンボ – 空港', meals: '朝食のみ', details: '朝食後、国際出発のためにコロンボ空港に送迎。<br>私たちのサービスの終了。' },
                    ],
                    includes: [
                        '記載されているすべてのホテルまたは同様のもの（空室状況による）',
                        '全食事付きツアー、1日目の夕食から始まり、最終日の朝食で終わります',
                        'イタリア語を話すガイド付きエアコン付き車両',
                        '旅程に従ったすべての入場チケットとガイド付き訪問'
                    ],
                    excludes: ['運転手/ガイドへのチップ', '食事中の飲み物とエキストラ'],
                },
            },

            // === アクティビティページ ===
            thingsToDoPage: {
                pageTitle: 'スリランカでのアクティビティ',
                sectionTitle: 'スリランカでのアクティビティ',
                subtitle: '冒険、文化、ウェルネス',
                heroAlt: 'スリランカでのアクティビティ',
                viewMore: 'もっと見る',

                ayurveda: {
                    title: 'アーユルヴェーダ - 生命の古代科学',
                    alt: 'スリランカのアーユルヴェーダ療法',
                },
                diving: {
                    title: 'スリランカでのダイビング',
                    alt: 'スリランカでのダイビング体験',
                },
                elephantRide: {
                    title: 'ゾウの背中乗り',
                    alt: 'スリランカでのゾウの背中乗り',
                },
                fishing: {
                    title: 'スリランカでの釣り',
                    alt: 'スリランカでの釣り活動',
                },
                ballooning: {
                    title: 'スリランカでの熱気球',
                    alt: 'スリランカでの熱気球',
                },
                jeepSafari: {
                    title: 'ジープサファリ',
                    alt: 'スリランカでのジープサファリ',
                },
                whiteWaterRafting: {
                    title: 'ホワイトウォーターラフティング',
                    alt: 'スリランカでのホワイトウォーターラフティング',
                },
                riverSafari: {
                    title: 'リバーサファリ',
                    alt: 'スリランカでのリバーサファリ',
                },
                snorkeling: {
                    title: 'スリランカでのシュノーケリング',
                    alt: 'スリランカでのシュノーケリング体験',
                },
                teaTasting: {
                    title: '紅茶試飲ツアー',
                    alt: 'スリランカでの紅茶試飲ツアー',
                },
                templeVisit: {
                    title: '寺院訪問',
                    alt: 'スリランカでの寺院訪問',
                },
                wildlifeTour: {
                    title: 'ワイルドライフサファリ',
                    alt: 'スリランカでのワイルドライフサファリ',
                },
            },
        },
    },
};

// Detect if user is on /au or /jp routes to set initial language
const pathName = typeof window !== 'undefined' ? window.location.pathname : '';
let initialLng = 'it'; // Default to Italian

if (pathName.includes('/au')) {
    initialLng = 'en'; // English for AU routes
} else if (pathName.includes('/jp')) {
    initialLng = 'ja'; // Japanese for JP routes
}

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: initialLng,
        fallbackLng: initialLng,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;